/* ─── Block 0 (was line ~54) ─── */

/* Lazy-load heavy configurator scripts on demand */
function efLoadScript(url, flag) {
  if (window[flag]) return;
  var s = document.createElement('script');
  s.src = url;
  document.head.appendChild(s);
  window[flag] = true;
}
if (!window.EF_CFG_DATA) {
  console.error('[EF-CFG] EF_CFG_DATA failed to load!');
} else {
  console.log('[EF-CFG] Data loaded:', Object.keys(window.EF_CFG_DATA).length, 'groups');
}


/* ─── Block 1 (was line ~964) ─── */

(function() {
  'use strict';

  /* ────────────────────────────────────
     CONSTANTS & CONFIG
     ──────────────────────────────────── */
  var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  /* EF_STOLL_1TO1_20260829 — "+$135 per 2″ height increase over dimensions on sizing chart"
     (every Stoll door order form). One shared hidden variant, added with quantity = steps. */
  var STOLL_HEIGHT_STEP_PRICE = 135;
  var STOLL_HEIGHT_STEP_VARIANT = '42659520446546';

  var CAT_LABELS = {
    /* Stoll pricebook categories (page 79) — used by all Stoll groups */
    powdercoat:       'Powder Coat',
    premium:          'Premium',
    plated_stainless: 'Stainless',
    plated:           'Plated',
    overlay:          'Overlay',
    /* Legacy categories — kept for non-Stoll groups (Avalon, Legend, Carolina, etc.).
       2026-05-06 — `boutique` category removed per user request. Oil Rubbed Bronze
       (the only boutique finish) moved into `handcrafted` via data-file rewrites. */
    powder_coat:      'Powder Coat',
    standard:         'Powder Coat',
    stainless:        'Plated & Stainless',
    handcrafted:      'Hand Crafted'
  };

  /* 2026-06-01 — Normalize finish categories. The deprecated `boutique` category
     (its lone finish, Oil Rubbed Bronze, belongs under Hand Crafted) still lingers
     in some group data (e.g. DS Custom screens), producing a stray 4th "BOUTIQUE"
     tab. Fold it into `handcrafted` at read-time so it merges into that tab. */
  function normCat(c) {
    c = c || 'powder_coat';
    if (c === 'boutique') return 'handcrafted';
    return c;
  }

  var SKIP_WORDS = ['all', 'mid', 'old', 'new', 'hand', 'arch', 'the', 'and', 'for'];

  /* Step definitions by cfg type */
  var STEP_DEFS = {
    'cfg-custom':         ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review'],
    'cfg-custom-full':    ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review'],
    'cfg-custom-premium': ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review'],
    'cfg-standard':       ['Order'],  /* single page — variant + optional photo/notes + ATC */
    'cfg-simple':         ['Order'],  /* single page — W/H ranges + optional photo/notes + ATC */
    'cfg-screen':         ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review']  /* step 0 + step 4 auto-skipped */
  };

  /* cfg-screen skip helpers — Fireplace (0), Style (2) + Glass (4) hidden.
     Step 2 (Style: feet/handle) is skipped for frameless full-glass screens — the
     panel has no decorative style options; the flow is Measurements → Finish → Glass. */
  var _skipStep0 = false;
  function _isSkippedStep(i) { return (_skipStep0 && i === 0) || (_skipStep2 && i === 2) || (_skipStep4 && i === 4); }
  function _skippedBefore(i) { var n=0; if(_skipStep0 && i>0) n++; if(_skipStep2 && i>2) n++; if(_skipStep4 && i>4) n++; return n; }
  function _totalSkipped() { return (_skipStep0?1:0) + (_skipStep2?1:0) + (_skipStep4?1:0); }

  /* ────────────────────────────────────
     DOM REFS
     ──────────────────────────────────── */
  var root = document.getElementById('efCfg');
  if (!root) return;

  var cfgType   = root.dataset.cfgType;
  var isArch    = root.dataset.arch === 'true';
  var isMeshOnly= root.dataset.meshOnly === 'true';
  var basePrice = parseInt(root.dataset.basePrice, 10) || 0; // in cents
  var variantId = root.dataset.variantId;
  var prodTitle = root.dataset.productTitle;
  var prodHandle= root.dataset.productHandle;
  var prodVendor= root.dataset.vendor || '';
  /* Per-product flags — read from product title to drive option-set overrides
     without needing dedicated EF_CFG_DATA groups. */
  var isOdyssey  = /odyssey/i.test(prodTitle);
  var isAllGlass = /all\s*glass/i.test(prodTitle);
  /* Forged Iron Arch (Conversion): shares DS Arch data group but ships with
     restricted options — Cabinet/Bi-Fold only, no handles, no decorative pattern. */
  var isForgedIronArch = /forged\s*iron.*arch|forged-iron-arch/i.test(prodTitle);
  /* EdgeLine = Stoll Inline Hinge variant of DeepSet (shared "Fireplace Doors - Inset / Inline"
     option group). Inline cannot use: decorative pattern (Inset-only), Inside Fit, or
     Pyro Ceramic glass. DeepSet (Inset Hinge) is the default — no flag needed. */
  var isEdgeline = /edgeline|edge-line|edge\s*line/i.test(prodTitle);
  var stepNames = (STEP_DEFS[cfgType] || STEP_DEFS['cfg-custom']).slice();
  /* Mesh-only doors (Stoll Mesh, DS Legend Mesh): step 4 still selects mesh +
     draft control, just no glass — relabel from "Glass" to "Mesh" so the
     progress strip reflects what the user actually picks. */
  if (isMeshOnly) {
    var glassIdx = stepNames.indexOf('Glass');
    if (glassIdx !== -1) stepNames[glassIdx] = 'Mesh';
  }
  var totalSteps= stepNames.length;
  var curStep   = 0;

  /* ── EF FUNNEL ANALYTICS (P-007, 2026-07-27) ─────────────────────────────
     Pure dataLayer emissions for GA4/GTM funnel measurement. ZERO configurator
     logic touched — every call site is additive and fully guarded; any failure
     is silently swallowed and can never affect the money path. */
  function efTrack(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = params || {};
      p.event = eventName;
      if (!p.product_handle) p.product_handle = prodHandle || '';
      window.dataLayer.push(p);
      /* gtag.js (ef-analytics) ignores GTM-style pushes — forward explicitly
         so the funnel reaches GA4 (G-LJCQPD1VSH) through the same consent gate. */
      if (typeof window.gtag === 'function') {
        var g = {};
        for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k) && k !== 'event') g[k] = p[k];
        window.gtag('event', eventName, g);
      }
    } catch (e) {}
  }

  /* State — also exposed on window for Express Checkout (worker path).
     Same object identity so live mutations are visible to external readers. */
  var selections  = {};
  var surcharges  = {};
  var _skipStep4  = false;
  var _skipStep2  = false;
  var sizeData    = [];
  var sizeGrid    = false;   /* EF_STOLL_SIZE_GRID_20260829 */
  var matchedGroup= null;
  var groupData   = null;
  var uploadedFile= null;
  window._efCfgState = {
    selections: selections,
    surcharges: surcharges,
    get photoURL() { return photoURL; },
    get matchedGroup() { return matchedGroup; },
    get cfgType() { return cfgType; },
    get isArch() { return isArch; },
    get variantId() { return variantId; },
    get prodTitle() { return prodTitle; },
    calcTotal: function () { return calcTotal(); },
    formatFieldLabel: function (k) { return formatFieldLabel(k); }
  };

  /* ────────────────────────────────────
     PRODUCT → DATA GROUP MATCHING
     ──────────────────────────────────── */
  function matchProductToGroup() {
    var data = window.EF_CFG_DATA;
    if (!data) { console.warn('EF_CFG_DATA not loaded'); return null; }

    var ALIASES = {
      /* ── ARCH variants (must be matched FIRST to win over rectangular sibling) ── */
      /* Bar Iron Arch — uses the Stoll Bar Iron option set (reassigned 2026-06-16 per product owner):
         arch-specific steps 1&2 (size W+Peak, Masonry, firebox, fit) + all other options copied from
         the rectangular Stoll "Bar Iron - Masonry & Prefab" group (finish/handle/glass/mesh/door_type/
         pattern/hardware_finish). Dedicated file: ef-cfg-doors-bar-iron-arch.js (group "Fireplace Doors - Bar Iron Arch").
         Old World Arch + Smithline Arch remain on dedicated Stoll groups with Legend size brackets. */
      /* Brookfield Deluxe Magnetic — must match BEFORE the generic 'brookfield' →
         standard group fallback in pass1, otherwise the matcher routes Deluxe
         to the standard Brookfield group and the Deluxe-specific measurement
         panel + filters never trigger. */
      'brookfield deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'brookfield – deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'brookfield - deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'bar iron arch':    'Fireplace Doors - Bar Iron Arch',
      'bar iron - arch':  'Fireplace Doors - Bar Iron Arch',
      'forgeline arch':   'Fireplace Doors - Bar Iron Arch',
      'forged iron arch': 'Fireplace Doors - Bar Iron Arch',
      'old world arch':   'Fireplace Doors - Old World Arch',
      'old world - arch': 'Fireplace Doors - Old World Arch',
      'smithline arch':   'Fireplace Doors - Smithline Arch',
      'smithline - arch': 'Fireplace Doors - Smithline Arch',
      /* Industrial Arch (Metro Arch) — REASSIGNED 2026-08-29 (owner GO) from the Blacksmith
         option set (p45) to Industrial (p47). It was standing on the Blacksmith size grid
         while its base price came from Industrial, over-charging $371–$1,426 per door.
         Arch (+$465, p47) is baked into the product base price ($2136 + $465 = $2601),
         so the data group needs no separate arch row — the p47 W×H grid applies as-is.
         EF_STOLL_INDUSTRIAL_ARCH_20260829 */
      'industrial arch':  'Fireplace Doors - Industrial',
      'industrial - arch':'Fireplace Doors - Industrial',
      'metro arch':       'Fireplace Doors - Industrial',
      /* Design Specialties arches → dedicated group "DS Arch" (cloned from DS group + Legend size brackets, 2026-04-21).
         These MUST come before the non-arch DS aliases (black rock, etc.). */
      'buckingham arch':  'Fireplace Doors - DS Arch',
      'buckingham':       'Fireplace Doors - DS Arch',
      'black rock arch':  'Fireplace Doors - DS Arch',
      'legend plain arch':'Fireplace Doors - DS Arch',
      'legend plain':     'Fireplace Doors - DS Arch',

      /* ── Non-arch (rectangular) ── */
      'forgeline': 'Fireplace Doors - Bar Iron',
      'forge line': 'Fireplace Doors - Bar Iron',
      'forge-line': 'Fireplace Doors - Bar Iron',
      'mesh masonry': 'Fireplace Doors - Mesh Doors',
      'laguna': 'Fireplace Doors - Laguna',
      /* ══════════════════════════════════════════════════════════════════
         SCREEN products — MUST match BEFORE door aliases (title often contains
         keywords like "carolina window pane" which would otherwise route to doors).
         All screens use cfg-screen flow (3 steps: Measurements → Style → Review).
         ══════════════════════════════════════════════════════════════════ */
      /* — Full Glass (frameless, no handle, no feet) — */
      'full glass':                'Fireplace Screen - Full Glass',
      'frameless clear glass':     'Fireplace Screen - Full Glass',
      'clear glass fireplace screen': 'Fireplace Screen - Full Glass',
      'fireplace glass screen':    'Fireplace Screen - Full Glass',
      /* — Modern Stainless (outdoor) — */
      'modern stainless':          'Fireplace Screen - Modern Stainless Outdoor',
      'outdoor arch':              'Fireplace Screen - Modern Stainless Outdoor',
      'outdoor rectangle':         'Fireplace Screen - Modern Stainless Outdoor',
      /* — Manhattan / Nolita / Tribeca / Madison screens (DS single-panel) — */
      'manhattan rectangle':       'Fireplace Screen - Manhattan Modern',
      'nolita rectangle':          'Fireplace Screen - Manhattan Modern',
      'nolita custom free standing': 'Fireplace Screen - Manhattan Modern',
      'tribeca rectangle':         'Fireplace Screen - Manhattan Modern',
      'madison free standing':     'Fireplace Screen - Manhattan Modern',
      /* — Stoll Traditional family (Blacksmith, Craftsman, Colonial, Old World, Industrial, Transitional, Elite, Essentials) — */
      'blacksmith triple panel':   'Fireplace Screen - Stoll Traditional',
      'blacksmith arch working':   'Fireplace Screen - Stoll Traditional',
      'blacksmith rectangle':      'Fireplace Screen - Stoll Traditional',
      'craftsman aged':            'Fireplace Screen - Stoll Traditional',
      'craftsman forged':          'Fireplace Screen - Stoll Traditional',
      'craftsman old world':       'Fireplace Screen - Stoll Traditional',
      'colonial':                  'Fireplace Screen - Stoll Traditional',
      'transitional rectangle':    'Fireplace Screen - Stoll Traditional',
      'industrial rectangle':      'Fireplace Screen - Stoll Traditional',
      'industrial triple panel':   'Fireplace Screen - Stoll Traditional',
      'elite rectangle':           'Fireplace Screen - Stoll Traditional',
      'essentials rectangle':      'Fireplace Screen - Stoll Traditional',
      'essentials triple panel':   'Fireplace Screen - Stoll Traditional',
      'traditional triple panel':  'Fireplace Screen - Stoll Traditional',
      'traditional rectangle':     'Fireplace Screen - Stoll Traditional',
      'traditional arch':          'Fireplace Screen - Stoll Traditional',
      'traditional ellipse':       'Fireplace Screen - Stoll Traditional',
      'traditional classic courtyard': 'Fireplace Screen - Stoll Traditional',
      'traditional x design':      'Fireplace Screen - Stoll Traditional',
      'old world rectangle':       'Fireplace Screen - Stoll Traditional',
      'old world arch':            'Fireplace Screen - Stoll Traditional',  /* OVERRIDES door alias since screens matched first */
      /* — DS Custom family (Scroll, Sawgrass, Black Rock, Banded Scroll, Hammered Edge) — */
      'scroll custom fireplace screen': 'Fireplace Screen - DS Custom',
      'sawgrass':                  'Fireplace Screen - DS Custom',
      'banded scroll':             'Fireplace Screen - DS Custom',
      'hammered edge':             'Fireplace Screen - DS Custom',
      'black rock':                'Fireplace Screen - DS Custom',
      /* — Carolina (single panel + all variants: arch, folding, operable, free standing) — */
      'single panel fireplace screen':            'Fireplace Screen - Carolina Single Panel',
      'single panel fireplace screen - carolina': 'Fireplace Screen - Carolina Single Panel',
      'arch fireplace screen':                    'Fireplace Screen - Carolina Single Panel',
      'carolina custom free standing':            'Fireplace Screen - Carolina Single Panel',
      'carolina free standing':                   'Fireplace Screen - Carolina Single Panel',
      'free standing fireplace screen handmade':  'Fireplace Screen - Carolina Single Panel',
      'folding screens - carolina':               'Fireplace Screen - Carolina Single Panel',
      'folding screens custom':                   'Fireplace Screen - Carolina Single Panel',
      'fireplace screen with operable doors':     'Fireplace Screen - Carolina Single Panel',
      'fireplace arch screen with operable':      'Fireplace Screen - Carolina Single Panel',
      'fireplace screen - carolina':              'Fireplace Screen - Carolina Single Panel',
      'carolina ivy':                             'Fireplace Screen - Carolina Single Panel',
      'carolina pond':                            'Fireplace Screen - Carolina Single Panel',
      'carolina coastal':                         'Fireplace Screen - Carolina Single Panel',
      'carolina plain':                           'Fireplace Screen - Carolina Single Panel',
      /* Legend — Fireplace Screen with Operable Doors (DS premium product) */
      'legend freestanding glass fireplace screen': 'Fireplace Screen - Carolina Single Panel',
      'legend fireplace screen':                    'Fireplace Screen - Carolina Single Panel',
      /* Generic catch-all screen fallback (must be LAST in screen block) */
      'fireplace screen':                         'Fireplace Screen - Carolina Single Panel',
      'carolina sunrise': 'Fireplace Doors - Carolina / Panes',
      'carolina window pane': 'Fireplace Doors - Carolina / Panes',
      'carolina steel': 'Fireplace Doors - Carolina / Panes',
      /* Odyssey — uses Carolina option set, but glass + handle hidden via per-product filter (see renderCards) */
      'odyssey':       'Fireplace Doors - Carolina',
      /* Brooklyn + SlimLinePro aliases moved below to the Stoll 2026 block (dedicated groups). */
      /* DS shared option set — Piccolo & 304 Stainless Steel use the DS catalog */
      'piccolo':       'Fireplace Doors - DS / Oak / Black / Crafts etc',
      '304 stainless': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'stainless steel': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      /* Stoll-name → our-EF_CFG_DATA-group equivalents (per owner mapping 2026-04-21) */
      'arden':    'Fireplace Doors - Avalon /Br /Ht / Ln',  /* Arden = Stoll Avalon */
      'openview': 'Fireplace Doors - Full View',            /* OpenView = Stoll Full View */
      /* Sierra family = Stoll Columbia (pricebook page 32, L2051). Standard widths
         35/39/43/47/51 with width-tier surcharge $0/$0/$240/$240/$371 over base $1086.
         All three Sierra variants share the same Columbia option set. */
      'sierra window pane': 'Fireplace Doors - Columbia',
      'sierra arch':        'Fireplace Doors - Columbia',
      'sierra':             'Fireplace Doors - Columbia',
      /* DeepSet (Inset Hinge) + EdgeLine (Inline Hinge) share Stoll's Inset/Inline
         pricebook (page 37, L2884). Same price grid; per-product flag isEdgeline
         hides decorative panes + Inside Fit (Inline restrictions). Arch handled
         via frame_width field in-group, not the global isArch flag. */
      'deepset arch conversion': 'Fireplace Doors - Inset / Inline',
      'deepset arch':            'Fireplace Doors - Inset / Inline',
      'deepset':                 'Fireplace Doors - Inset / Inline',
      'edgeline arch conversion':'Fireplace Doors - Inset / Inline',
      'edgeline arch':           'Fireplace Doors - Inset / Inline',
      'edgeline':                'Fireplace Doors - Inset / Inline',
      /* Smithline (rectangular) = Stoll Blacksmith. MUST come AFTER 'smithline arch' alias above
         so arch variants still route to the dedicated Smithline Arch group. */
      'smithline':'Fireplace Doors - Blacksmith',
      /* Stoll Heritage = "Original" in pricebook — dedicated group with 27 finishes per HearthProducts 2026. */
      'heritage': 'Fireplace Doors - Heritage',
      /* Design Specialties shared option set: Madrid, Black Rock, Craftsman, Hammered Edge, Banded Scroll, Oak Tree, Napa Valley.
         Bevel Glass options are filtered to Black Rock only (see glass-field constraint below). */
      'madrid':        'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'black rock':    'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'craftsman':     'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'hammered edge': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'banded scroll': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'oak tree':      'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'napa valley':   'Fireplace Doors - DS / Oak / Black / Crafts etc',
      /* Mantel (DS) — Masonry & Prefab Fireplace Doors. Uses Carolina Window Pane option set per owner 2026-04-22. */
      'mantel':        'Fireplace Doors - Carolina / Panes',
      /* Milwaukee Forged Iron — Design Specialties product (DS option set) with Milwaukee-specific size pricing.
         Milwaukee MUST be checked before any generic 'forged iron' alias. */
      'milwaukee': 'Fireplace Doors - Milwaukee',
      /* ── Stoll 2026 pricebook groups (owner 2026-04-22). EF renames per Stoll contract. ── */
      /* Brooklyn Hidden Main Frame — dedicated group as of 2026-08-29. It used to share the
         Design Specialties "Original / Slim / Moderne" ladder ($100/$200/$400/$600), which
         under-charged the Stoll Manhattan grid by up to $1,680 on a 68"×44½" opening.
         Cloned from Manhattan (p55) with its own EF-STOLL-BRKH-* size variants.
         MUST precede the generic 'brooklyn' alias below. EF_STOLL_BRKH_GROUP_20260829 */
      'brooklyn hidden':     'Fireplace Doors - Brooklyn Hidden Main Frame',
      'brooklyn - hidden':   'Fireplace Doors - Brooklyn Hidden Main Frame',
      'brooklyn':            'Fireplace Doors - Manhattan',           /* Brooklyn = Stoll Manhattan (L6157) */
      'manhattan':           'Fireplace Doors - Manhattan',
      'slimlinepro':         'Fireplace Doors - Elite Thinline',      /* SlimLine Pro = Stoll Elite Thinline (L6524) — Cabinet only */
      'slim line pro':       'Fireplace Doors - Elite Thinline',
      'elite thinline':      'Fireplace Doors - Elite Thinline',
      'rustic':              'Fireplace Doors - Old World',           /* Rustic = Stoll Old World (L4136) */
      'old world':           'Fireplace Doors - Old World',
      'metro':               'Fireplace Doors - Industrial',          /* Metro = Stoll Industrial (L4916) — Cabinet only */
      'industrial':          'Fireplace Doors - Industrial',
      'midway':              'Fireplace Doors - Transitional',        /* Midway = Stoll Transitional (L5254) */
      'transitional':        'Fireplace Doors - Transitional',
      'timeless flames':     'Fireplace Doors - Vintage',             /* Timeless Flames = Stoll Vintage (L5603) */
      'vintage':             'Fireplace Doors - Vintage',
      'aged iron':           'Fireplace Doors - Aged & Forged Iron',  /* Aged/Forged Iron (L3721) */
      'aged & forged iron':  'Fireplace Doors - Aged & Forged Iron',
      'aged and forged iron':'Fireplace Doors - Aged & Forged Iron',
      'forged iron':         'Fireplace Doors - Aged & Forged Iron',  /* Stoll Forged Iron — own group as of 2026-04-22 */
      /* Ashford + Edgewood — Stoll steel custom doors (~$2,263 base). No dedicated pricebook
         entry; route to Manhattan (Brooklyn) option set as closest mid-tier steel Stoll match.
         Reassign if owner provides Ashford/Edgewood-specific pricebook later. */
      'ashford':             'Fireplace Doors - Manhattan',
      'edgewood':            'Fireplace Doors - Manhattan',
      /* Plated — Stoll's premium electroplated line (page 39 of HearthProducts pricebook).
         Dedicated group cloned from Bar Iron + 5 plated finishes baked in at $0 (included
         in $6,433+ base). 10–12 week lead time, max size 60×40 due to plating-tank limits. */
      'plated':              'Fireplace Doors - Plated'
    };

    var groups = Object.keys(data);
    var title = prodTitle.toLowerCase();

    /* 2026-06-01 — FIX: Black Rock / Hammered Edge / Banded Scroll exist as BOTH a
       screen and a DS door. Their screen alias in ALIASES is declared BEFORE the
       door alias of the same key, so the JS duplicate-key rule (last wins) silently
       overwrote the screen mapping with the door group → screen products routed to a
       door option-set (empty/wrong configurator). Re-assert the screen group FIRST
       for screen products so they get the correct DS Custom screen option-set. */
    var efIsScreen = (root && root.dataset && root.dataset.cfgType === 'cfg-screen') || title.indexOf('screen') !== -1;
    if (efIsScreen) {
      var SCREEN_OVERRIDE = {
        'black rock':    'Fireplace Screen - DS Custom',
        'hammered edge': 'Fireplace Screen - DS Custom',
        'banded scroll': 'Fireplace Screen - DS Custom'
      };
      for (var sov in SCREEN_OVERRIDE) {
        if (title.indexOf(sov) !== -1 && data[SCREEN_OVERRIDE[sov]]) return SCREEN_OVERRIDE[sov];
      }
    }

    for (var alias in ALIASES) {
      if (title.indexOf(alias) !== -1 && data[ALIASES[alias]]) return ALIASES[alias];
    }

    /* Pass 1: match on product model names only (unique, unambiguous).
       These are real product names that won't collide with colors/materials. */
    var MODEL_NAMES = [
      'stiletto cutback',
      'ardmore','armitage','finley','belmont','brookfield','stiletto','silhouette',
      'cabot','rainbow','reflection','grande','medio','apex','bungalow','savannah',
      'carolina','legend','avalon','blacksmith','elite thinline','madrid',
      'hammered edge','craftsman','oak tree','black rock','bar iron',
      'original custom','old world','smithline','essex','lancaster','portland',
      'hudson','mantel','mke rail','camden','colt','farnsworth'
    ];
    var pass1 = [];
    for (var i = 0; i < groups.length; i++) {
      var gName = groups[i];
      var raw = gName.replace(/^Fireplace Doors\s*-\s*/i, '');
      var keywords = raw.split(/\s*[\/,]\s*/);
      var matchedChars = 0;
      for (var k = 0; k < keywords.length; k++) {
        var kw = keywords[k].trim().toLowerCase();
        if (MODEL_NAMES.indexOf(kw) !== -1 && title.indexOf(kw) !== -1) {
          matchedChars += kw.length;
        }
      }
      if (matchedChars > 0) pass1.push({ name: gName, score: matchedChars });
    }
    if (pass1.length === 1) return pass1[0].name;
    if (pass1.length > 1) {
      pass1.sort(function(a, b) { return b.score - a.score; });
      return pass1[0].name;
    }

    /* Pass 2: fallback keyword match (original logic) */
    groups.sort(function(a, b) { return b.length - a.length; });
    for (var j = 0; j < groups.length; j++) {
      var gName2 = groups[j];
      var raw2 = gName2.replace(/^Fireplace Doors\s*-\s*/i, '');
      var keywords2 = raw2.split(/\s*[\/,]\s*/);
      var matched = false;
      for (var m = 0; m < keywords2.length; m++) {
        var kw2 = keywords2[m].trim().toLowerCase();
        if (kw2.length < 4) continue;
        if (SKIP_WORDS.indexOf(kw2) !== -1) continue;
        if (title.indexOf(kw2) !== -1) {
          matched = true;
          break;
        }
      }
      if (matched) return gName2;
    }
    return groups.length ? groups[groups.length - 1] : null;
  }

  matchedGroup = matchProductToGroup();
  groupData = matchedGroup && window.EF_CFG_DATA ? window.EF_CFG_DATA[matchedGroup] : null;
  /* Expose for the AI Configurator Assist IIFE (separate scope) — sent to the
     worker so it knows which option-set the customer is configuring and can
     restrict finish recommendations to what's actually available. */
  window.efCfgMatchedGroup = matchedGroup;
  console.log('[EF-CFG] Product:', prodTitle, '| Matched group:', matchedGroup, '| Data found:', !!groupData, '| size entries:', groupData && groupData.size ? groupData.size.length : 'NONE');

  /* ────────────────────────────────────
     STOLL FINISH OVERRIDE (pricebook page 79)
     When a product is Stoll-branded (Arden, Sierra, Brooklyn, SlimLinePro,
     ForgeLine, Heritage, Odyssey, Rustic, Metro, Midway, Timeless Flames,
     Aged Iron, DeepSet, EdgeLine, OpenView), swap groupData.finish with the
     canonical 4-category Stoll list. This runs REGARDLESS of which EF group
     the product alias maps to — ensures consistent Stoll-spec finishes.
     ──────────────────────────────────── */
  (function applyStollFinishOverride() {
    if (!groupData) return;
    /* Guard: this override is for Stoll-branded products only. Some Design
       Specialties doors have titles that collide with Stoll aliases below
       (e.g. "Milwaukee Forged Iron" → /forged iron/, "Odyssey" → /odyssey/),
       which would wrongly swap their DS finishes for the Stoll set. DS products
       keep their own finishes (normalized by normalizeFinishCats). */
    var _isDsVendor = /design\s*specialties/i.test(prodVendor);
    var _pt = (prodTitle || '').toLowerCase();

    var STOLL_POWDERCOAT = ['Aspire Rust','Bronzed Iron','Champagne','Charcoal','Copper Vein','Matte Black','Oil Rubbed Bronze','Silver Vein','Textured Black','Vintage Vein','White'];
    var STOLL_PREMIUM = ['Antique Black','Antique Steel','Brushed Beige','Brushed Black','Brushed Grey','Brushed White','Burnished Bronze','Burnished Copper','Burnished Latte','Industrial Black','Natural Iron','Satin Gold'];
    /* PLATED (electroplated) — a different door build, not a coating. Stoll order book p.39:
       exactly these 5 finishes, and a flat +$4,200 retail difference over a powder-coat Bar
       Iron (set 2026-06-06). One shared $4,200 surcharge variant; per-finish swatch images. */
    var PLATED_VARIANT = '42438142361682';
    var PLATED_PRICE = 4200;
    var PLATED_IMG = {
      'Antique Brass':  'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/antique_brass_brushed_metal_seamless_swatch.jpg?v=1776897940',
      'Antique Nickel': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-plated-antique-nickel.jpg?v=1780896016',
      'Satin Brass':    'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/satin_brushed_horizontal_brass_texture.jpg?v=1776897940',
      'Terra Cotta':    'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-plated-terra-cotta.jpg?v=1780896020',
      'Uptown Walnut':  'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-plated-uptown-walnut.jpg?v=1780896023'
    };
    var STOLL_PLATED = ['Antique Brass','Antique Nickel','Satin Brass','Terra Cotta','Uptown Walnut'];
    /* Stainless is its own thing (brushed 304 stainless), NOT a plated finish. Keep separate. */
    var STAINLESS_IMG = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/seamless_brushed_stainless_steel_surface.jpg?v=1776897940';
    var STOLL_OVERLAY = ['Antique Brass','Brushed Chrome','Pewter','Satin Brass'];
    /* OVERLAY & TRIM finishes. Stoll order forms (p29/p35/p53/p55) price these at $205 on the
       main frame, not $395. Owner GO 2026-08-29: match the pricebook. One shared surcharge
       variant (EF-STOLL-OVERLAY-205) so every style bills the same line item. */
    var OVERLAY_VARIANT = '42659289366610';
    var OVERLAY_PRICE   = 205;

    /* Per-EF-brand availability (verified against Stoll pricebook order forms).
       plated: 'all' (6 entries) | 'stainless' (1 entry) | null (none) */
    /* overlay availability verified against clean Stoll pricebook order forms (2026-06, layout
       extract). overlay=false where the form has NO overlay/trim finish column (selling those
       finishes was unfulfillable). overlay=true only where the form offers Overlay & Trim
       finishes (Original/Heritage, Full View/TotalView, Manhattan). */
    /* overlay availability VERIFIED 2026-06-08 by reading each style's FINISH SELECTION
       directly from the pricebook PDF (per-page pdftotext, no column bleed). overlay=true ONLY
       where the order form prints an "OVERLAY & TRIM FINISHES" section: Bar Iron, Original/Heritage,
       Full View/TotalView, Manhattan. All others = powdercoat+premium (+stainless) only → overlay=false
       (we were selling 4 overlay finishes the factory won't build on those frames). */
    var PRODUCT_MAP = [
      /* Arden — vendor corrected to Design Specialties 2026-08-29 (extruded aluminum frame,
         DS anodized finishes, made in South Carolina). It still shares the Stoll `doors-bar-iron`
         data group, whose raw finish list carries Plated +$4,200 / Brushed Stainless +$1,400 /
         overlay @$395 — none of which belong on an $895 aluminum door. dsOk keeps this override
         running for Arden despite the DS vendor guard, so its palette stays exactly as it was.
         TODO: Arden needs its own DS data group (audit §7.1). EF_ARDEN_DSOK_20260829 */
      {match:/arden/,                                  plated:null,        overlay:true, dsOk:true},
      /* Ashford / Edgewood — Stoll Manhattan platform (p55, base $2,167). p55 offers
         Overlay & Trim finishes and Brushed Stainless at $800, so they get the Brooklyn spec
         rather than the generic Stoll fallback (which would drop the $800 stainless). */
      {match:/ashford|edgewood/,                       plated:'stainless', overlay:true, stainlessPrice:800, stainlessVariant:'42376170373202'},
      {match:/openview/,                               plated:null,        overlay:true},  // Stoll Full View — overlay offered (p53)
      {match:/sierra/,                                 plated:null,        overlay:false}, // Stoll Columbia — no overlay (welded bullet hinges, p33)
      {match:/deepset|edgeline/,                       plated:'stainless', overlay:false, stainlessPrice:800, stainlessVariant:'42376090812498'}, // Stoll Inset/Inline — no overlay, Brushed Stainless $800 (p37)
      {match:/brooklyn/,                               plated:'stainless', overlay:true, stainlessPrice:800, stainlessVariant:'42376170373202'},  // Stoll Manhattan — overlay offered, Brushed Stainless $800 (p55)
      {match:/slimlinepro|slim\s*line\s*pro/,          plated:null,        overlay:false}, // Stoll Elite Thinline — no overlay (p57)
      /* Aged & Forged Iron (p41) FIRST: 'Forged Iron ...' titles must NOT fall through to the
         Bar Iron rule below, which would sell Plated +$4200 / Stainless / Overlay that p41
         does not offer. Audit 2026-08-29 fix #15. */
      {match:/flat\s*hammer|aged\s*iron|forged\s*iron/, plated:null,      overlay:false}, // Stoll Aged & Forged — powdercoat + premium only (p41)
      {match:/forgeline|forge[\s-]?line|bar\s*iron/,   plated:'all',       overlay:true},  // Stoll Bar Iron — overlay offered (p35)
      {match:/heritage/,                               plated:null,        overlay:true},  // Stoll Original — overlay offered (p29)
      {match:/odyssey/,                                plated:null,        overlay:true},  // Stoll Carolina-equivalent (not in audited pages, left as-is)
      {match:/rustic/,                                 plated:null,        overlay:false}, // Stoll Old World — no overlay (p43)
      {match:/metro/,                                  plated:null,        overlay:false}, // Stoll Industrial — no overlay (p47)
      {match:/midway/,                                 plated:null,        overlay:false}, // Stoll Transitional — no overlay (p49)
      {match:/timeless\s*flames?/,                     plated:null,        overlay:false}, // Stoll Vintage — no overlay (p51)
      {match:/smithline|blacksmith|industrial/,        plated:null,        overlay:false}  // Stoll Blacksmith (p45) / Industrial (p47) — powdercoat + premium only
    ];

    var spec = null;
    for (var i = 0; i < PRODUCT_MAP.length; i++) {
      if (PRODUCT_MAP[i].match.test(_pt)) { spec = PRODUCT_MAP[i]; break; }
    }
    /* Design Specialties products keep their own finishes — unless the entry is explicitly
       marked dsOk (Arden: DS product parked on a Stoll data group, see above). */
    if (_isDsVendor && !(spec && spec.dsOk)) return;

    /* EF_STOLL_DEFAULT_SPEC_20260829 — owner GO 2026-08-29: "Stoll doors must show Stoll's
       colors, not Design Specialties'". Until today a Stoll-vendor product whose title matched
       no PRODUCT_MAP row fell through with whatever finish list its data group happened to
       carry — on shared/legacy groups that meant DS names (Shark Skin, Rustic Copper,
       Satin Nickel, Root Beer, Mahogany…) and $315/$1,500 tiers with no basis in any Stoll
       order form. Now the vendor decides: Stoll vendor + no per-style spec = the canonical
       Stoll powdercoat (11 × $0) + premium (12 × $395) lists, no plated / stainless / overlay
       (those are per-style and must be opted into through PRODUCT_MAP above).
       Scoped to door groups: screens and the Plated line keep their own palettes. */
    if (!spec) {
      if (cfgType === 'cfg-screen') return;
      if (!/stoll/i.test(prodVendor)) return;
      if ((matchedGroup || '').indexOf('Fireplace Doors') !== 0) return;
      if (/plated|electroplated|stainless/.test(_pt)) return;
      spec = { match: /__stoll_default__/, plated: null, overlay: false, isDefault: true };
    }

    /* Preserve existing variantIds by normalized label match */
    var existing = {};
    (groupData.finish || []).forEach(function(f) {
      var k = (f.label || '').toLowerCase().replace(/\*/g,'').replace(/\s+(plated|overlay)$/i,'').trim();
      if (!existing[k]) existing[k] = f;
    });
    function lookupV(label) { var e = existing[label.toLowerCase().trim()]; return e ? (e.variantId || null) : null; }
    function lookupImg(label) { var e = existing[label.toLowerCase().trim()]; return (e && e.img) ? e.img : ''; }

    var out = [];
    STOLL_POWDERCOAT.forEach(function(l) { out.push({label:l, cat:'powdercoat', price:'0', variantId:lookupV(l), img:lookupImg(l)}); });
    STOLL_PREMIUM.forEach(function(l)    { out.push({label:l, cat:'premium', price:'395', variantId:lookupV(l), img:lookupImg(l)}); });
    /* PLATED finishes (+$4,200) — only when this product offers full plating ('all'). */
    if (spec.plated === 'all') {
      STOLL_PLATED.forEach(function(l) { out.push({label:l, cat:'plated', price:String(PLATED_PRICE), variantId:PLATED_VARIANT, img:PLATED_IMG[l] || lookupImg(l)}); });
    }
    /* STAINLESS (brushed 304) — offered by full-plating ('all') and stainless-only doors.
       Price matches the pricebook per style: Bar Iron/ForgeLine $1400, Inset/Inline & Manhattan $800. */
    if (spec.plated === 'all' || spec.plated === 'stainless') {
      var _stPrice = String(spec.stainlessPrice || 1400);
      /* EF_STOLL_STAINLESS_20260829 — pin the surcharge variant when the style has a
         pricebook stainless price, so the displayed price and the billed line item agree
         even when the group's own data file still carries the old $1,400 variant. */
      out.push({label:'Brushed Stainless', cat:'plated_stainless', price:_stPrice, variantId:(spec.stainlessVariant || lookupV('Brushed Stainless')), img:lookupImg('Brushed Stainless') || STAINLESS_IMG});
    }
    if (spec.overlay) STOLL_OVERLAY.forEach(function(l) { out.push({label:l, cat:'overlay', price:String(OVERLAY_PRICE), variantId:OVERLAY_VARIANT, img:lookupImg(l)}); });

    /* Shallow-clone groupData before mutating so the shared EF_CFG_DATA
       object isn't polluted across renders. */
    groupData = Object.assign({}, groupData);
    groupData.finish = out;
    console.log('[EF-CFG] Stoll finish override applied:', out.length, 'finishes for pattern', spec.match);
  })();

  /* ────────────────────────────────────
     STOLL HANDLE OVERRIDE — EF_STOLL_HANDLES_20260829
     Owner GO 2026-08-29: "Stoll doors show Design Specialties handles — must be Stoll's".
     Handle availability is per order form, NOT global:
       p23 Mesh · p29 Original · p33 Columbia · p35 Bar Iron · p37 Inset/Inline · p53 TotalView
             → Square* / Wire / Designer / Strap / Hampton / Knob   (all N/C)
       p41 Aged & Forged → Square* / Wire / Designer / Strap / Knob / Craftsman
       p45 Blacksmith    → Blacksmith* / Strap / Craftsman
       p57 Elite Thinline→ Knob handles only (listed under ELITE THINLINE FEATURES)
       p43 / p47 / p49 / p51 / p55 → no HANDLE section on the form → group left untouched
     "Contemporary" is on the Stoll forms but was discontinued store-wide 2026-06-16
     (dropDiscontinuedOptions), so it is deliberately not re-introduced here.
     "Place Handles On Center Bar $70" is priced through the Extras step, not here.
     Design Specialties products are never touched (vendor guard).
     ──────────────────────────────────── */
  (function applyStollHandleOverride() {
    if (!groupData) return;
    if (cfgType === 'cfg-screen') return;
    if (/design\s*specialties/i.test(prodVendor)) return;
    if (!/stoll/i.test(prodVendor)) return;

    var _F = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/';
    /* Stoll Industries handle artwork (*_SI.png). "Desinger" is Stoll's own file-name typo. */
    var SI_IMG = {
      'Square':   _F + 'Square_SI.png',
      'Wire':     _F + 'Wire_SI.png',
      'Designer': _F + 'Desinger_SI.png',
      'Strap':    _F + 'Strap_SI.png',
      'Hampton':  _F + 'Hampton_SI.png',
      'Knob':     _F + 'Knob_SI.png',
      /* Owner-supplied artwork 2026-08-30 (transparent PNG, same treatment as the *_SI set). */
      'Craftsman':  _F + 'ef-handle-craftsman-si.png?v=1788123201',
      /* 2026-08-30 correction: the first file the owner sent (ef-handle-blacksmith-si.png,
         riveted S-curve) is the Old World handle, not this one. Blacksmith = forged bar
         with a ring pull. The unused file stays in Files for a future Old World handle. */
      'Blacksmith': _F + 'ef-handle-blacksmith-si-v2.png?v=1788123536',
      /* Signature handles: the Industrial (p47) and Transitional (p49) order forms carry no
         handle selection — each door ships with its own handle, so we show that one card. */
      'Industrial':   _F + 'ef-handle-industrial-si.png?v=1788123903',
      'Transitional': _F + 'ef-handle-transitional-si.png?v=1788123906'
    };
    /* Recommended handle per style (owner 2026-08-30) — a merchandising hint on the card,
       it does not change the default selection or any price. Craftsman on the Aged & Forged
       (hammered iron) doors, Blacksmith on the Blacksmith / Smithline doors — that is the
       rustic "old world" handle in the Stoll book (p45 "J. Blacksmith*"). */
    var RECOMMENDED = {
      'Fireplace Doors - Aged & Forged Iron': 'Craftsman',
      'Fireplace Doors - Blacksmith':         'Blacksmith',
      'Fireplace Doors - Smithline Arch':     'Blacksmith',
      'Fireplace Doors - Industrial':         'Industrial',
      'Fireplace Doors - Transitional':       'Transitional'
    };
    var STD        = ['Square', 'Wire', 'Designer', 'Strap', 'Hampton', 'Knob'];
    var AGEDFORGED = ['Square', 'Wire', 'Designer', 'Strap', 'Knob', 'Craftsman'];
    var BLACKSMITH = ['Blacksmith', 'Strap', 'Craftsman'];
    var KNOB_ONLY  = ['Knob'];
    var INDUSTRIAL = ['Industrial'];
    var TRANSITION = ['Transitional'];
    var BY_GROUP = {
      'Fireplace Doors - Mesh Doors':          STD,
      'Fireplace Doors - Heritage':            STD,
      'Fireplace Doors - Columbia':            STD,
      'Fireplace Doors - Bar Iron':            STD,
      'Fireplace Doors - Bar Iron Arch':       STD,
      'Fireplace Doors - Inset / Inline':      STD,
      'Fireplace Doors - Full View':           STD,
      'Fireplace Doors - Aged & Forged Iron':  AGEDFORGED,
      'Fireplace Doors - Blacksmith':          BLACKSMITH,
      'Fireplace Doors - Smithline Arch':      BLACKSMITH,
      'Fireplace Doors - Elite Thinline':      KNOB_ONLY,
      'Fireplace Doors - ThinlinePro':         KNOB_ONLY,
      'Fireplace Doors - Industrial':          INDUSTRIAL,
      'Fireplace Doors - Transitional':        TRANSITION
    };
    var labels = BY_GROUP[matchedGroup];
    if (!labels) return;

    /* Preserve existing variantIds (and images we don't have SI art for) by label. */
    var existing = {};
    (groupData.handle || []).forEach(function (h) {
      var k = (h.label || '').toLowerCase().replace(/\*/g, '').trim();
      if (!existing[k]) existing[k] = h;
    });
    var _rec = RECOMMENDED[matchedGroup] || null;
    var handles = labels.map(function (l) {
      var e = existing[l.toLowerCase()];
      return {
        label: l,
        price: 0,
        variantId: (e && e.variantId) || null,
        img: SI_IMG[l] || (e && e.img) || '',
        rec: _rec === l ? 'Recommended' : null
      };
    });
    groupData = Object.assign({}, groupData);
    groupData.handle = handles;
    console.log('[EF-CFG] Stoll handle override applied:', handles.length, 'handles for', matchedGroup);
  })();

  /* ────────────────────────────────────
     DISCONTINUED OPTIONS (2026-06-16)
     Options pulled from the palette globally (no longer orderable). Removed at
     runtime so we don't have to touch the 28 code-split data files. Label match,
     case-insensitive. These are effectively DS-only (Stoll lists don't carry them):
       • finish "Black Nickel"  • handle "Contemporary"
     ──────────────────────────────────── */
  (function dropDiscontinuedOptions() {
    if (!groupData) return;
    var GONE = {
      finish: { 'black nickel': 1, 'root beer': 1 },
      handle: { 'contemporary': 1 }
    };
    Object.keys(GONE).forEach(function (grp) {
      var arr = groupData[grp];
      if (!Array.isArray(arr)) return;
      var kept = arr.filter(function (o) { return !GONE[grp][(o.label || '').toLowerCase().trim()]; });
      if (kept.length !== arr.length) {
        groupData = Object.assign({}, groupData);
        groupData[grp] = kept;
        console.log('[EF-CFG] Discontinued ' + grp + ' removed; ' + kept.length + ' remain');
      }
    });
  })();

  /* ────────────────────────────────────
     NEWLY-AVAILABLE OPTIONS (2026-06-16)
     Options that are now orderable, injected at runtime (parallel to the
     discontinued filter) so we don't touch the 28 code-split data files.
     "Rugged Steel" = free handle, added only to groups that already offer the
     Design Specialties handle set (detected by a signature handle), never duped.
     ──────────────────────────────────── */
  (function addNewOptions() {
    if (!groupData || !Array.isArray(groupData.handle)) return;
    var labels = groupData.handle.map(function (h) { return (h.label || '').toLowerCase().trim(); });
    var isDSHandleSet = labels.indexOf('classic') !== -1 || labels.indexOf('simplicity') !== -1;
    if (!isDSHandleSet || labels.indexOf('rugged steel') !== -1) return;
    groupData = Object.assign({}, groupData);
    var hs = groupData.handle.slice();
    var rugged = {
      label: 'Rugged Steel', price: 0, variantId: null,
      img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/Rugged_Steel.png?v=1781639976'
    };
    /* Rugged Steel is free — place it with the free handles, BEFORE the first
       paid (+$) bar handle (Diamond/Square/Hammered Bar). */
    var firstPaid = hs.findIndex(function (h) { return (parseFloat(h.price) || 0) > 0; });
    if (firstPaid === -1) hs.push(rugged); else hs.splice(firstPaid, 0, rugged);
    groupData.handle = hs;
    console.log('[EF-CFG] Added handle: Rugged Steel (before paid handles)');
  })();

  /* ────────────────────────────────────
     STOLL HANDLE IMAGE SWAP (2026-06-16)
     New handle renders from the Stoll order form. Matched by the OLD image URL
     (the Stoll ".jpg" handle art) so the Design-Specialties "Square" (a getimg URL)
     is left untouched — only the Stoll Square.jpg is swapped. Runtime, so all
     groups update without editing the code-split data files.
     ──────────────────────────────────── */
  (function swapStollHandleImages() {
    if (!groupData || !Array.isArray(groupData.handle)) return;
    var SI = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/';
    var MAP = [
      ['/Strap.jpg',    SI + 'Strap_SI.png?v=1781647290'],
      ['/Square.jpg',   SI + 'Square_SI.png?v=1781647290'],
      ['/Designer.jpg', SI + 'Desinger_SI.png?v=1781647290'],
      ['/Wire.jpg',     SI + 'Wire_SI.png?v=1781647290'],
      ['/Hampton.jpg',  SI + 'Hampton_SI.png?v=1781647290'],
      ['/Knob.jpg',     SI + 'Knob_SI.png?v=1781647290']
    ];
    var hit = false;
    var hs = groupData.handle.map(function (h) {
      if (!h.img) return h;
      for (var i = 0; i < MAP.length; i++) {
        if (h.img.indexOf(MAP[i][0]) !== -1) { hit = true; return Object.assign({}, h, { img: MAP[i][1] }); }
      }
      return h;
    });
    if (hit) { groupData = Object.assign({}, groupData); groupData.handle = hs; console.log('[EF-CFG] Stoll handle images swapped'); }
  })();

  /* ────────────────────────────────────
     PATTERN PREVIEW IMAGE (2026-06-16, TEST)
     New preview render for the "Standard" pattern option. Runtime swap by label
     so every group's Standard pattern uses it (test scope).
     ──────────────────────────────────── */
  (function swapPatternImages() {
    /* 2026-06-25 — REVERTED per owner. The transparent "Standard" PNG was a TEST and
       made Standard look inconsistent vs the other 8 patterns (which use the original
       white-bg line-drawing images). Keep everything as it was → Standard uses its
       original image like the rest. Re-enable by removing this return. */
    return;
    if (!groupData || !Array.isArray(groupData.pattern)) return;
    var IMG = { 'standard': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/fireplace_standard_pattern_transparent.png?v=1781647709' };
    var hit = false;
    var ps = groupData.pattern.map(function (p) {
      var key = (p.label || '').toLowerCase().trim();
      if (IMG[key]) { hit = true; return Object.assign({}, p, { img: IMG[key] }); }
      return p;
    });
    if (hit) { groupData = Object.assign({}, groupData); groupData.pattern = ps; console.log('[EF-CFG] Pattern image swapped'); }
  })();

  /* ────────────────────────────────────
     FINISH CATEGORY NORMALIZATION (2026-06-16)
     Fixes two systemic issues in the per-group finish lists that surface as
     wrong finish tabs (display-only — never touches price or variantId):
       1) PRICED finish mis-tagged into a free/powder-coat tier → it shows in the
          "Powder Coat" tab (e.g. Belmont's +$75 anodized finishes, Old World Arch
          $395 finishes). Move any finish with price > 0 out of the free tier.
       2) DS groups carry BOTH `premium` and `handcrafted` → a redundant 3rd tab.
          Where `handcrafted` exists, fold `premium` into it so the customer sees
          just Powder Coat + Hand Crafted (per spec for Design Specialties doors).
     Groups that are already correct (powdercoat + premium, no handcrafted — e.g.
     the Stoll override output, Brookfield, Cavestone) are left untouched.
     ──────────────────────────────────── */
  (function normalizeFinishCats() {
    if (!groupData || !groupData.finish || !groupData.finish.length) return;
    var FREE = { powder_coat: 1, powdercoat: 1, standard: 1 };
    var hasHandcrafted = groupData.finish.some(function (f) { return f.cat === 'handcrafted'; });
    var changed = 0;
    var out = groupData.finish.map(function (f) {
      var orig = f.cat || 'powder_coat';
      var c = orig;
      var price = parseFloat(f.price) || 0;
      if (FREE[c] && price > 0) c = hasHandcrafted ? 'handcrafted' : 'premium';
      if (c === 'premium' && hasHandcrafted) c = 'handcrafted';
      if (c !== orig) { changed++; return Object.assign({}, f, { cat: c }); }
      return f;
    });
    if (changed) {
      groupData = Object.assign({}, groupData);
      groupData.finish = out;
      console.log('[EF-CFG] Finish categories normalized:', changed, 'recategorized');
    }
  })();

  /* ────────────────────────────────────
     PREMIUM ALUMINUM FINISHES → HAND CRAFTED (2026-08-29, owner request)
     The Design Specialties aluminum-door "Premium" palette (Brookfield / Stiletto /
     Apex set) offered on selected screens as a +$175 Hand Crafted option. Per-product
     opt-in by handle (started with the Madison screen). Runs AFTER normalizeFinishCats
     so cat 'handcrafted' is final. Each finish has its own hidden surcharge variant on
     product 7492486070354 ("Finish: finish-10", $175). Finishes the product already
     lists (e.g. Shark Skin, Satin Nickel) are never duplicated or repriced.
     ──────────────────────────────────── */
  (function addPremiumAluminumFinishes() {
    if (!groupData || !Array.isArray(groupData.finish)) return;
    var HANDLES = {
      'free-standing-fireplace-screen-custom-made-tribeca-rectangle': 1   /* Madison Free Standing Screen */
    };
    if (!HANDLES[(prodHandle || '').toLowerCase()]) return;
    var AV = 'https://product-options-img.avisplus.io/7095025746/7095025746_';
    var SET = [
      { label: 'Copper Fire',       variantId: '42659188932690', img: AV + '1723952740690_RMHZkhmYjwsVXTTVksJ.jpeg' },
      { label: 'Old World Bronze',  variantId: '42659189030994', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/7095025746_1723952745034_ogVpQuHzaPsENWzxXX.jpg?v=1776732375' },
      { label: 'Vintage Brass',     variantId: '42659189063762', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-vintage-brass.jpg?v=1788030713' },
      { label: 'Venetian Bronze',   variantId: '42659189096530', img: AV + '1723952764118_bvQSPnpwkvUcnyXJkWBVx.jpeg' },
      { label: 'Candlelight Brass', variantId: '42659189162066', img: AV + '1723952766404_XFteBCRYiexLiGQYzm.jpeg' }
    ];
    var have = {};
    groupData.finish.forEach(function (f) { have[(f.label || '').toLowerCase().replace(/_/g, ' ').trim()] = 1; });
    var add = SET.filter(function (f) { return !have[f.label.toLowerCase()]; })
      .map(function (f) { return { label: f.label, cat: 'handcrafted', price: '175', variantId: f.variantId, img: f.img }; });
    if (!add.length) return;
    groupData = Object.assign({}, groupData);
    var fs = groupData.finish.slice();
    /* Place right after the last existing Hand Crafted finish so the tab reads
       existing set → premium aluminum, not scattered. */
    var lastHC = -1;
    fs.forEach(function (f, i) { if (f.cat === 'handcrafted') lastHC = i; });
    if (lastHC === -1) fs = fs.concat(add); else fs.splice.apply(fs, [lastHC + 1, 0].concat(add));
    groupData.finish = fs;
    console.log('[EF-CFG] Premium Aluminum finishes added to Hand Crafted:', add.length);
  })();

  /* ────────────────────────────────────
     SIZE CATEGORIES (parsed from data)
     ──────────────────────────────────── */
  function parseSizeCategories() {
    if (!groupData || !groupData.size) return;
    sizeData = [];
    sizeGrid = false;
    groupData.size.forEach(function(s) {
      // Parse: "Medium: 60-70 (W+H)" or "Small: under 60 (W+H)" or "XXL: 90+ (W+H)"
      var m;
      var entry = { label: s.label, price: s.price || 0, variantId: s.variantId, maxTotal: Infinity, minTotal: 0,
                    maxW: (s.maxW === undefined || s.maxW === null) ? null : parseFloat(s.maxW),
                    maxH: (s.maxH === undefined || s.maxH === null) ? null : parseFloat(s.maxH) };
      /* EF_STOLL_SIZE_GRID_20260829 - Stoll order forms price by a Width x Height grid
         (row = max opening width AND max opening height), not by united inches. Rows that
         carry maxW/maxH switch this group to grid selection; every other group (all Design
         Specialties data) keeps the legacy W+H behaviour untouched. */
      if (entry.maxW !== null && entry.maxH !== null && !isNaN(entry.maxW) && !isNaN(entry.maxH)) sizeGrid = true;

      m = s.label.match(/under\s+(\d+)/i);
      if (m) { entry.maxTotal = parseInt(m[1], 10) - 0.01; entry.minTotal = 0; }

      m = s.label.match(/(\d+)\s*[-–]\s*(\d+)/);
      if (m) { entry.minTotal = parseInt(m[1], 10); entry.maxTotal = parseInt(m[2], 10) + 0.999; }

      m = s.label.match(/(\d+)\s*\+/);
      if (m) { entry.minTotal = parseInt(m[1], 10); entry.maxTotal = Infinity; }

      // Clean label for display (strip "(W+H)")
      entry.displayLabel = s.label.replace(/\s*\(W\s*\+\s*(?:H|Peak)\)\s*/gi, '').trim();
      /* EF_STOLL_1TO1_20260829 — Stoll rows display exactly as the order form ("Up to 38″ W × 36½″ H"). */
      if (s.gridLabel) entry.displayLabel = s.gridLabel;

      sizeData.push(entry);
    });
  }
  parseSizeCategories();

  /* ────────────────────────────────────
     PARSE FRACTION INPUT ("36 1/16" → 36.0625)
     ──────────────────────────────────── */
  function parseMeasurement(val) {
    if (!val) return NaN;
    val = val.trim().replace(/[""″]/g, '');
    // Match "36 1/16" or "36.5" or "36"
    var m = val.match(/^(\d+(?:\.\d+)?)\s+(\d+)\/(\d+)$/);
    if (m) return parseFloat(m[1]) + parseInt(m[2], 10) / parseInt(m[3], 10);
    m = val.match(/^(\d+(?:\.\d+)?)$/);
    if (m) return parseFloat(m[1]);
    // Try fraction only "1/2"
    m = val.match(/^(\d+)\/(\d+)$/);
    if (m) return parseInt(m[1], 10) / parseInt(m[2], 10);
    return NaN;
  }

  /* ────────────────────────────────────
     MONEY FORMATTER
     ──────────────────────────────────── */
  function money(cents) {
    var neg = cents < 0;
    cents = Math.abs(cents);
    var d = Math.floor(cents / 100);
    var c = cents % 100;
    return (neg ? '-' : '') + '$' + d.toLocaleString('en-US') + (c ? '.' + (c < 10 ? '0' : '') + c : '');
  }

  /* ────────────────────────────────────
     BUILD PROGRESS BAR
     ──────────────────────────────────── */
  var checkSvg = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6l3 3 5-5"/></svg>';

  function buildProgress() {
    /* Luxury strip — thin sticky bar under header. One segment per visible step.
       JS-driven so segment count matches visibleSteps. */
    var strip = document.getElementById('efCfgStrip');
    if (strip) {
      var visStepCount = 0;
      for (var vi = 0; vi < stepNames.length; vi++) {
        if (!_isSkippedStep(vi)) visStepCount++;
      }
      if (!visStepCount) visStepCount = stepNames.length || 6;
      var stripHtml = '';
      for (var si = 0; si < visStepCount; si++) {
        stripHtml += '<div class="ef-cfg-strip__seg" data-vis-step="' + si + '"></div>';
      }
      strip.innerHTML = stripHtml;

      /* ROUND 5 (2026-04-29) — also build segmented bar for the in-flow stepbar
         (mirrors the strip's segment count + premium bronze treatment). */
      var sbTrack = document.getElementById('efPd2StepBarTrack');
      if (sbTrack) {
        var sbHtml = '';
        for (var sbi = 0; sbi < visStepCount; sbi++) {
          sbHtml += '<div class="ef-pd2-stepbar__seg" data-vis-step="' + sbi + '"></div>';
        }
        sbTrack.innerHTML = sbHtml;
      }

      /* Detect header height once on init + on resize (NOT on scroll —
         reading getBoundingClientRect on every scroll caused forced reflows
         that interacted badly with iOS gallery video scroll-into-view). */
      function syncStripOffset() {
        var hdr = document.querySelector('header.shopify-section, #shopify-section-header, header[role="banner"], .header, header');
        var h = 0;
        if (hdr) h = Math.round(hdr.getBoundingClientRect().height);
        if (!h || h < 30) h = 64; /* sane default */
        document.documentElement.style.setProperty('--ef-cfg-strip-offset', h + 'px');
      }
      syncStripOffset();
      window.addEventListener('resize', syncStripOffset, { passive: true });
      /* Run once after window load — header may not be fully sized at script execution */
      window.addEventListener('load', syncStripOffset, { once: true });
      requestAnimationFrame(function() { strip.classList.add('is-ready'); });
    }

    var el = document.getElementById('efCfgProgress');
    /* "Configure your door" label removed 2026-05-03 — duplicate of the
       new section header above. Progress strip just shows step fraction. */
    var html =
      '<div class="ef-cfg-progress__header ef-cfg-progress__header--frac-only">' +
        '<span class="ef-cfg-progress__header-fraction">Step <span id="efCfgStepNum">1</span> of <span id="efCfgStepTotal">' + stepNames.length + '</span></span>' +
      '</div>' +
      '<div class="ef-cfg-progress__nodes">' +
        '<div class="ef-cfg-progress__track-line"></div>' +
        '<div class="ef-cfg-progress__track-fill" id="efCfgTrackFill"></div>';
    /* Mobile-shorter step labels — desktop sees full names, mobile gets
       truncated where helpful. User feedback 2026-05-03 — "Measurements" was
       truncating on 375px viewport but reads fine on desktop. */
    var MOBILE_STEP_SHORT = { 'Measurements': 'Measure' };
    stepNames.forEach(function(name, i) {
      var mobileShort = MOBILE_STEP_SHORT[name];
      var labelHtml = mobileShort
        ? '<span class="ef-desktop-only">' + name + '</span><span class="ef-mobile-only">' + mobileShort + '</span>'
        : name;
      html +=
        '<div class="ef-cfg-progress__node" data-step="' + i + '"' + (i === 0 ? ' aria-current="step"' : '') + '>' +
          '<div class="ef-cfg-progress__circle" id="efCfgCircle' + i + '">' + (i + 1) + '</div>' +
          '<div class="ef-cfg-progress__node-label">' + labelHtml + '</div>' +
          '<div class="ef-cfg-progress__node-summary" id="efCfgSummary' + i + '"></div>' +
        '</div>';
    });
    html +=
      '</div>' +
      '<div class="ef-cfg-progress__pill">' +
        '<div class="ef-cfg-progress__pill-fill" id="efCfgPillFill"></div>' +
      '</div>';
    el.innerHTML = html;

    el.querySelectorAll('.ef-cfg-progress__node').forEach(function(node) {
      node.addEventListener('click', function() {
        var idx = parseInt(node.dataset.step, 10);
        if (idx < curStep) { goToStep(idx); }
        else if (idx > curStep) {
          for (var s = curStep; s < idx; s++) {
            if (_isSkippedStep(s)) continue;
            if (!validateStep(s)) {
              var failNode = el.querySelector('[data-step="' + s + '"]');
              if (failNode) {
                failNode.classList.add('is-error');
                setTimeout(function() { failNode.classList.remove('is-error'); }, 2000);
              }
              return;
            }
          }
          goToStep(idx);
        }
      });
    });

    updateProgress();
  }

  function getStepSummary(stepIndex) {
    /* Return a short label for completed steps based on user selections */
    switch(stepIndex) {
      case 0: return selections.fireplace_type || selections.firebox_type || '';
      case 1:
        var w = selections._width || '';
        var h = selections._height || '';
        if (w && h) return w + '"×' + h + '"';
        return '';
      case 2: return selections.door_type || selections.fit_type || selections.frame_width || '';
      case 3: return selections.finish || '';
      case 4: return selections.glass || selections.mesh || '';
      default: return '';
    }
  }

  function updateProgress() {
    var total = stepNames.length;
    var progEl = document.getElementById('efCfgProgress');
    if (!progEl) return;
    var displayNum = 0;
    for (var i = 0; i < total; i++) {
      var node = progEl.querySelector('[data-step="' + i + '"]');
      var circle = progEl.querySelector('#efCfgCircle' + i);
      var summary = progEl.querySelector('#efCfgSummary' + i);
      if (!node) continue;
      if (_isSkippedStep(i)) { node.style.display = 'none'; continue; }
      node.style.display = '';
      displayNum++;
      node.classList.remove('is-done', 'is-active');
      node.removeAttribute('aria-current');
      var dn = displayNum;
      if (i < curStep) {
        node.classList.add('is-done');
        node.style.cursor = 'pointer';
        circle.innerHTML = checkSvg;
        if (summary) summary.textContent = getStepSummary(i);
      } else if (i === curStep) {
        node.classList.add('is-active');
        node.setAttribute('aria-current', 'step');
        node.style.cursor = 'default';
        circle.textContent = dn;
        if (summary) summary.textContent = '';
      } else {
        node.style.cursor = 'default';
        circle.textContent = dn;
        if (summary) summary.textContent = '';
      }
    }
    var visTotal = total - _totalSkipped();
    var visCur = curStep - _skippedBefore(curStep);
    /* Track line + fill — clip to half-slot offset on each side so line starts
       AT circle 1 center and ends AT circle N center. Track-line has no ID
       (only class) — query by class. User feedback 2026-05-03. */
    var halfSlotPct = (50 / visTotal) + '%';
    var trackLineEls = progEl.querySelectorAll('.ef-cfg-progress__track-line');
    trackLineEls.forEach(function(el) {
      el.style.setProperty('left', halfSlotPct, 'important');
      el.style.setProperty('right', halfSlotPct, 'important');
    });
    /* Track fill: line between nodes */
    var trackFill = document.getElementById('efCfgTrackFill');
    if (trackFill) {
      trackFill.style.setProperty('left', halfSlotPct, 'important');
      var pct = visCur > 0 ? (visCur / (visTotal - 1)) * 100 : 0;
      /* fill width must be capped to (100% - 2*halfSlot) so the bronze fill
         doesn't extend past the last circle. */
      var fillWidth = ((visTotal - 1) / visTotal) * pct + '%';
      trackFill.style.setProperty('width', fillWidth, 'important');
    }
    /* Pill fill */
    var pillFill = document.getElementById('efCfgPillFill');
    if (pillFill) {
      pillFill.style.width = (((visCur + 1) / visTotal) * 100) + '%';
    }
    /* Step number */
    var stepNum = document.getElementById('efCfgStepNum');
    if (stepNum) stepNum.textContent = visCur + 1;
    var stepTotalEl = document.getElementById('efCfgStepTotal');
    if (stepTotalEl) stepTotalEl.textContent = visTotal;

    if (window.innerWidth <= 599) {
      var nodesEl = progEl.querySelector('.ef-cfg-progress__nodes');
      var activeNode = progEl.querySelector('[data-step="' + curStep + '"]');
      if (nodesEl && activeNode) {
        var scrollPos = activeNode.offsetLeft - (nodesEl.offsetWidth / 2) + (activeNode.offsetWidth / 2);
        nodesEl.scrollTo({ left: scrollPos, behavior: 'smooth' });
      }
    }

    /* Sync luxury strip — visCur is current visible-step index, visTotal is total visible steps */
    var stripEl = document.getElementById('efCfgStrip');
    if (stripEl) {
      var segs = stripEl.querySelectorAll('.ef-cfg-strip__seg');
      /* Segment count was built in buildProgress() BEFORE populateSteps() decided which steps
         are skipped (_skipStep2 etc.) — rebuild segments when the visible count changes. (2026-07-01) */
      if (segs.length !== visTotal && visTotal > 0) {
        var _sh = '';
        for (var _si = 0; _si < visTotal; _si++) _sh += '<div class="ef-cfg-strip__seg" data-vis-step="' + _si + '"></div>';
        stripEl.innerHTML = _sh;
        var _sbT = document.getElementById('efPd2StepBarTrack');
        if (_sbT) {
          var _sbh = '';
          for (var _sj = 0; _sj < visTotal; _sj++) _sbh += '<div class="ef-pd2-stepbar__seg" data-vis-step="' + _sj + '"></div>';
          _sbT.innerHTML = _sbh;
        }
        segs = stripEl.querySelectorAll('.ef-cfg-strip__seg');
      }
      segs.forEach(function(seg, idx) {
        seg.classList.remove('is-done', 'is-active');
        if (idx < visCur) seg.classList.add('is-done');
        else if (idx === visCur) seg.classList.add('is-active');
      });
    }
  }

  /* ────────────────────────────────────
     RENDER OPTION CARDS
     ──────────────────────────────────── */
  function renderCards(field, container) {
    if (!groupData || !groupData[field]) {
      // Hide the group if no data
      var grp = container.closest('.ef-cfg-group');
      if (grp) grp.style.display = 'none';
      return;
    }
    /* Odyssey: uses Carolina option set but ships without:
         - glass / handle choices (per owner)
         - pattern (decorative panes — Odyssey is plain)
         - non-overlap fit types (Odyssey is Overlap Fit only)
       Glass/handle/pattern groups are hidden entirely. fit_type still renders
       but is filtered down to Overlap Fit only (handled in the fit_type filter
       block below — see _fitOverlapOnly). */
    if (isOdyssey && (field === 'glass' || field === 'handle' || field === 'pattern')) {
      var _ogrp = container.closest('.ef-cfg-group');
      if (_ogrp) _ogrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    /* All Glass: frameless steel doors — no handles (door operates via glass edge).
       Hide handle field entirely. */
    if (isAllGlass && field === 'handle') {
      var _aggrp = container.closest('.ef-cfg-group');
      if (_aggrp) _aggrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    /* Forged Iron Arch: hide handle + pattern entirely (per owner spec) */
    if (isForgedIronArch && (field === 'handle' || field === 'pattern')) {
      var _figrp = container.closest('.ef-cfg-group');
      if (_figrp) _figrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    /* EdgeLine (Inline Hinge): hide decorative pattern entirely (Inset-only per pricebook) */
    if (isEdgeline && field === 'pattern') {
      var _elgrp = container.closest('.ef-cfg-group');
      if (_elgrp) _elgrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    container.innerHTML = '';
    var _seen = {};
    var _pn = (matchedGroup || '').toLowerCase();

    /* ═══════════════════════════════════════════════════════════════
       FIT TYPE RULES (from Design Specialties Pricebook 2024)
       ─────────────────────────────────────────────────────────────
       overlap_only:  Met, Mantel/All Glass, Hudson, MKE Rail, Brookfield ZC
       inside_only:   Stiletto ZC, Silhouette ZC
       has_flush:     Carolina (all variants) — Masonry Only, +$175
       has_tight:     All steel doors (Carolina, Legend, Hammered Edge,
                      Madrid, Black Rock, Craftsman, Oak Tree, etc.)
       default:       Overlap + Inside (most aluminum & steel masonry)
       ═══════════════════════════════════════════════════════════════ */
    var _fitOverlapOnly = _pn.indexOf('met,') !== -1 || _pn === 'the met' ||
      (_pn.indexOf('met') !== -1 && _pn.indexOf('moderne') === -1 && _pn.indexOf('metro') === -1) ||
      _pn.indexOf('mantel') !== -1 || _pn.indexOf('hudson') !== -1 ||
      _pn.indexOf('mke rail') !== -1 ||
      (_pn.indexOf('brookfield') !== -1 && _pn.indexOf('zc') !== -1) ||
      _pn.indexOf('brookfield deluxe') !== -1 ||
      _pn.indexOf('cutback') !== -1;
    /* Odyssey: allows Overlap Fit + Inside Fit — handled by _fitInsideAndOverlapOnly below */
    var _fitInsideAndOverlapOnly = isOdyssey;
    var _fitInsideOnly = (_pn.indexOf('stiletto') !== -1 && _pn.indexOf('zc') !== -1) ||
      (_pn.indexOf('silhouette') !== -1 && _pn.indexOf('zc') !== -1);
    var _isCarolina = _pn.indexOf('carolina') !== -1;
    var _isAluminum = _pn.indexOf('stiletto') !== -1 || _pn.indexOf('silhouette') !== -1 ||
      _pn.indexOf('brookfield') !== -1 || _pn.indexOf('apex') !== -1 ||
      _pn.indexOf('bungalow') !== -1 || _pn.indexOf('savannah') !== -1 ||
      _pn.indexOf('cabot') !== -1 || _pn.indexOf('reflection') !== -1 ||
      _pn.indexOf('grande') !== -1 || _pn.indexOf('medio') !== -1;

    /* Brookfield Deluxe Magnetic = Factory Built only (magnetic mount installs
       inside ZC opening — no masonry application per pricebook). */
    var _isBrookfieldDeluxe = _pn.indexOf('brookfield deluxe') !== -1;

    var items = groupData[field].filter(function(opt) {
      if (field === 'fireplace_type' && _isBrookfieldDeluxe) {
        var ftlbl = opt.label.toLowerCase().trim();
        if (ftlbl.indexOf('masonry') !== -1) return false;
      }
      if (field === 'glass') {
        var lbl = opt.label.toLowerCase().trim();
        /* Ceramic Glass: only masonry (hide/show handled in selectCard fireplace_type) */
        /* Bevel Glass: DS shared option set — available ONLY for Black Rock.
           Madrid, Craftsman, Hammered Edge, Banded Scroll, Oak Tree, Napa Valley → hide bevel options. */
        if (lbl.indexOf('bevel') !== -1 && prodTitle.toLowerCase().indexOf('black rock') === -1) return false;
        /* EdgeLine (Inline Hinge): Pyro Ceramic not available (pricebook: Cabinet w/ Center Bar masonry only, NOT Inline) */
        if (isEdgeline && lbl.indexOf('pyro') !== -1) return false;
        /* Piccolo (DS shared option set): Black Glass not offered — hidden per owner 2026-07-15 */
        if (lbl.indexOf('black glass') !== -1 && /picc?ol+o/.test(prodTitle.toLowerCase())) return false;
      }
      /* Inside Fit available for BOTH DeepSet and EdgeLine (owner 2026-04-22) */
      if (field === 'mesh' && isArch) {
        /* Arch products: only Pull-Curtain mesh available (Black Mesh and Stainless Steel
           cannot be installed on a curved opening — their tracks are straight). */
        var mlbl = opt.label.toLowerCase().trim();
        if (mlbl.indexOf('black mesh') !== -1) return false;
        if (mlbl.indexOf('stainless') !== -1) return false;
      }
      if (field === 'door_type' && (isArch || isForgedIronArch)) {
        /* Arch products + Forged Iron Arch: only Clear-View Cabinet and Bi-Fold
           fit a curved opening. Hide Center Bar, AirSeal, Total View, Single
           Hinge, Fixed Door (rectangular-only constructs).
           Handles both legacy EF labels ('Cabinet', 'Bi-Fold') and Stoll-spec
           labels ('Cabinet Clear View', 'Bi-Fold Clear View'). */
        var dtlbl = opt.label.toLowerCase().trim();
        if (/airseal|center\s*bar|total\s*view|single\s*hinge|fixed/i.test(dtlbl)) return false;
        var _startsCabinet = /^cabinet\b/.test(dtlbl);
        var _startsBifold  = /^bi-?fold\b/.test(dtlbl) || dtlbl === 'trackless bi-fold';
        if (!_startsCabinet && !_startsBifold) return false;
      }
      if (field === 'fit_type') {
        var lbl = opt.label.toLowerCase().trim();
        /* Skip "Overlap Fit Only" label variant */
        if (lbl.indexOf('overlap fit only') !== -1) return false;
        /* Overlap-only products: hide Inside, Flush, Tight, Regular */
        if (_fitOverlapOnly && lbl.indexOf('overlap') === -1) return false;
        /* Inside-only products: hide Overlap, Flush, Tight, Regular */
        if (_fitInsideOnly && lbl.indexOf('inside') === -1) return false;
        /* Odyssey-style products: only Overlap Fit + Inside Fit (hide Flush, Tight, Regular) */
        if (_fitInsideAndOverlapOnly && lbl.indexOf('overlap') === -1 && lbl.indexOf('inside') === -1) return false;
        /* Flush Fit & Regular Fit: move to door_fit group for premium products */
        if (cfgType === 'cfg-custom-premium' && (lbl.indexOf('flush') !== -1 || lbl.indexOf('regular') !== -1)) return false;
        /* Flush Fit: only Carolina (non-premium) */
        if (lbl.indexOf('flush') !== -1 && !_isCarolina) return false;
        /* Regular Fit: only Carolina (non-premium) */
        if (lbl.indexOf('regular') !== -1 && !_isCarolina) return false;
        /* Tight Fitting: only steel doors (not aluminum) */
        if (lbl.indexOf('tight') !== -1 && _isAluminum) return false;
      }
      /* Deduplicate by label (Avis data has duplicates for some products) */
      var key = opt.label.toLowerCase().trim();
      if (_seen[key]) return false;
      _seen[key] = true;
      return true;
    });
    /* Arch products: ensure Fireplace Ceramic Glass is offered (Smithline/Old World groups
       lack it in source data — inject the shared DS surcharge variant). */
    if (field === 'glass' && isArch) {
      var _hasCeramic = items.some(function(it){ return (it.label || '').toLowerCase().indexOf('ceramic') !== -1; });
      if (!_hasCeramic) {
        items.push({
          label: 'Fireplace Ceramic Glass',
          price: 1785,
          variantId: '42373276565586',
          img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/beveled_amber_glass_with_zoom_magnifier.jpg?v=1776733306',
          desc: 'Withstands extreme heat — burn with doors closed'
        });
      }
    }

    if (!items.length) {
      var grp2 = container.closest('.ef-cfg-group');
      if (grp2) grp2.style.display = 'none';
      return;
    }
    // Show group and set grid columns based on count
    var grp3 = container.closest('.ef-cfg-group');
    if (grp3) grp3.style.display = '';
    container.className = 'ef-cfg-group__grid';
    /* Moderne (Slim/Original) Door Type: force 2-col layout — 4 large door illustrations
       look cramped at 3-col (3+1 layout). Other groups keep default 3-col for door_type. */
    var _isModerneDoorType = field === 'door_type' && matchedGroup === 'Fireplace Doors - Original Slim / Moderne';
    if (_isModerneDoorType) {
      /* default 2-col grid, no extra class needed */
    } else if (items.length === 3) container.classList.add('ef-cfg-group__grid--3');
    else if (items.length >= 4) container.classList.add('ef-cfg-group__grid--3');

    /* Fallback descriptions for options without desc */
    var fallbackDescs = {
      'Trackless Bi-Fold': 'Fully swing Bi-fold doors',
      'Bi-Fold': 'Fully swing Bi-fold doors',
      'Cabinet': 'Traditional hinged double doors',
      'Simplicity': 'Clean vertical bar',
      'Modern': 'Rectangular pull',
      'Birdcage': 'Ornate twisted design',
      'Infinity': 'Continuous loop handle',
      'Square': 'Angular modern pull',
      'Classic': 'Traditional curved handle',
      'Foundation': 'Solid minimal bar',
      'Contour': 'Ergonomic curved grip',
      'Rugged Steel': 'Hand-forged iron bar',
      'Contemporary': 'Sleek modern design',
      'Designer': 'Premium decorative handle',
      'Masonry': 'Traditional brick or stone fireplace',
      'Overlap Fit': 'Frame overlaps the opening edges',
      'Inside Fit': 'Frame sits inside the opening',
      'Regular Fit': 'Doors overlap the fireplace frame',
      'Flush Fit': 'Doors sit inside the fireplace frame',
      'Clear Glass': 'Standard clear tempered',
      'Grey': 'Tinted grey tempered',
      'Bronze': 'Tinted bronze tempered',
      'Black Glass': 'Tinted black tempered',
      'Wire Mesh Instead': 'Replaces glass with wire mesh',
      'Wire Mesh': 'Replaces glass with wire mesh',
      'Bevel Glass 1/2': 'Beveled edge tempered',
      'Bevel Glass 1': 'Wide beveled edge tempered',
      'No Mesh': 'Just glass doors',
      'Black Mesh': 'Pull-chain mesh',
      'Twin Gate': 'Two mesh doors',
      'Single Panel': 'Single mesh panel',
      'Stainless Steel': 'Premium stainless steel',
      'No Thank You': 'No draft control',
      'Yes': 'Add bottom draft control'
    };

    items.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-card' + (!opt.img ? ' ef-cfg-card--no-img' : '');
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('tabindex', '0');
      btn.dataset.field = field;
      /* Clean label: remove trailing periods, shorten long mesh/glass names */
      var cleanLabel = opt.label.replace(/\.\s*$/, '');
      /* Shorten labels: take only part before " - " */
      if (field === 'mesh' || field === 'glass') {
        cleanLabel = cleanLabel.split(' - ')[0].replace(/\[.*\]/, '').trim();
      }
      btn.dataset.value = cleanLabel;
      btn.dataset.surcharge = opt.price || 0;
      if (opt.variantId) btn.dataset.variantId = opt.variantId;

      /* Find description: prefer fallback if exists (shorter/cleaner), then data desc */
      var desc = '';
      for (var key in fallbackDescs) {
        if (cleanLabel.toLowerCase().indexOf(key.toLowerCase()) !== -1) {
          desc = fallbackDescs[key];
          break;
        }
      }
      if (!desc) desc = opt.desc || '';

      /* Arch products: override images with arch-specific illustrations.
         Covers: firebox_type (flush/hole), fit_type (overlap/inside),
         door_type (bi-fold/cabinet), mesh (depends on door_type selection). */
      var _imgSrc = opt.img;
      if (isArch) {
        var _ll = cleanLabel.toLowerCase();
        if (field === 'firebox_type') {
          if (_ll.indexOf('flush') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_flush_hearth_1.png?v=1776817368';
          } else if (_ll.indexOf('hole') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_hole_in_the_wall_2.png?v=1776817415';
          }
        } else if (field === 'fit_type') {
          if (_ll.indexOf('overlap') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_overlap.png?v=1776817368';
          } else if (_ll.indexOf('inside') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_inside.png?v=1776817368';
          }
        } else if (field === 'door_type') {
          if (_ll.indexOf('bi-fold') !== -1 || _ll.indexOf('bifold') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/glass_bi-fold_1.png?v=1776814923';
          } else if (_ll.indexOf('cabinet') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/glass_cabinet_1.png?v=1776814923';
          }
        } else if (field === 'mesh') {
          var _dp  = (selections.door_type || '').toLowerCase();
          var _bi  = _dp.indexOf('bi-fold') !== -1 || _dp.indexOf('bifold') !== -1;
          var _cab = _dp.indexOf('cabinet') !== -1;
          var _tw  = _ll.indexOf('twin gate') !== -1;
          var _one = _ll.indexOf('single panel') !== -1 || _ll.indexOf('one panel') !== -1;
          if (_bi && _tw)        _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bi-fold_twin_gate_mesh_1.png?v=1776814923';
          else if (_bi && _one)  _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bi-fold_one_panel_1.png?v=1776814923';
          else if (_cab && _tw)  _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/cabinet_twin_gate_mesh_1.png?v=1776814923';
          else if (_cab && _one) _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/cabinet_one_panel_1.png?v=1776814923';
        }
      }

      if (_imgSrc) {
        btn.classList.remove('ef-cfg-card--no-img');
        btn.classList.add('ef-cfg-card--has-preview');
      }

      var html = '<span class="ef-cfg-card__check">' + CHECK_SVG + '</span>';

      if (_imgSrc) {
        /* Zoom button — mobile tap-to-zoom. data-cfg-zoom attr matched by global click delegate */
        /* Span (not button) — nested <button> breaks the parent card's DOM tree.
           Click delegation matches data-cfg-zoom regardless of element type. */
        html += '<span class="ef-cfg-card__zoom" role="button" tabindex="0" aria-label="View larger image" data-cfg-zoom>'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>'
              + '</span>';
        html += '<span class="ef-cfg-card__img"><img src="' + _imgSrc.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'ef-cfg-img-broken\')"></span>';
        html += '<span class="ef-cfg-card__preview">'
              + '<img src="' + _imgSrc.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '">'
              + '<span class="ef-cfg-card__preview-label">' + escHtml(cleanLabel) + '</span>'
              + '</span>';
      }

      html += '<span class="ef-cfg-card__body">';
      /* EF_REC_BADGE_20260830 — merchandising hint ("Recommended") on an option card.
         Set by the Stoll handle override; never affects price or default selection. */
      if (opt.rec) {
        html += '<span class="ef-cfg-card__rec">' + escHtml(String(opt.rec)) + '</span>';
      }
      html += '<span class="ef-cfg-card__title">' + escHtml(cleanLabel) + '</span>';
      if (desc) {
        html += '<span class="ef-cfg-card__desc">' + escHtml(desc) + '</span>';
      }
      if (opt.price && opt.price > 0) {
        html += '<span class="ef-cfg-card__price">+$' + opt.price + '</span>';
      }
      html += '</span>';

      btn.innerHTML = html;
      /* Modal will read these from data attrs */
      if (_imgSrc) btn.dataset.imgFull = _imgSrc;
      btn.dataset.fullDesc = desc || '';
      btn.addEventListener('click', function(e) {
        /* Don't trigger card select when user tapped the zoom icon */
        if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
        selectCard(btn, field);
      });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(btn, field);
        }
      });
      container.appendChild(btn);
    });
  }

  function selectCard(btn, field) {
    var grid = btn.parentElement;
    /* Toggle off — second click on the already-selected card deselects.
       Useful for cosmetic options (finish, handle, draft control, mesh, pattern).
       For required fields (fit_type, door_type) the validateStep on Next will
       block advance until something is re-selected. */
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-pressed', 'false');
      delete selections[field];
      delete surcharges[field];
      /* Restore gallery ONLY for glass-screens that actually have a per-product glass
         preview for this label — never clobber a doors finish-preview swap. */
      if (field === 'glass') {
        try {
          var _gphX = (root && root.dataset && root.dataset.productHandle) || '';
          var _gmX  = (window.EF_SCREEN_FINISH_PREVIEWS && window.EF_SCREEN_FINISH_PREVIEWS[_gphX]) || null;
          if (_gmX && (_gmX['Grey'] || _gmX['Bronze'] || _gmX['Clear'])) efRestoreMainImage();
        } catch(e) {}
      }
      try { updatePrice(); } catch(e) {}
      return;
    }

    grid.querySelectorAll('.ef-cfg-card').forEach(function(c) {
      c.setAttribute('aria-checked', 'false');
      c.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true');
    btn.setAttribute('aria-pressed', 'true');

    selections[field] = btn.dataset.value;
    var surcharge = parseInt(btn.dataset.surcharge, 10) || 0;
    surcharges[field] = { amount: surcharge * 100, label: btn.dataset.value, variantId: btn.dataset.variantId || null };

    /* EF FUNNEL: option select (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_option_select', {
        step_name: stepNames[curStep] || '',
        option_type: field,
        option_label: btn.dataset.value || '',
        price_delta: surcharge || 0
      });
    } catch (e) {}

    /* Glass color → swap the gallery main image to the per-product tint preview
       (frameless full-glass screens). Keyed by product handle in EF_SCREEN_FINISH_PREVIEWS,
       same map used by finish swatches. Restores to the base photo if no preview exists
       (e.g. Black before its render is generated). */
    if (field === 'glass') {
      try {
        var _gph  = (root && root.dataset && root.dataset.productHandle) || '';
        var _gmap = (window.EF_SCREEN_FINISH_PREVIEWS && window.EF_SCREEN_FINISH_PREVIEWS[_gph]) || null;
        var _gp   = _gmap && _gmap[btn.dataset.value];
        /* A glass SCREEN is identified by glass-color keys in its per-product map
           (doors finish-preview maps never contain Clear/Grey/Bronze). Swap when the
           picked color has a render; for a glass screen color WITHOUT a render (Black,
           until generated) restore to the clear base — but NEVER touch the gallery on
           doors, where that would undo the finish-swatch preview swap. */
        var _isGlassScreenMap = _gmap && (_gmap['Grey'] || _gmap['Bronze'] || _gmap['Clear']);
        if (_gp) efSwapMainImage(_gp);
        else if (_isGlassScreenMap) efRestoreMainImage();
      } catch(e) {}
    }

    /* Update opening diagram when fireplace/firebox type changes */
    if (field === 'fireplace_type') { _openType.fp = btn.dataset.value; drawOpening(_openDims.w, _openDims.h); }
    if (field === 'firebox_type')   {
      _openType.fb = btn.dataset.value;
      drawOpening(_openDims.w, _openDims.h);
      /* Arch SVG dynamic hearth toggle:
         - Flush: hearth slab visible, floor at y=260 (level with hearth surface)
         - Hole-in-wall: hearth hidden, brick wall extends below firebox down to floor at y=292 */
      if (isArch) {
        var _isFlushArch = btn.dataset.value.toLowerCase().indexOf('flush') !== -1 ||
                           btn.dataset.value.toLowerCase().indexOf('hearth') !== -1;
        var _ah1 = document.getElementById('efArchHearthTop');
        var _ah2 = document.getElementById('efArchHearthEdge');
        var _afl = document.getElementById('efArchFloorLine');
        var _awb = document.getElementById('efArchWallBelow');
        if (_ah1) _ah1.setAttribute('opacity', _isFlushArch ? '1' : '0');
        if (_ah2) _ah2.setAttribute('opacity', _isFlushArch ? '1' : '0');
        if (_awb) _awb.setAttribute('opacity', _isFlushArch ? '0' : '1');
        if (_afl) {
          _afl.setAttribute('y1', _isFlushArch ? '260' : '292');
          _afl.setAttribute('y2', _isFlushArch ? '260' : '292');
        }
      }
    }

    /* Conditional logic: Fireplace Type affects Fit Type & Draft Control */
    if (field === 'fireplace_type') {
      var isFactory = btn.dataset.value.toLowerCase().indexOf('factory') !== -1 ||
                      btn.dataset.value.toLowerCase().indexOf('prefab') !== -1;

      /* Factory-Built → hide Inside Fit ONLY for DS aluminum products
         that are documented as Overlap Only in ZC/Factory-Built mode.
         Products not in this list keep both fit types for Factory-Built. */
      var _pnFit = (matchedGroup || '').toLowerCase();
      var _factoryOverlapOnly = ['brookfield'];
      var _shouldHideInside = _factoryOverlapOnly.some(function(n) { return _pnFit.indexOf(n) !== -1; });
      var _factoryInsideOnly = _pnFit.indexOf('stiletto') !== -1 && _pnFit.indexOf('cutback') === -1;
      var hideInsideFit = isFactory && _shouldHideInside;
      var hideOverlapFit = isFactory && _factoryInsideOnly;
      var fitCards = root.querySelectorAll('[data-field="fit_type"]');
      fitCards.forEach(function(c) {
        var cv = c.dataset.value.toLowerCase();
        var isInside = cv.indexOf('inside') !== -1;
        var isOverlap = cv.indexOf('overlap') !== -1;
        var shouldHide = (isInside && hideInsideFit) || (isOverlap && hideOverlapFit);
        c.style.display = shouldHide ? 'none' : '';
        if (shouldHide && c.getAttribute('aria-checked') === 'true') {
          c.setAttribute('aria-checked', 'false');
          c.setAttribute('aria-pressed', 'false');
          delete selections.fit_type;
          delete surcharges.fit_type;
        }
        if (hideInsideFit && isOverlap) {
          c.setAttribute('aria-checked', 'true');
          selections.fit_type = c.dataset.value;
          surcharges.fit_type = { amount: (parseInt(c.dataset.surcharge,10)||0)*100, label: c.dataset.value, variantId: c.dataset.variantId || null };
        }
        if (hideOverlapFit && isInside) {
          c.setAttribute('aria-checked', 'true');
          selections.fit_type = c.dataset.value;
          surcharges.fit_type = { amount: (parseInt(c.dataset.surcharge,10)||0)*100, label: c.dataset.value, variantId: c.dataset.variantId || null };
        }
      });
      /* Draft Control: masonry only — hide for factory-built/prefab */
      var draftGroup = root.querySelector('[data-group="draft_control"]');
      if (draftGroup && draftGroup.dataset.hasDraftControl === '1') {
        var showDC = !isFactory;
        draftGroup.style.display = showDC ? '' : 'none';
        if (!showDC) { delete selections.draft_control; delete surcharges.draft_control; }
      }

      /* Extras: Z-Tab is prefab/ZC only — re-evaluate now that we know the fireplace type. */
      try { updateExtrasVisibility(); } catch (e) {}

      /* Ceramic Glass: masonry only */
      var ceramicCards = root.querySelectorAll('[data-field="glass"]');
      ceramicCards.forEach(function(gc) {
        if (gc.dataset.value.toLowerCase().indexOf('ceramic') !== -1) {
          gc.style.display = isFactory ? 'none' : '';
          if (isFactory && gc.getAttribute('aria-checked') === 'true') {
            gc.setAttribute('aria-checked', 'false');
            gc.setAttribute('aria-pressed', 'false');
            delete selections.glass;
            delete surcharges.glass;
          }
        }
      });
    }

    /* Glass = Wire Mesh / Replace with Mesh → dim Mesh Screen group (mesh replaces glass, no extra screen needed).
       Cards stay visible but greyed out and non-interactive. Selection cleared. */
    if (field === 'glass') {
      var _glv = btn.dataset.value.toLowerCase();
      var _isWireMesh = _glv.indexOf('wire mesh') !== -1 ||
                        _glv.indexOf('replace with mesh') !== -1 ||
                        _glv.indexOf('replace glass') !== -1 ||
                        _glv.indexOf('mesh instead') !== -1;
      var meshGroup = root.querySelector('[data-group="mesh"]');
      if (meshGroup) {
        meshGroup.classList.toggle('ef-cfg-group--disabled', _isWireMesh);
        if (_isWireMesh) {
          meshGroup.querySelectorAll('.ef-cfg-card').forEach(function(mc) {
            mc.setAttribute('aria-checked', 'false');
            mc.setAttribute('aria-pressed', 'false');
          });
          delete selections.mesh;
          delete surcharges.mesh;
        }
      }
    }

    /* Arch: when door_type changes, re-render mesh cards so images switch
       between bi-fold and cabinet variants (renderCards reads selections.door_type). */
    if (field === 'door_type' && isArch) {
      var _archMeshGroup = root.querySelector('[data-group="mesh"]');
      var _archMeshGrid  = _archMeshGroup ? _archMeshGroup.querySelector('.ef-cfg-group__grid') : null;
      if (_archMeshGrid) {
        var _prevMesh = selections.mesh;
        renderCards('mesh', _archMeshGrid);
        if (_prevMesh) {
          _archMeshGrid.querySelectorAll('.ef-cfg-card').forEach(function(mc) {
            if (mc.dataset.value === _prevMesh) {
              mc.setAttribute('aria-checked', 'true');
              mc.setAttribute('aria-pressed', 'true');
            }
          });
        }
      }
    }

    /* Door type → mirror selected door image onto the "No Mesh" card
       (No Mesh = just glass doors, so its preview should match the chosen door style).
       For arch, runs after re-render so fresh cards get the mirror treatment too. */
    if (field === 'door_type') {
      var _dtImg = btn.querySelector('img');
      var _dtSrc = _dtImg ? _dtImg.getAttribute('src') : null;
      if (_dtSrc) {
        var _meshCards = root.querySelectorAll('[data-field="mesh"]');
        _meshCards.forEach(function(mc) {
          var _v = (mc.dataset.value || '').toLowerCase();
          if (_v.indexOf('no mesh') !== -1) {
            mc.querySelectorAll('img').forEach(function(im) { im.src = _dtSrc; });
          }
        });
      }
    }

    updatePrice();
  }

  /* ────────────────────────────────────
     RENDER FINISH SWATCHES
     ──────────────────────────────────── */
  function renderFinishes() {
    if (!groupData || !groupData.finish) return;

    var tabs = {};
    groupData.finish.forEach(function(f) {
      var cat = normCat(f.cat);
      if (!tabs[cat]) tabs[cat] = [];
      tabs[cat].push(f);
    });

    var tabEl = document.getElementById('efCfgFinishTabs');
    var gridEl = document.getElementById('efCfgSwatchGrid');
    tabEl.innerHTML = '';
    gridEl.innerHTML = '';

    var catKeys = Object.keys(tabs);
    if (!catKeys.length) return;

    var activeTab = catKeys[0];

    catKeys.forEach(function(cat) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-tab' + (cat === activeTab ? ' is-active' : '');
      btn.textContent = CAT_LABELS[cat] || cat;
      btn.dataset.cat = cat;
      btn.setAttribute('role', 'tab');
      btn.addEventListener('click', function() {
        hideSwatchPopup();
        tabEl.querySelectorAll('.ef-cfg-tab').forEach(function(t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        showSwatchesForCat(cat, gridEl);
      });
      tabEl.appendChild(btn);
    });

    showSwatchesForCat(activeTab, gridEl);
  }

  function showSwatchesForCat(cat, gridEl) {
    hideSwatchPopup();
    gridEl.innerHTML = '';
    /* Premium "why it costs more" reveal — only on the Premium tab. */
    var _pi = document.getElementById('efCfgPremiumInfo');
    if (_pi) { _pi.style.display = (cat === 'premium') ? 'block' : 'none'; }
    /* Plated "why it costs more" reveal — only on the Plated tab. */
    var _pl = document.getElementById('efCfgPlatedInfo');
    if (_pl) { _pl.style.display = (cat === 'plated') ? 'block' : 'none'; }
    if (!groupData || !groupData.finish) return;

    groupData.finish.forEach(function(f) {
      if (normCat(f.cat) !== cat) return;

      var btn = document.createElement('button');
      btn.className = 'ef-cfg-swatch';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-checked', selections.finish === f.label ? 'true' : 'false');
      btn.setAttribute('aria-pressed', selections.finish === f.label ? 'true' : 'false');
      btn.setAttribute('aria-label', f.label + (f.price > 0 ? ', plus $' + f.price : ', included'));
      btn.setAttribute('tabindex', '0');
      btn.dataset.label = f.label;
      btn.dataset.surcharge = f.price || 0;
      btn.dataset.cat = f.cat || 'powder_coat';
      if (f.variantId) btn.dataset.variantId = f.variantId;

      var circle = document.createElement('span');
      circle.className = 'ef-cfg-swatch__circle';
      if (f.img) circle.style.backgroundImage = 'url(' + f.img.replace(/ /g, '%20') + ')';
      else circle.style.background = '#333';

      var tooltip = document.createElement('span');
      tooltip.className = 'ef-cfg-swatch__tooltip';
      tooltip.innerHTML = escHtml(f.label) + '<br>' + (f.price > 0 ? '+' + money(f.price * 100) : 'Included');

      btn.appendChild(circle);
      btn.appendChild(tooltip);

      btn.addEventListener('click', function() { selectSwatch(btn, f); });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectSwatch(btn, f); }
      });
      /* mouseenter / mouseleave only meaningful on hover-capable devices.
         On touch devices iOS Safari fires simulated mouseenter on tap → click,
         then mouseleave when finger lifts — which would auto-hide the popup
         we just showed via selectSwatch. Gate by (hover: hover). */
      btn.addEventListener('mouseenter', function(e) {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          showSwatchPopup(btn, f);
        }
      });
      btn.addEventListener('mouseleave', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          hideSwatchPopup();
        }
      });

      gridEl.appendChild(btn);
    });
  }

  /* ────────────────────────────────────
     FINISH SAMPLES — multi-select grid + ATC ($10 each, $10 promo per sample)
     Backend: requires Shopify product "Door Finish Sample" at $10.
     Replace DOOR_SAMPLE_VARIANT_ID below with the real variant ID.
     ──────────────────────────────────── */
  function renderSamples() {
    var grid = document.getElementById('efCfgSamplesGrid');
    if (!grid) return;
    if (!groupData || !groupData.finish || !groupData.finish.length) return;

    var DOOR_SAMPLE_VARIANT_ID = '42380268535890'; /* Fireplace Door Finish Sample — handle: fireplace-door-finish-sample */
    var SAMPLE_PRICE = 10;
    var selectedSamples = {}; /* { label: { label, img } } */

    /* Build cards from all finishes available for this product */
    grid.innerHTML = groupData.finish.map(function(f) {
      var bgStyle = f.img
        ? 'background-image:url(' + f.img.replace(/ /g, '%20') + ');'
        : 'background-color:#888;';
      var safeLabel = (f.label || '').replace(/"/g, '&quot;');
      return '<button type="button" class="ef-cfg-samples-card" data-label="' + safeLabel + '" aria-pressed="false">' +
        '<span class="ef-cfg-samples-card__swatch" style="' + bgStyle + '"></span>' +
        '<span class="ef-cfg-samples-card__name">' + escHtml(f.label || '') + '</span>' +
      '</button>';
    }).join('');

    var countEl = document.getElementById('efCfgSamplesCount');
    var totalEl = document.getElementById('efCfgSamplesTotal');
    var atcBtn = document.getElementById('efCfgSamplesAtc');
    if (!countEl || !totalEl || !atcBtn) return;

    function updateBar() {
      var n = Object.keys(selectedSamples).length;
      /* UX/a11y rec 2026-05-03 — never start the CTA disabled at $0 (reads as
         broken, no SR explanation). Stays enabled; if user taps with 0 selected
         we focus the grid + show inline nudge. Count copy adapts so the bar
         doesn't read "0 selected · $0" (dead-end energy). */
      if (n === 0) {
        countEl.textContent = 'Tap a swatch to start';
        totalEl.textContent = '';
      } else {
        countEl.textContent = n + ' selected';
        totalEl.textContent = '$' + (n * SAMPLE_PRICE).toLocaleString('en-US');
      }
      atcBtn.disabled = false;
      atcBtn.removeAttribute('disabled');
    }

    /* Build a label → swatch-url lookup so we can pass the swatch image as a
       hidden line-item property — cart drawer reads it to render the actual
       finish color instead of the generic sample-product image. */
    var swatchByLabel = {};
    groupData.finish.forEach(function (f) {
      if (f && f.label) swatchByLabel[f.label] = f.img || '';
    });

    grid.addEventListener('click', function(e) {
      var card = e.target.closest('.ef-cfg-samples-card');
      if (!card) return;
      var label = card.getAttribute('data-label');
      if (selectedSamples[label]) {
        delete selectedSamples[label];
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
      } else {
        selectedSamples[label] = { label: label, img: swatchByLabel[label] || '' };
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
      }
      updateBar();
    });

    var atcDefaultHTML = 'Add Samples <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';

    atcBtn.addEventListener('click', function() {
      var labels = Object.keys(selectedSamples);
      if (!labels.length) {
        /* Inline nudge instead of silent disabled state — focus grid + flash hint. */
        countEl.textContent = 'Tap a swatch above to add';
        countEl.style.color = '#8A6A43';
        countEl.style.fontWeight = '600';
        var firstCard = grid.querySelector('.ef-cfg-samples-card');
        if (firstCard) firstCard.focus();
        setTimeout(function () {
          countEl.style.color = '';
          countEl.style.fontWeight = '';
          updateBar();
        }, 1800);
        return;
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      /* Each sample = its own line item with finish-name property so the order
         shows "Finish: Bronze Burst" etc. for fulfillment to ship the right swatch. */
      var sampleConfigId = 'sample-' + Date.now().toString(36);
      var items = labels.map(function(n) {
        var props = {
          'Finish': n,
          '_sample_set_id': sampleConfigId
        };
        /* Property name matches what ef-cart-drawer.js expects (line 113). */
        var swatchUrl = (selectedSamples[n] && selectedSamples[n].img) || swatchByLabel[n];
        if (swatchUrl) props._finish_image = swatchUrl;
        return {
          id: parseInt(DOOR_SAMPLE_VARIANT_ID),
          quantity: 1,
          properties: props
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { if (!r.ok) throw new Error('cart error'); return r.json(); })
      .then(function() {
        atcBtn.style.background = '#8A6A43';
        atcBtn.innerHTML = 'Added &#10003;';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        /* Open EF custom cart drawer (same as main ATC) — never Prestige's <cart-drawer>,
           which has different fonts/styling and was causing visual inconsistency. */
        if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') {
          window.EFCartDrawer.open();
        }
        setTimeout(function() {
          atcBtn.disabled = true;
          atcBtn.style.background = '';
          atcBtn.innerHTML = atcDefaultHTML;
          selectedSamples = {};
          grid.querySelectorAll('.ef-cfg-samples-card.is-selected').forEach(function(c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
          updateBar();
        }, 1200);
      })
      .catch(function() {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Error — try again';
        setTimeout(function() {
          atcBtn.innerHTML = atcDefaultHTML;
        }, 2000);
      });
    });

    updateBar();
  }

  /* ────────────────────────────────────
     EF FINISH PREVIEW — main gallery image swap on swatch click.
     Helpers swap #efGallerySwiper's first slide image to finish.previewImg
     and restore on deselect. Defensive — wrapped in try/catch so absence
     of gallery never breaks configurator.
     ──────────────────────────────────── */
  function efGalleryFirstImg() {
    try { return document.querySelector('#efGallerySwiper .swiper-slide:first-child picture img, #efGallerySwiper .swiper-slide:first-child img'); }
    catch(e) { return null; }
  }
  function efSwapMainImage(previewUrl) {
    var img = efGalleryFirstImg();
    if (!img || !previewUrl) return;
    if (!img.dataset.efOriginalSrc) {
      img.dataset.efOriginalSrc = img.getAttribute('src') || '';
      img.dataset.efOriginalSrcset = img.getAttribute('srcset') || '';
    }
    /* 2026-06-05 — serve an optimized image via Shopify CDN transform (width cap → ~80KB,
       webp auto-negotiated) instead of the full-size original (the finish previews were
       uploaded at full res). Skip if the URL already carries a width/height transform. */
    var _opt = previewUrl;
    if (_opt && !/[?&](width|height)=/.test(_opt)) _opt += (_opt.indexOf('?') > -1 ? '&' : '?') + 'width=1100';
    img.setAttribute('src', _opt);
    img.setAttribute('srcset', _opt);
    /* 2026-06-05 — jump the gallery to slide 1 so the customer SEES the finish swap even
       if they're currently viewing another photo (the swap only touches the first slide). */
    try { var _sw = document.getElementById('efGallerySwiper'); if (_sw && _sw.swiper && _sw.swiper.activeIndex !== 0) _sw.swiper.slideTo(0); } catch(e) {}
  }
  function efRestoreMainImage() {
    var img = efGalleryFirstImg();
    if (!img || !img.dataset.efOriginalSrc) return;
    img.setAttribute('src', img.dataset.efOriginalSrc);
    if (img.dataset.efOriginalSrcset) img.setAttribute('srcset', img.dataset.efOriginalSrcset);
    else img.removeAttribute('srcset');
  }

  /* Mobile inline live finish preview — cross-fade the door-in-this-finish image right at the
     swatches (the gallery swap is off-screen on phones/tablets). Only ~60% of door lines have a
     finish render, so this is shown ONLY when a preview URL exists; otherwise it's hidden (no
     broken image). Stateless A/B layer via the .is-shown class. 2026-06-25. */
  function efCfgLivePreview(src, name) {
    var lp = document.getElementById('efCfgFinishLivePreview');
    if (!lp) return;
    if (!src) { lp.hidden = true; return; }
    var imgA = document.getElementById('efCfgFinishLiveImgA');
    var imgB = document.getElementById('efCfgFinishLiveImgB');
    var tag = document.getElementById('efCfgFinishLiveTag');
    var opt = src;
    if (opt && !/[?&](width|height)=/.test(opt)) opt += (opt.indexOf('?') > -1 ? '&' : '?') + 'width=900';
    lp.hidden = false;
    var aShown = imgA.classList.contains('is-shown');
    var next = aShown ? imgB : imgA, cur = aShown ? imgA : imgB;
    function reveal() { next.classList.add('is-shown'); cur.classList.remove('is-shown'); }
    if (next.getAttribute('src') === opt) { reveal(); }
    else { next.onload = reveal; next.src = opt; }
    if (tag) tag.textContent = name || '';
  }

  function selectSwatch(btn, finishData) {
    /* Toggle off — second click on already-selected swatch deselects.
       Same UX as selectCard. validateStep on Next blocks advance if finish
       is required and nothing's selected. */
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-pressed', 'false');
      delete selections.finish;
      delete surcharges.finish;
      try { recomputeHardwareSurcharge(); } catch (e) {}
      try { var _efRo = document.getElementById('efCfg'); if (_efRo) { _efRo.dataset.finishChip = ''; } } catch (e) {}
      var prevHide = document.getElementById('efCfgFinishPreview');
      if (prevHide) prevHide.classList.remove('is-visible');
      try { hideSwatchPopup(); } catch(e) {}
      try { updatePrice(); } catch(e) {}
      try { efRestoreMainImage(); } catch(e) {}
      try { efCfgLivePreview(null); } catch(e) {}
      return;
    }

    var finishGrid = document.getElementById('efCfgSwatchGrid');
    finishGrid.querySelectorAll('.ef-cfg-swatch').forEach(function(s) {
      s.setAttribute('aria-checked', 'false');
      s.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true');
    btn.setAttribute('aria-pressed', 'true');

    selections.finish = finishData.label;
    /* Capture the selected finish's appearance for the Review chip (robust against grid
       re-renders). url('...') for textured finishes, flat #333 for color-only ones. */
    try { var _efR = document.getElementById('efCfg'); if (_efR) { _efR.dataset.finishChip = finishData.img ? ("url('" + finishData.img.replace(/ /g, '%20').replace(/'/g, '%27') + "')") : '#333'; } } catch (e) {}
    surcharges.finish = {
      amount: (finishData.price || 0) * 100,
      label: finishData.label,
      variantId: finishData.variantId || null
    };

    /* EF FUNNEL: finish select (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_option_select', {
        step_name: stepNames[curStep] || '',
        option_type: 'finish',
        option_label: finishData.label || '',
        price_delta: finishData.price || 0
      });
    } catch (e) {}

    // Update preview
    var prev = document.getElementById('efCfgFinishPreview');
    prev.classList.add('is-visible');
    document.getElementById('efCfgFinishPreviewSwatch').style.backgroundImage = finishData.img ? 'url(' + finishData.img.replace(/ /g, '%20') + ')' : '';
    document.getElementById('efCfgFinishPreviewName').textContent = finishData.label;
    document.getElementById('efCfgFinishPreviewPrice').textContent = finishData.price > 0 ? '+' + money(finishData.price * 100) : 'Included';

    // EF FINISH PREVIEW — swap gallery main image if previewImg available
    try {
      /* 2026-06-04 — PER-PRODUCT finish previews. Multiple screen products share one cfg
         data file (e.g. 4 Carolina screens share screen-carolina-single-panel), but each has
         a different base photo, so the swap image must be per product. window.EF_SCREEN_FINISH_PREVIEWS
         is keyed by product handle -> { finishLabel: url } and overrides the data file's previewImg. */
      var _ph = (root && root.dataset && root.dataset.productHandle) || '';
      var _pmap = (window.EF_SCREEN_FINISH_PREVIEWS && window.EF_SCREEN_FINISH_PREVIEWS[_ph]) || null;
      /* Tri-fold screens have no per-product finish renders; the shared data-file previewImg points at
         a single-panel Carolina photo, which is wrong here. Only swap when a REAL per-product override
         exists — otherwise keep the product's own gallery (the 3D preview already recolors). (2026-07-01) */
      var _isTF = !!(groupData && groupData.side_panel && groupData.side_panel.length);
      var _preview = (_pmap && _pmap[finishData.label]) || (_isTF ? null : finishData.previewImg);
      if (_preview) efSwapMainImage(_preview); else efRestoreMainImage();
      /* Mobile inline live preview — shows ONLY when this finish has a render (~60% of lines) */
      try { efCfgLivePreview(_preview || null, finishData.label); } catch(e) {}
    } catch(e) {}

    // Frame color changed → re-evaluate two-tone hardware surcharge (auto-clears if now equal).
    try { recomputeHardwareSurcharge(); } catch(e) {}

    updatePrice();

    /* Re-position popup AFTER price updates — Artisan/Premium surcharges
       change the price-section height above the grid, which shifts swatch
       position. Calculating popup before layout settles puts it off-screen. */
    requestAnimationFrame(function() {
      try { showSwatchPopup(btn, finishData); } catch(e) {}
    });
  }

  /* ── Style Finish (same swatches, all free, in Style step) ── */
  function renderStyleFinishes() {
    if (!groupData || !groupData.style_finish) return;
    var sfGrp = root.querySelector('[data-group="style_finish"]');
    if (!sfGrp) return;
    sfGrp.style.display = '';
    var ffLabel = document.getElementById('efCfgFrameFinishLabel');
    if (ffLabel) ffLabel.style.display = '';

    var tabs = {};
    groupData.style_finish.forEach(function(f) {
      var cat = normCat(f.cat);
      if (!tabs[cat]) tabs[cat] = [];
      tabs[cat].push(f);
    });

    var tabEl = document.getElementById('efCfgStyleFinishTabs');
    var gridEl = document.getElementById('efCfgStyleFinishGrid');
    tabEl.innerHTML = '';
    gridEl.innerHTML = '';

    var catKeys = Object.keys(tabs);
    if (!catKeys.length) return;
    var activeTab = catKeys[0];

    catKeys.forEach(function(cat) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-tab' + (cat === activeTab ? ' is-active' : '');
      btn.textContent = CAT_LABELS[cat] || cat;
      btn.dataset.cat = cat;
      btn.setAttribute('role', 'tab');
      btn.addEventListener('click', function() {
        hideSwatchPopup();
        tabEl.querySelectorAll('.ef-cfg-tab').forEach(function(t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        showStyleSwatchesForCat(cat, gridEl);
      });
      tabEl.appendChild(btn);
    });
    showStyleSwatchesForCat(activeTab, gridEl);
  }

  function showStyleSwatchesForCat(cat, gridEl) {
    hideSwatchPopup();
    gridEl.innerHTML = '';
    if (!groupData || !groupData.style_finish) return;
    groupData.style_finish.forEach(function(f) {
      if (normCat(f.cat) !== cat) return;
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-swatch';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-checked', selections.style_finish === f.label ? 'true' : 'false');
      btn.setAttribute('aria-pressed', selections.style_finish === f.label ? 'true' : 'false');
      btn.setAttribute('aria-label', f.label + ', included');
      btn.setAttribute('tabindex', '0');
      btn.dataset.label = f.label;
      btn.dataset.surcharge = 0;
      btn.dataset.cat = f.cat || 'powder_coat';

      var circle = document.createElement('span');
      circle.className = 'ef-cfg-swatch__circle';
      if (f.img) circle.style.backgroundImage = 'url(' + f.img.replace(/ /g, '%20') + ')';
      else circle.style.background = '#333';

      var tooltip = document.createElement('span');
      tooltip.className = 'ef-cfg-swatch__tooltip';
      tooltip.innerHTML = escHtml(f.label) + '<br>Included';

      btn.appendChild(circle);
      btn.appendChild(tooltip);
      btn.addEventListener('click', function() { selectStyleSwatch(btn, f); });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectStyleSwatch(btn, f); }
      });
      btn.addEventListener('mouseenter', function(e) {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          showSwatchPopup(btn, f);
        }
      });
      btn.addEventListener('mouseleave', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          hideSwatchPopup();
        }
      });
      gridEl.appendChild(btn);
    });
  }

  function selectStyleSwatch(btn, finishData) {
    /* Toggle off — second click on already-selected swatch deselects */
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-pressed', 'false');
      delete selections.style_finish;
      delete surcharges.style_finish;
      var prevHide = document.getElementById('efCfgStyleFinishPreview');
      if (prevHide) prevHide.classList.remove('is-visible');
      try { hideSwatchPopup(); } catch(e) {}
      try { updatePrice(); } catch(e) {}
      return;
    }

    var gridEl = document.getElementById('efCfgStyleFinishGrid');
    gridEl.querySelectorAll('.ef-cfg-swatch').forEach(function(s) {
      s.setAttribute('aria-checked', 'false');
      s.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true');
    btn.setAttribute('aria-pressed', 'true');
    selections.style_finish = finishData.label;
    surcharges.style_finish = { amount: 0, label: finishData.label, variantId: null };

    var prev = document.getElementById('efCfgStyleFinishPreview');
    if (prev) {
      prev.style.display = '';
      prev.classList.add('is-visible');
      document.getElementById('efCfgStyleFinishPreviewSwatch').style.backgroundImage = finishData.img ? 'url(' + finishData.img.replace(/ /g, '%20') + ')' : '';
      document.getElementById('efCfgStyleFinishPreviewName').textContent = finishData.label;
      document.getElementById('efCfgStyleFinishPreviewPrice').textContent = 'Included';
    }
    updatePrice();
    /* Re-position popup AFTER price updates — same fix as selectSwatch. */
    requestAnimationFrame(function() {
      try { showSwatchPopup(btn, finishData); } catch(e) {}
    });
  }

  /* ── HARDWARE FINISH (two-tone) — 2026-06-06 ───────────────────────────────
     Forge Iron only. Customer can give hinges/handles a different color than the
     frame. "Match Frame" = included; any other color = +$75 two-tone surcharge
     (real hidden variant so the cart subtotal stays honest). The surcharge is
     recomputed whenever EITHER the hardware OR the frame finish changes, so it
     auto-clears if the two colors end up equal. */
  var HW_TWOTONE_VARIANT_ID = '42437260771410';
  var HW_TWOTONE_PRICE = 75; // dollars — edit here + on the Shopify variant to change

  function recomputeHardwareSurcharge() {
    var hw = selections.hardware_finish;
    // Not chosen, or explicitly matching the frame → included, no line item.
    if (!hw || hw === '__match__' || hw === selections.finish) {
      delete surcharges.hardware_finish;
    } else {
      surcharges.hardware_finish = {
        amount: HW_TWOTONE_PRICE * 100,
        label: 'Hardware: ' + hw + ' (two-tone)',
        variantId: HW_TWOTONE_VARIANT_ID
      };
    }
    var prev = document.getElementById('efCfgHardwarePreview');
    var priceEl = document.getElementById('efCfgHardwarePreviewPrice');
    if (priceEl) {
      priceEl.textContent = surcharges.hardware_finish ? '+' + money(HW_TWOTONE_PRICE * 100) : 'Included';
    }
    if (prev && hw) { prev.style.display = ''; prev.classList.add('is-visible'); }
  }

  function renderHardwareFinishes() {
    if (!groupData || !groupData.hardware_finish || !groupData.hardware_finish.length) return;
    var grp = document.getElementById('efCfgHardwareGroup');
    var gridEl = document.getElementById('efCfgHardwareGrid');
    if (!grp || !gridEl) return;
    grp.style.display = '';
    gridEl.innerHTML = '';

    function addSwatch(label, img, isMatch) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-swatch' + (isMatch ? ' ef-cfg-swatch--match' : '');
      btn.setAttribute('type', 'button');
      var checked = isMatch ? (!selections.hardware_finish || selections.hardware_finish === '__match__')
                            : (selections.hardware_finish === label);
      btn.setAttribute('aria-checked', checked ? 'true' : 'false');
      btn.setAttribute('aria-pressed', checked ? 'true' : 'false');
      btn.setAttribute('aria-label', label + (isMatch ? ', included' : ', +' + money(HW_TWOTONE_PRICE * 100)));
      btn.setAttribute('tabindex', '0');
      btn.dataset.label = isMatch ? '__match__' : label;

      var circle = document.createElement('span');
      circle.className = 'ef-cfg-swatch__circle';
      if (isMatch) {
        circle.style.background = 'linear-gradient(135deg,#1E1E1B 0 50%,#C9C9C9 50% 100%)';
      } else if (img) {
        circle.style.backgroundImage = 'url(' + img.replace(/ /g, '%20') + ')';
      } else {
        circle.style.background = '#333';
      }

      var tooltip = document.createElement('span');
      tooltip.className = 'ef-cfg-swatch__tooltip';
      tooltip.innerHTML = escHtml(label) + '<br>' + (isMatch ? 'Included' : '+' + money(HW_TWOTONE_PRICE * 100));

      btn.appendChild(circle);
      btn.appendChild(tooltip);
      var data = { label: isMatch ? '__match__' : label, img: img, isMatch: !!isMatch, displayLabel: label };
      /* Popup-data shape matches showSwatchPopup (label/img/price). Match Frame = $0/Included. */
      var popData = { label: label, img: img, price: isMatch ? 0 : HW_TWOTONE_PRICE };
      btn.addEventListener('click', function() { selectHardwareSwatch(btn, data); });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectHardwareSwatch(btn, data); }
      });
      btn.addEventListener('mouseenter', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) { try { showSwatchPopup(btn, popData); } catch(e) {} }
      });
      btn.addEventListener('mouseleave', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) { try { hideSwatchPopup(); } catch(e) {} }
      });
      gridEl.appendChild(btn);
    }

    addSwatch('Match Frame', null, true);
    groupData.hardware_finish.forEach(function(f) { addSwatch(f.label, f.img, false); });

    // Default to Match Frame (included) so the state is always defined.
    if (!selections.hardware_finish) selections.hardware_finish = '__match__';
    recomputeHardwareSurcharge();
  }

  function selectHardwareSwatch(btn, data) {
    var gridEl = document.getElementById('efCfgHardwareGrid');
    if (gridEl) gridEl.querySelectorAll('.ef-cfg-swatch').forEach(function(s) {
      s.setAttribute('aria-checked', 'false'); s.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true');
    btn.setAttribute('aria-pressed', 'true');

    selections.hardware_finish = data.isMatch ? '__match__' : data.label;

    var prev = document.getElementById('efCfgHardwarePreview');
    if (prev) {
      prev.style.display = '';
      prev.classList.add('is-visible');
      var sw = document.getElementById('efCfgHardwarePreviewSwatch');
      if (sw) {
        if (data.isMatch) sw.style.backgroundImage = '', sw.style.background = 'linear-gradient(135deg,#1E1E1B 0 50%,#C9C9C9 50% 100%)';
        else sw.style.background = '', sw.style.backgroundImage = data.img ? 'url(' + data.img.replace(/ /g, '%20') + ')' : '';
      }
      var nm = document.getElementById('efCfgHardwarePreviewName');
      if (nm) nm.textContent = data.isMatch ? 'Match Frame' : data.label;
    }
    recomputeHardwareSurcharge();
    try { updatePrice(); } catch(e) {}

    /* Show the same 1:1 swatch popup as Frame Finish (after price/layout settles). */
    var popData = { label: data.isMatch ? 'Match Frame' : data.label, img: data.img, price: data.isMatch ? 0 : HW_TWOTONE_PRICE };
    requestAnimationFrame(function() { try { showSwatchPopup(btn, popData); } catch(e) {} });
  }

  /* ── Swatch Popup ── */
  /* Top-3 popular finishes (by % of orders, derived from sales data). */
  var EF_POPULAR_FINISHES = {
    'matte black':       { rank: 1, pct: 47 },
    'textured black':    { rank: 2, pct: 18 },
    'charcoal':          { rank: 3, pct: 11 }
  };
  function showSwatchPopup(btn, f) {
    var popup = document.getElementById('efCfgSwatchPopup');
    var img = popup.querySelector('.ef-cfg-swatch-popup__img');
    var name = popup.querySelector('.ef-cfg-swatch-popup__name');
    var price = popup.querySelector('.ef-cfg-swatch-popup__price');
    var badge = document.getElementById('efCfgSwatchPopupBadge');
    var stat  = document.getElementById('efCfgSwatchPopupStat');

    if (f.img) {
      img.src = f.img.replace(/ /g, '%20');
      img.alt = f.label;
      img.style.display = '';
    } else {
      img.style.display = 'none';
    }
    name.textContent = f.label;
    price.textContent = f.price > 0 ? '+' + money(f.price * 100) : 'Included';

    /* Populate badge + stat for popular finishes */
    var key = (f.label || '').toLowerCase().trim();
    var pop = EF_POPULAR_FINISHES[key];
    if (badge && stat) {
      if (pop) {
        badge.hidden = false;
        stat.hidden = false;
        stat.textContent = 'Used in ' + pop.pct + '% of orders';
      } else {
        badge.hidden = true;
        stat.hidden = true;
      }
    }

    // Position popup near the swatch (absolute positioning relative to root).
    // Popup scrolls with the page; low z-index lets it slide under the header
    // and sticky ATC bar when scrolled past them.
    // 2026-05-06 fix: was using hardcoded popupW=220, popupH=300 — but actual
    // popup is 150px wide and ~200px tall. With H=300 the popup floated 300px
    // above the swatch instead of "right above the circle". Now measure live
    // dimensions after content + visibility paint, so close-positioning
    // works regardless of popup content height (badge / stat optional rows).
    popup.style.visibility = 'hidden';
    popup.classList.add('is-visible');
    var popupW = popup.offsetWidth || 150;
    var popupH = popup.offsetHeight || 200;
    var rect = btn.getBoundingClientRect();
    var rootRect = root.getBoundingClientRect();
    var left = rect.left - rootRect.left + rect.width / 2 - popupW / 2;
    left = Math.max(8, Math.min(left, rootRect.width - popupW - 8));
    var top = rect.top - rootRect.top - popupH - 10;
    // If not enough space above, show below the swatch
    if (top < 8) top = rect.bottom - rootRect.top + 10;

    popup.style.left = left + 'px';
    popup.style.top = top + 'px';
    popup.style.bottom = 'auto';
    popup.style.visibility = '';

    /* 2026-06-02 — TOUCH auto-dismiss. Touch devices never fire mouseleave, so the
       swatch popup used to stay on screen after a finish tap and block the rest of the
       order form. On touch we dismiss it on the next scroll, on a tap outside a swatch,
       and after a short timeout — informs briefly, never covers the form. */
    var isTouch = !(window.matchMedia && window.matchMedia('(hover: hover)').matches);
    if (isTouch) {
      clearTimeout(_swatchPopupTimer);
      _swatchPopupTimer = setTimeout(hideSwatchPopup, 1900);
      var dismiss = function (e) {
        if (e && e.type === 'touchstart' && e.target && e.target.closest && e.target.closest('.ef-cfg-swatch')) return;
        hideSwatchPopup();
      };
      window.addEventListener('scroll', dismiss, { capture: true, once: true, passive: true });
      document.addEventListener('touchstart', dismiss, { capture: true, once: true, passive: true });
    }
  }

  var _swatchPopupTimer = null;
  function hideSwatchPopup() {
    clearTimeout(_swatchPopupTimer);
    document.getElementById('efCfgSwatchPopup').classList.remove('is-visible');
  }

  /* ────────────────────────────────────
     POPULATE ALL STEPS
     ──────────────────────────────────── */
  function renderDoorFitCards(items, container) {
    if (!container) return;
    container.innerHTML = '';
    var descs = {
      'Regular Fit': 'Doors overlap the fireplace frame',
      'Flush Fit': 'Doors sit inside the fireplace frame'
    };
    items.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-card' + (!opt.img ? ' ef-cfg-card--no-img' : '');
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('tabindex', '0');
      btn.dataset.field = 'door_fit';
      var cleanLabel = opt.label.replace(/\.\s*$/, '');
      btn.dataset.value = cleanLabel;
      btn.dataset.surcharge = opt.price || 0;
      if (opt.variantId) btn.dataset.variantId = opt.variantId;
      var desc = descs[cleanLabel] || opt.desc || '';
      if (opt.img) btn.classList.add('ef-cfg-card--has-preview');
      var html = '<span class="ef-cfg-card__check">' + CHECK_SVG + '</span>';
      if (opt.img) {
        /* Span (not button) — nested <button> breaks the parent card's DOM tree.
           Click delegation matches data-cfg-zoom regardless of element type. */
        html += '<span class="ef-cfg-card__zoom" role="button" tabindex="0" aria-label="View larger image" data-cfg-zoom>'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>'
              + '</span>';
        html += '<span class="ef-cfg-card__img"><img src="' + opt.img.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'ef-cfg-img-broken\')"></span>';
        html += '<span class="ef-cfg-card__preview">'
              + '<img src="' + opt.img.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '">'
              + '<span class="ef-cfg-card__preview-label">' + escHtml(cleanLabel) + '</span>'
              + '</span>';
      }
      html += '<span class="ef-cfg-card__body">';
      html += '<span class="ef-cfg-card__title">' + escHtml(cleanLabel) + '</span>';
      if (desc) html += '<span class="ef-cfg-card__desc">' + escHtml(desc) + '</span>';
      if (opt.price && opt.price > 0) html += '<span class="ef-cfg-card__price">+$' + opt.price + '</span>';
      html += '</span>';
      btn.innerHTML = html;
      if (opt.img) btn.dataset.imgFull = opt.img;
      btn.dataset.fullDesc = desc || '';
      btn.addEventListener('click', function(e) {
        if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
        selectCard(btn, 'door_fit');
      });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(btn, 'door_fit'); }
      });
      container.appendChild(btn);
    });
    container.className = 'ef-cfg-group__grid';
    if (items.length <= 2) container.classList.add('ef-cfg-group__grid--2col');
  }

  /* ════════════════════════════════════════════════════════════════════════
     EXTRAS — optional multi-select add-ons (EF_STOLL_EXTRAS_20260829)

     Stoll order forms carry a block of per-order add-ons that were not sellable
     on the site: Key Lock $205, Z-Tab $70, Flange up to 3" $135 / over 3" $275,
     Place Handles on Center Bar $70, Extra Insulation Roll (10 ft.) $14.
     Availability is per order form, so the list lives in each data group as an
     optional `extras` array — groups without one render nothing (all Design
     Specialties groups, plus the shared Plated group, are untouched).

     Unlike every other field these are MULTI-select, so instead of a single
     `selections[field]` scalar each ticked extra gets its own key,
     `extra_<slug>`, in the same `selections` / `surcharges` maps. That makes it
     ride the existing money path unchanged: calcTotal(), updatePrice(), the
     /cart/add.js surcharge batch (one line item per extra with _parent_product /
     _option_type / _config_id) and the Express Checkout snapshot all iterate
     Object.keys(surcharges) and pick them up for free.
     ════════════════════════════════════════════════════════════════════════ */
  function extraKey(label) {
    return 'extra_' + String(label).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+/, '').replace(/_+$/, '');
  }

  function efExtrasList() {
    if (!groupData || !groupData.extras || !groupData.extras.length) return [];
    /* Design Specialties products never see Stoll extras, even when they sit on a
       data group that carries them (shared groups). */
    if (/design\s*specialties/i.test(prodVendor)) return [];
    if (cfgType === 'cfg-screen') return [];
    return groupData.extras;
  }

  function toggleExtra(btn) {
    var key = btn.dataset.extraKey;
    var on = btn.getAttribute('aria-checked') !== 'true';
    btn.setAttribute('aria-checked', on ? 'true' : 'false');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on) {
      selections[key] = btn.dataset.value;
      surcharges[key] = {
        amount: (parseInt(btn.dataset.surcharge, 10) || 0) * 100,
        label: btn.dataset.value,
        variantId: btn.dataset.variantId || null
      };
    } else {
      delete selections[key];
      delete surcharges[key];
    }
    updatePrice();
  }

  function renderExtras() {
    var grp = root.querySelector('[data-group="extras"]');
    if (!grp) return;
    var grid = grp.querySelector('.ef-cfg-group__grid');
    var list = efExtrasList();
    if (!grid || !list.length) { grp.style.display = 'none'; return; }
    grp.style.display = '';
    grid.innerHTML = '';
    list.forEach(function (opt) {
      var key = extraKey(opt.label);
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-card ef-cfg-card--extra';
      btn.setAttribute('type', 'button');
      btn.setAttribute('role', 'checkbox');
      btn.setAttribute('aria-checked', selections[key] ? 'true' : 'false');
      btn.setAttribute('aria-pressed', selections[key] ? 'true' : 'false');
      btn.setAttribute('tabindex', '0');
      btn.dataset.field = 'extras';
      btn.dataset.extraKey = key;
      btn.dataset.value = opt.label;
      btn.dataset.surcharge = opt.price || 0;
      if (opt.variantId) btn.dataset.variantId = opt.variantId;
      if (opt.zcOnly) btn.dataset.zcOnly = '1';
      var html = '<span class="ef-cfg-card__check">' + CHECK_SVG + '</span>';
      html += '<span class="ef-cfg-card__body">';
      html += '<span class="ef-cfg-card__title">' + escHtml(opt.label) + '</span>';
      if (opt.desc) html += '<span class="ef-cfg-card__desc">' + escHtml(opt.desc) + '</span>';
      if (opt.price && opt.price > 0) html += '<span class="ef-cfg-card__price">+$' + opt.price + '</span>';
      html += '</span>';
      btn.innerHTML = html;
      btn.addEventListener('click', function () { toggleExtra(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleExtra(btn); }
      });
      grid.appendChild(btn);
    });
    updateExtrasVisibility();
  }

  /* Z-Tabs are a prefab / zero-clearance mounting part — hide them once the customer
     has told us the fireplace is masonry. Called on every fireplace_type change. */
  function updateExtrasVisibility() {
    var grp = root.querySelector('[data-group="extras"]');
    if (!grp) return;
    var cards = grp.querySelectorAll('.ef-cfg-card--extra');
    if (!cards.length) { grp.style.display = 'none'; return; }
    var ft = String(selections.fireplace_type || '').toLowerCase();
    var known = ft !== '';
    var isFactory = /factory|prefab|zero|\bzc\b/.test(ft);
    var visible = 0;
    var dropped = false;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var hide = c.dataset.zcOnly === '1' && known && !isFactory;
      c.style.display = hide ? 'none' : '';
      if (!hide) visible++;
      if (hide && c.getAttribute('aria-checked') === 'true') {
        c.setAttribute('aria-checked', 'false');
        c.setAttribute('aria-pressed', 'false');
        delete selections[c.dataset.extraKey];
        delete surcharges[c.dataset.extraKey];
        dropped = true;
      }
    }
    grp.style.display = visible ? '' : 'none';
    if (dropped) updatePrice();
  }

  /* [{key,label,amount}] for the review summary + cart line item properties. */
  function efSelectedExtras() {
    var out = [];
    Object.keys(selections).forEach(function (k) {
      if (k.indexOf('extra_') !== 0) return;
      var s = surcharges[k];
      out.push({ key: k, label: selections[k], amount: s ? s.amount : 0 });
    });
    return out;
  }

  function populateSteps() {
    if (cfgType === 'cfg-standard' || cfgType === 'cfg-simple') return;
    if (!groupData) {
      console.warn('No EF_CFG_DATA group matched for:', prodTitle);
      return;
    }

    // Step 1: Fireplace Type
    var fields0 = ['fireplace_type', 'firebox_type'];
    fields0.forEach(function(f) {
      var grp = root.querySelector('[data-group="' + f + '"]');
      if (grp) renderCards(f, grp.querySelector('.ef-cfg-group__grid'));
    });

    /* Auto-select single-option fields (e.g. Masonry Only products) */
    fields0.forEach(function(f) {
      if (groupData[f] && groupData[f].length === 1) {
        var card = root.querySelector('[data-field="' + f + '"]');
        if (card && card.getAttribute('aria-checked') !== 'true') {
          selectCard(card, f);
        }
      }
    });

    // Step 3: Style (includes fit_type now)
    var fields2 = ['fit_type', 'frame_width', 'door_type', 'side_panel', 'feet', 'handle', 'pattern'];
    fields2.forEach(function(f) {
      var grp = root.querySelector('[data-group="' + f + '"]');
      if (grp) renderCards(f, grp.querySelector('.ef-cfg-group__grid'));
    });

    /* Single-handle styles (Stoll Elite Thinline / ThinlinePro ship with Knob handles only,
       p57) would otherwise present a one-card "Pick 1" the customer has to click to get past.
       Auto-select it. No group has a single handle option other than those, so this is inert
       everywhere else — Design Specialties included. EF_STOLL_HANDLES_20260829 */
    if (groupData.handle && groupData.handle.length === 1) {
      var _h1 = root.querySelector('[data-group="handle"] [data-field="handle"]');
      if (_h1 && _h1.getAttribute('aria-checked') !== 'true') selectCard(_h1, 'handle');
    }

    // ── Tri-Fold screens: show the side-panel selector only when the product has side_panel data.
    //    (2026-06-29) Non-trifold products never have this group → it stays hidden. ──
    var _spGrp = root.querySelector('[data-group="side_panel"]');
    if (_spGrp) _spGrp.style.display = (groupData.side_panel && groupData.side_panel.length) ? '' : 'none';

    // ── Screens only: "Feet Style" group visibility (2026-06-16) ──
    // Hide the feet selector when the screen comes with a fixed foot:
    //   • screens WITH operable doors → Classic Foot only (default = first option in data)
    //   • single-option feet (e.g. Full Glass "Front Feet Only")
    // Keep it shown for free-standing screens that feature selectable front feet,
    // and surface the 8–10" forward-protrusion note there. Doors configs are untouched.
    if (cfgType === 'cfg-screen') {
      var _feetGrp = root.querySelector('[data-group="feet"]');
      if (_feetGrp) {
        var _feetN     = (groupData.feet || []).length;
        var _t         = (prodTitle || '').toLowerCase();
        var _hasDoors  = /operable door|with door|w\/ ?door|screen door|folding/.test(_t) || root.dataset.screenHasDoors === 'true';
        var _frontFeet = /front feet/.test(_t);
        _feetGrp.style.display = (_hasDoors || (_feetN <= 1 && !_frontFeet)) ? 'none' : '';
        var _note = _feetGrp.querySelector('[data-feet-protrude]');
        if (_note) _note.style.display = (_frontFeet && _feetGrp.style.display !== 'none') ? '' : 'none';
      }
    }

    // Door Fit Type: extract Regular/Flush from fit_type data for premium products
    if (cfgType === 'cfg-custom-premium') {
      var doorFitGrp = root.querySelector('[data-group="door_fit"]');
      if (doorFitGrp) {
        var doorFitGrid = doorFitGrp.querySelector('.ef-cfg-group__grid');
        var doorFitItems = (groupData.fit_type || []).filter(function(opt) {
          var lbl = (opt.label || '').toLowerCase().trim();
          return lbl.indexOf('regular') !== -1 || lbl.indexOf('flush') !== -1;
        });
        /* Only show the Door Fit Type group when the group actually offers
           Regular/Flush fits. Otherwise hide it (no empty "PICK 1" section even
           when fit_type is undefined — e.g. groups mis-tagged as premium). */
        if (doorFitItems.length > 0) {
          renderDoorFitCards(doorFitItems, doorFitGrid);
          doorFitGrp.style.display = '';
        } else {
          doorFitGrp.style.display = 'none';
        }
      }
    }

    // Custom Frame Width: Legend only
    var _isLegend = (matchedGroup || '').toLowerCase().indexOf('legend') !== -1;
    var cfwEl = document.getElementById('efCfgCustomFrame');
    if (cfwEl) {
      cfwEl.style.display = _isLegend ? '' : 'none';
      if (_isLegend) {
        var fInputs = ['efCfgFrameLeft','efCfgFrameRight','efCfgFrameTop','efCfgFrameBottom'];
        var fLabels = { efCfgFrameLeft:'A', efCfgFrameRight:'B', efCfgFrameTop:'C', efCfgFrameBottom:'D' };
        var fKeys = { efCfgFrameLeft:'_frame_left', efCfgFrameRight:'_frame_right', efCfgFrameTop:'_frame_top', efCfgFrameBottom:'_frame_bottom' };
        window._efUpdateFrameSvg = updateFrameSvg;
        function updateFrameSvg() {
          var svg = document.getElementById('efCfgFrameSvg');
          if (!svg) return;
          var l = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameLeft').value) || 2));
          var r = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameRight').value) || 2));
          var t = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameTop').value) || 2));
          var b = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameBottom').value) || 2));

          var widthInput = document.getElementById('efCfgWidth');
          var heightInput = document.getElementById('efCfgHeight');
          var ow = (widthInput && parseFloat(widthInput.value)) || 36;
          var oh = (heightInput && parseFloat(heightInput.value)) || 28;
          /* Scale uses MAX possible frame (12" each side) so glass stays the
             same visual size while A/B/C/D change — frame grows outward. */
          var MAX_F = 12;
          var scaleW = 320 / (ow + 2 * MAX_F);
          var scaleH = 260 / (oh + 2 * MAX_F);
          var scale = Math.min(scaleW, scaleH);
          var gw = ow * scale, gh = oh * scale;
          var lPx = l * scale, rPx = r * scale, tPx = t * scale, bPx = b * scale;

          /* Anchor glass/opening at centre; frame extends outward by A/B/C/D. */
          var cx = 200, cy = 170;
          var ix = cx - gw / 2, iy = cy - gh / 2;
          var ox = ix - lPx, oy = iy - tPx;
          var totalW = gw + lPx + rPx, totalH = gh + tPx + bPx;
          var barW = 3, gap = 3, halfGlass = (gw - barW) / 2;

          function s(id, a) { var e = svg.getElementById(id); if (!e) return; for (var k in a) e.setAttribute(k, a[k]); }
          function txt(id, v) { var e = svg.getElementById(id); if (e) e.textContent = v; }

          s('efFrameOuter', { x:ox, y:oy, width:totalW, height:totalH });

          s('efGlassL', { x:ix+gap, y:iy+gap, width:halfGlass-gap*2, height:gh-gap*2 });
          s('efGlassR', { x:cx+barW/2+gap, y:iy+gap, width:halfGlass-gap*2, height:gh-gap*2 });

          var lGx = ix+gap, lGy = iy+gap, lGw = halfGlass-gap*2, lGh = gh-gap*2;
          s('efRefl1', { x1:lGx+6, y1:lGy+6, x2:lGx+lGw*0.25, y2:lGy+lGh*0.25 });
          s('efRefl2', { x1:lGx+12, y1:lGy+6, x2:lGx+lGw*0.3, y2:lGy+lGh*0.25 });
          var rGx = cx+barW/2+gap;
          s('efRefl3', { x1:rGx+6, y1:lGy+6, x2:rGx+lGw*0.25, y2:lGy+lGh*0.25 });
          s('efRefl4', { x1:rGx+12, y1:lGy+6, x2:rGx+lGw*0.3, y2:lGy+lGh*0.25 });

          s('efDivider', { x:cx-barW/2, y:iy, width:barW, height:gh });

          var hSize = Math.min(12, gh*0.08);
          s('efHandleL', { x:cx-barW/2-hSize-4, y:cy-hSize/2, width:hSize, height:hSize });
          s('efHandleR', { x:cx+barW/2+4, y:cy-hSize/2, width:hSize, height:hSize });

          var hingeW = 4, hingeH = Math.min(8, gh*0.06);
          var hx1 = ix-hingeW+1, hx2 = ix+gw-1;
          s('efHingeL1', { x:hx1, y:iy+gh*0.15, width:hingeW, height:hingeH });
          s('efHingeL2', { x:hx1, y:cy-hingeH/2, width:hingeW, height:hingeH });
          s('efHingeL3', { x:hx1, y:iy+gh*0.85-hingeH, width:hingeW, height:hingeH });
          s('efHingeR1', { x:hx2, y:iy+gh*0.15, width:hingeW, height:hingeH });
          s('efHingeR2', { x:hx2, y:cy-hingeH/2, width:hingeW, height:hingeH });
          s('efHingeR3', { x:hx2, y:iy+gh*0.85-hingeH, width:hingeW, height:hingeH });

          var margin = 24;
          s('efDimA', { x1:ox, y1:cy, x2:ix, y2:cy });
          s('efLabelA', { x:ox-margin, y:cy-7 }); txt('efLabelA', 'A');
          s('efValA', { x:ox-margin, y:cy+8 }); txt('efValA', l + '"');

          s('efDimB', { x1:ix+gw, y1:cy, x2:ox+totalW, y2:cy });
          s('efLabelB', { x:ox+totalW+margin, y:cy-7 }); txt('efLabelB', 'B');
          s('efValB', { x:ox+totalW+margin, y:cy+8 }); txt('efValB', r + '"');

          var cDimX = ox - margin;
          s('efDimC', { x1:cDimX, y1:oy, x2:cDimX, y2:iy });
          s('efLabelC', { x:cDimX, y:oy-14 }); txt('efLabelC', 'C  ' + t + '"');

          var dDimX = ox + totalW + margin;
          s('efDimD', { x1:dDimX, y1:iy+gh, x2:dDimX, y2:oy+totalH });
          s('efLabelD', { x:dDimX, y:oy+totalH+16 }); txt('efLabelD', 'D  ' + b + '"');

          selections._frame_left = l + '"';
          selections._frame_right = r + '"';
          selections._frame_top = t + '"';
          selections._frame_bottom = b + '"';
        }
        fInputs.forEach(function(id) {
          var inp = document.getElementById(id);
          if (inp) {
            inp.addEventListener('input', updateFrameSvg);
            selections[fKeys[id]] = inp.value + '"';
          }
        });
        updateFrameSvg();
      }
    }

    // Step 4: Finish
    renderFinishes();
    renderStyleFinishes();
    renderHardwareFinishes();
    renderSamples();

    // Step 5: Glass & Accessories
    var fields3 = ['glass', 'mesh', 'draft_control'];
    fields3.forEach(function(f) {
      var grp = root.querySelector('[data-group="' + f + '"]');
      if (grp) renderCards(f, grp.querySelector('.ef-cfg-group__grid'));
    });

    /* Draft control: render cards but keep hidden until masonry is selected.
       selectCard(fireplace_type) handles show/hide based on masonry vs factory-built. */
    var _dcGrp = root.querySelector('[data-group="draft_control"]');
    if (_dcGrp) {
      var _hasDC = groupData && groupData.draft_control && groupData.draft_control.length > 0;
      _dcGrp.dataset.hasDraftControl = _hasDC ? '1' : '0';
      _dcGrp.style.display = 'none';
    }

    /* Extras (optional multi-select) — EF_STOLL_EXTRAS_20260829 */
    renderExtras();

    /* Skip Step 5 entirely if no glass, mesh, or draft_control data,
       OR if product is a mesh-doors variant (title ends in "Mesh Doors"). */
    var _hasGlass = groupData.glass && groupData.glass.length > 0;
    var _hasMesh = groupData.mesh && groupData.mesh.length > 0;
    var _hasDraftControl = groupData.draft_control && groupData.draft_control.length > 0;
    /* Mesh-only flag from Liquid (data-mesh-only) catches Stoll Mesh / DS Mesh
       where the title is "Mesh Masonry & Prefab Doors" — regex below misses it
       because "Mesh" isn't immediately followed by "doors". */
    var _isMeshOnly = isMeshOnly || /\bmesh\s+doors?\b/i.test(prodTitle);
    if ((!_hasGlass && !_hasMesh && !_hasDraftControl) || _isMeshOnly) {
      _skipStep4 = true;
      var step4El = document.getElementById('efCfgStep4');
      /* Extras live inside step 5 (Glass & Accessories). When that step is skipped —
         mesh-only doors (Stoll Mesh p23) — move the extras group into the Review step so
         the add-ons stay sellable instead of disappearing with the step. */
      var _exGrp = root.querySelector('[data-group="extras"]');
      var _revStep = document.getElementById('efCfgStepReview');
      var _revGrid = document.getElementById('efCfgReviewGrid');
      if (_exGrp && _revStep && _revGrid && _exGrp.style.display !== 'none') {
        _revGrid.parentNode.insertBefore(_exGrp, _revGrid);
      }
      if (step4El) step4El.style.display = 'none';
    }
    /* Frameless FULL-GLASS screens: hide the Style step (2 — feet/handle). The frameless
       glass panel has no decorative style options. Flow = Measurements → Finish → Glass →
       Review. Finish (frame/base color) and Glass Color both stay. */
    var _isGlassScreenCfg = /clear glass|full glass|frameless/i.test(prodTitle || '')
                          || /full glass/i.test(matchedGroup || '');
    if (cfgType === 'cfg-screen' && _isGlassScreenCfg) {
      _skipStep2 = true;
      var step2El = document.getElementById('efCfgStep2');
      if (step2El) step2El.style.display = 'none';
    }
    /* cfg-screen: skip Fireplace step (0) — screens are universal. Swap door→screen text. */
    if (cfgType === 'cfg-screen') {
      _skipStep0 = true;
      var step0El = document.getElementById('efCfgStep0');
      if (step0El) step0El.style.display = 'none';
      var SWAP = [
        [/configure your door/gi, 'Configure Your Screen'],
        [/your door/gi,           'Your Screen'],
        [/\bdoor style\b/gi,      'Screen Style'],
        [/choose your door type, fit, and handle style/gi,
         'Choose your screen style and handle.'],
        [/fireplace door/gi,      'fireplace screen'],
        [/door frame/gi,          'screen frame'],
        [/fireplace opening/gi,   'screen'],
        [/your measurements/gi,   'Your Screen Size'],
        [/width and height of your fireplace/gi, 'finished width and height of your screen'],
        [/opening in inches/gi,   'in inches'],
        [/bottom to top of the opening/gi, 'Floor to the top'],
        [/how to measure your fireplace/gi, 'Screen Sizing Tips'],
        [/frame finish/gi,        'Screen Finish'],
        [/narrowest point of the opening/gi, 'Side to side, at the widest point'],
        [/floor to top of opening or lintel bar/gi, 'Finished screen height'],
        [/narrowest point of the arch opening, base to base/gi, 'Finished screen width at the base (widest point)'],
        [/floor to where arch starts curving \(straight side\)/gi, 'Finished screen height at the straight side (where the arch starts)'],
        [/floor to highest point of the arch \(peak\)/gi, 'Finished screen height at the center peak (tallest point)'],
        [/\bopening width\b/gi, 'Screen Width'],
        [/\bside height\b/gi, 'Side Height'],
        [/\bcenter height \(at peak\)/gi, 'Center Peak Height'],
        [/handle finish automatically matches the frame color you select in step 4/gi,
         'Handles are included in the frame finish color, and mount vertically on each side.'],
      ];
      var textWalker = document.createTreeWalker(document.querySelector('.ef-cfg'), NodeFilter.SHOW_TEXT);
      var node;
      while (node = textWalker.nextNode()) {
        var t = node.textContent;
        var changed = false;
        for (var i=0; i<SWAP.length; i++) {
          if (SWAP[i][0].test(t)) { t = t.replace(SWAP[i][0], SWAP[i][1]); changed = true; }
        }
        if (changed) node.textContent = t;
      }
      /* Tri-fold: the two wings (side panels) are already chosen above, so the width the customer types
         is the CENTER panel only — relabel so they don't wonder "center panel or whole screen?".
         Arch trifolds have their own arch-show label/desc elements (the arch-hide ones are display:none),
         so BOTH variants get the trifold copy — same language, arch just adds Side/Peak heights. (2026-07-01) */
      if (groupData && groupData.side_panel && groupData.side_panel.length) {
        var _tfWL = document.querySelector('label[for="efCfgWidth"] span.ef-cfg-arch-hide') || document.querySelector('label[for="efCfgWidth"] span');
        if (_tfWL) _tfWL.textContent = 'Center Panel Width';
        var _tfWLA = document.querySelector('label[for="efCfgWidth"] span.ef-cfg-arch-show');
        if (_tfWLA) _tfWLA.textContent = 'Center Panel Width';
        var _tfWD = document.getElementById('efCfgWidthDesc');
        if (_tfWD) _tfWD.textContent = 'Just the flat center panel — your two wings add on each side';
        var _tfWDA = document.getElementById('efCfgWidthDescArch');
        if (_tfWDA) _tfWDA.textContent = 'Just the flat center panel, at the base — your two wings add on each side';
        var _tfSHD = document.getElementById('efCfgSideHeightDesc');
        if (_tfSHD) _tfSHD.textContent = 'Screen height at the panel edges, floor to where the arch starts curving';
        var _tfHDA = document.getElementById('efCfgHeightDescArch');
        if (_tfHDA) _tfHDA.textContent = 'Screen height at the center, floor to the highest point of the arch';
      }
      if (curStep === 0) curStep = 1;
      /* 2026-06-16 — keep the screen tip box HIDDEN. Free-standing screens have no
         inside/overlap fit, so coverage advice ("+2\" wider") was misleading and
         repeated "finished size" three times. Step 1 stays minimal: title + one-line
         subtitle + inputs + the precision/verify line below. */
      var tipEl = document.getElementById('efCfgScreenTip');
      if (tipEl) tipEl.style.display = 'none';
      /* Show the compact screen-only overlap sizing hint (same pill format as the
         precision line). Optional guidance — both width AND height. */
      var sizeHint = document.getElementById('efCfgScreenSizeHint');
      if (sizeHint) {
        sizeHint.style.display = '';
        /* Tri-fold is FREE-STANDING — "overlap the opening" doesn't apply. Instead, tell the customer
           to mark the size on the floor with painter's tape to confirm the footprint fits. (2026-07-01) */
        if (groupData && groupData.side_panel && groupData.side_panel.length) {
          sizeHint.innerHTML = '<svg class="ef-cfg-measure-precision__ic" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> ' +
            'Tip: mark the <strong>width</strong> on your floor with <strong>painter&rsquo;s tape</strong> first &mdash; the easiest way to see how the screen&rsquo;s footprint sits in front of your fireplace before you order.';
        }
      }
      /* Hide door-centric "How to Measure" collapsible — tip box above handles it for screens */
      var htm = document.querySelector('.ef-cfg-htmeasure');
      if (htm) htm.style.display = 'none';
      /* Hide AI Fireplace Expert CTA — AI not tuned for screens */
      var aiBtn = document.getElementById('efCfgAiBtn');
      if (aiBtn) aiBtn.style.display = 'none';
      /* Hide AI advice box */
      var aiAdvice = document.getElementById('efCfgAiAdvice');
      if (aiAdvice) aiAdvice.style.display = 'none';
      /* Tri-fold: Step 2 (Style) ends up EMPTY — side panels moved into Step 1, and fit/feet/
         handle/pattern groups all have no data → renderCards hid every group. Drop the step
         from the flow (dynamic check so a future trifold WITH feet/handle data keeps it). (2026-07-01) */
      if (groupData && groupData.side_panel && groupData.side_panel.length && !_skipStep2) {
        var _tfS2 = document.getElementById('efCfgStep2');
        var _tfS2Visible = _tfS2 && Array.prototype.some.call(_tfS2.querySelectorAll('.ef-cfg-group'), function (g) { return g.style.display !== 'none'; });
        if (_tfS2 && !_tfS2Visible) { _skipStep2 = true; _tfS2.style.display = 'none'; }
      }
    }
  }

  /* ────────────────────────────────────
     OPENING DIAGRAM — live SVG preview
     Always visible, true proportions.
     Adapts to fireplace_type + firebox_type.
     ──────────────────────────────────── */
  var _openDims = { w: 36, h: 28 }; /* default = placeholder values */
  var _openType = { fp: '', fb: '' }; /* fireplace_type, firebox_type */

  /* ────────────────────────────────────
     SCREEN SVG — free-standing fireplace screen
     Frame: 1-1/4" · fine mesh · curved feet extending down+out
     Scales to finished W×H entered by customer.
     ──────────────────────────────────── */
  function drawScreen(wInch, hInch, svg) {
    var W = (wInch && wInch > 0) ? wInch : 40;
    var H = (hInch && hInch > 0) ? hInch : 32;
    _openDims.w = W;
    _openDims.h = H;

    var maxW = 320, maxH = 230;
    var scale = Math.min(maxW / W, maxH / H);
    var sW = Math.round(W * scale);
    var sH = Math.round(H * scale);

    /* Full-glass screens (e.g. "Modern Clear Glass Fireplace Screen with Steel Base"):
       frameless clear glass panel on a steel base with a forward-protruding foot —
       NOT a mesh panel. Bespoke render, then bail out of the mesh path. */
    var _isGlassScreen = /clear glass|full glass|frameless/i.test(prodTitle || '')
                      || /full glass/i.test(matchedGroup || '');
    if (_isGlassScreen) { drawGlassScreen(W, H, scale, sW, sH, svg); return; }

    var frameT = Math.max(3, Math.round(1.25 * scale));
    var footReach = Math.round(sW * 0.1);
    var footDrop  = Math.max(frameT * 3, Math.round(scale * 3));
    var footInset = Math.round(sW * 0.04);

    var padX = Math.max(50, footReach + 15), padTop = 32, padBot = Math.max(30, footDrop + 14);
    var cW = sW + padX * 2;
    var cH = sH + padTop + padBot;

    var x0 = padX, y0 = padTop;
    var ix = x0 + frameT, iy = y0 + frameT;
    var iw = sW - frameT * 2, ih = sH - frameT * 2;

    /* Curved feet — Bezier curves that swoop down and outward */
    var fLbase = x0 + footInset;
    var fLtip  = x0 + footInset - footReach;
    var footBot = y0 + sH + footDrop;
    var footL = 'M ' + fLbase + ' ' + (y0 + sH)
              + ' C ' + fLbase + ' ' + (y0 + sH + footDrop * 0.55)
              + ', ' + (fLtip + footReach * 0.25) + ' ' + (footBot - footDrop * 0.15)
              + ', ' + fLtip + ' ' + footBot;
    var fRbase = x0 + sW - footInset;
    var fRtip  = x0 + sW - footInset + footReach;
    var footR = 'M ' + fRbase + ' ' + (y0 + sH)
              + ' C ' + fRbase + ' ' + (y0 + sH + footDrop * 0.55)
              + ', ' + (fRtip - footReach * 0.25) + ' ' + (footBot - footDrop * 0.15)
              + ', ' + fRtip + ' ' + footBot;

    var meshS = Math.max(2, Math.round(scale * 0.4));
    padBot = 40;
    cH = sH + padTop + padBot;

    /* Arch shape: curved top half-ellipse from center peak to side base */
    var archRiseInch = 0;
    if (isArch && selections._side_height) {
      archRiseInch = Math.max(0, H - parseFloat(selections._side_height));
    } else if (isArch) {
      archRiseInch = Math.max(2, H * 0.25); /* default arch rise if side height not set */
    }
    var archRise = Math.round(archRiseInch * scale);

    /* Frame path — either rect or arch */
    var framePath, innerPath;
    if (isArch && archRise > 0) {
      /* Outer: bottom-left up, over arc to top-right, down to bottom-right */
      framePath = 'M ' + x0 + ' ' + (y0 + sH) +
                  ' L ' + x0 + ' ' + (y0 + archRise) +
                  ' A ' + (sW/2) + ' ' + archRise + ' 0 0 1 ' + (x0 + sW) + ' ' + (y0 + archRise) +
                  ' L ' + (x0 + sW) + ' ' + (y0 + sH) + ' Z';
      /* Inner cavity (arch shape, frameT inset) */
      var iArchRise = Math.max(0, archRise - frameT);
      innerPath = 'M ' + ix + ' ' + (y0 + sH - frameT) +
                  ' L ' + ix + ' ' + (y0 + frameT + iArchRise) +
                  ' A ' + (iw/2) + ' ' + iArchRise + ' 0 0 1 ' + (ix + iw) + ' ' + (y0 + frameT + iArchRise) +
                  ' L ' + (ix + iw) + ' ' + (y0 + sH - frameT) + ' Z';
    } else {
      framePath = 'M ' + x0 + ' ' + y0 + ' h ' + sW + ' v ' + sH + ' h -' + sW + ' Z';
      innerPath = 'M ' + ix + ' ' + iy + ' v ' + ih + ' h ' + iw + ' v -' + ih + ' Z';
    }

    svg.setAttribute('viewBox', '0 0 ' + cW + ' ' + cH);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', 'auto');

    /* Mesh clip path for arch — uses same inner path as clip region */
    var clipDef = isArch && archRise > 0
      ? '<clipPath id="efScreenClip"><path d="' + innerPath + '"/></clipPath>'
      : '';
    var meshRect = isArch && archRise > 0
      ? '<rect x="' + ix + '" y="' + (y0 + frameT) + '" width="' + iw + '" height="' + (sH - frameT * 2) + '" fill="url(#efScreenMesh)" clip-path="url(#efScreenClip)"/>'
      : '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '" fill="url(#efScreenMesh)"/>';

    svg.innerHTML =
      '<defs>' +
        '<pattern id="efScreenMesh" x="0" y="0" width="' + meshS + '" height="' + meshS + '" patternUnits="userSpaceOnUse">' +
          '<rect width="' + meshS + '" height="' + meshS + '" fill="#2A2724"/>' +
          '<circle cx="' + (meshS/2) + '" cy="' + (meshS/2) + '" r="0.4" fill="#8A8579" opacity="0.55"/>' +
        '</pattern>' +
        '<linearGradient id="efFrameGrad" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#2B2722"/>' +
          '<stop offset="50%" stop-color="#141210"/>' +
          '<stop offset="100%" stop-color="#2B2722"/>' +
        '</linearGradient>' +
        clipDef +
      '</defs>' +
      meshRect +
      /* Frame (hollow — outer minus inner, even-odd fill) */
      '<path d="' + framePath + ' ' + innerPath + '" fill="url(#efFrameGrad)" fill-rule="evenodd"/>' +
      /* Width dimension */
      '<text x="' + (x0 + sW / 2) + '" y="' + (y0 - 12) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B">' + W + '" W</text>' +
      '<line x1="' + x0 + '" y1="' + (y0 - 5) + '" x2="' + (x0 + sW) + '" y2="' + (y0 - 5) + '" stroke="#8A6A43" stroke-width="1"/>' +
      /* Height dimension */
      '<text x="' + (x0 + sW + 16) + '" y="' + (y0 + sH / 2) + '" text-anchor="start" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B" dominant-baseline="middle">' + H + (isArch ? '" Peak' : '" H') + '</text>' +
      '<line x1="' + (x0 + sW + 8) + '" y1="' + y0 + '" x2="' + (x0 + sW + 8) + '" y2="' + (y0 + sH) + '" stroke="#8A6A43" stroke-width="1"/>' +
      '<text x="' + (cW / 2) + '" y="' + (y0 + sH + 22) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="10" fill="#8A8579" letter-spacing="1">' + (isArch ? 'FINISHED ARCH SCREEN SIZE' : 'FINISHED SCREEN SIZE') + '</text>';
  }

  /* ────────────────────────────────────
     GLASS SCREEN SVG — frameless clear glass panel sitting in a steel
     base with a forward-protruding foot plate (shown in perspective).
     Used for the "Full Glass" screen group (no mesh, no top/side frame).
     ──────────────────────────────────── */
  function drawGlassScreen(W, H, scale, sW, sH, svg) {
    var padX = 66, padTop = 34, padBot = 86;
    var cW = sW + padX * 2;
    var cH = sH + padTop + padBot;

    var gx = padX, gy = padTop;                        /* glass top-left */
    var baseH   = Math.max(16, Math.round(sH * 0.15)); /* steel base front-face height */
    var by      = gy + sH;                             /* base bottom / front-face baseline */
    var baseTop = by - baseH;                          /* base front-face top */
    var glassH  = sH - Math.round(baseH * 0.5);        /* glass dips into the base channel */

    /* forward foot plate (perspective): horizontal steel plate jutting toward viewer */
    var footDepth = Math.max(16, Math.round(baseH * 1.2));
    var footOut   = Math.max(10, Math.round(sW * 0.06)); /* near (front) edge wider = closer */
    var ffl = gx - footOut, ffr = gx + sW + footOut;     /* front edge x */
    var fby = by + footDepth;                            /* front edge y */
    var footPlate = 'M ' + gx + ' ' + by + ' L ' + (gx + sW) + ' ' + by +
                    ' L ' + ffr + ' ' + fby + ' L ' + ffl + ' ' + fby + ' Z';

    svg.setAttribute('viewBox', '0 0 ' + cW + ' ' + cH);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', 'auto');

    svg.innerHTML =
      '<defs>' +
        '<linearGradient id="efGlassGrad" x1="0%" y1="0%" x2="100%" y2="100%">' +
          '<stop offset="0%" stop-color="#DCE6E8" stop-opacity="0.55"/>' +
          '<stop offset="45%" stop-color="#EAF0F1" stop-opacity="0.20"/>' +
          '<stop offset="100%" stop-color="#C7D2D4" stop-opacity="0.5"/>' +
        '</linearGradient>' +
        '<linearGradient id="efBaseGrad" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#3A3631"/>' +
          '<stop offset="55%" stop-color="#1C1A17"/>' +
          '<stop offset="100%" stop-color="#0F0E0C"/>' +
        '</linearGradient>' +
        '<linearGradient id="efFootGrad" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#4A453E"/>' +
          '<stop offset="100%" stop-color="#23211D"/>' +
        '</linearGradient>' +
      '</defs>' +
      /* clear glass panel (frameless) */
      '<rect x="' + gx + '" y="' + gy + '" width="' + sW + '" height="' + glassH + '" fill="url(#efGlassGrad)"/>' +
      /* diagonal reflection streak */
      '<polygon points="' + (gx + sW * 0.16) + ',' + gy + ' ' + (gx + sW * 0.34) + ',' + gy + ' ' + (gx + sW * 0.16) + ',' + (gy + glassH) + ' ' + (gx + sW * 0.02) + ',' + (gy + glassH) + '" fill="#FFFFFF" opacity="0.12"/>' +
      /* glass edge highlight */
      '<rect x="' + gx + '" y="' + gy + '" width="' + sW + '" height="' + glassH + '" fill="none" stroke="#AEBFC2" stroke-width="1.5" stroke-opacity="0.7"/>' +
      /* forward foot plate (drawn before base so the base front face overlaps its back edge) */
      '<path d="' + footPlate + '" fill="url(#efFootGrad)" stroke="#000" stroke-opacity="0.25" stroke-width="1"/>' +
      /* steel base front face */
      '<rect x="' + gx + '" y="' + baseTop + '" width="' + sW + '" height="' + baseH + '" rx="2" fill="url(#efBaseGrad)"/>' +
      '<rect x="' + gx + '" y="' + baseTop + '" width="' + sW + '" height="2" fill="#5A554C" opacity="0.6"/>' +
      /* width dimension */
      '<text x="' + (gx + sW / 2) + '" y="' + (gy - 12) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B">' + W + '" W</text>' +
      '<line x1="' + gx + '" y1="' + (gy - 5) + '" x2="' + (gx + sW) + '" y2="' + (gy - 5) + '" stroke="#8A6A43" stroke-width="1"/>' +
      /* height dimension (glass + base) */
      '<text x="' + (gx + sW + 16) + '" y="' + (gy + sH / 2) + '" text-anchor="start" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B" dominant-baseline="middle">' + H + '" H</text>' +
      '<line x1="' + (gx + sW + 8) + '" y1="' + gy + '" x2="' + (gx + sW + 8) + '" y2="' + by + '" stroke="#8A6A43" stroke-width="1"/>' +
      /* caption */
      '<text x="' + (cW / 2) + '" y="' + (fby + 18) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="10" fill="#8A8579" letter-spacing="1">CLEAR GLASS · STEEL BASE</text>';
  }

  function drawOpening(wInch, hInch) {
    var svg = document.getElementById('efCfgOpeningSvg');
    if (!svg) return;

    /* cfg-screen: render a free-standing fireplace screen (frame + mesh + feet)
       instead of a fireplace opening. 1-1/4" frame, square feet at bottom. */
    if (cfgType === 'cfg-screen') {
      drawScreen(wInch, hInch, svg);
      return;
    }

    var W = (wInch && wInch > 0) ? wInch : _openDims.w;
    var H = (hInch && hInch > 0) ? hInch : _openDims.h;
    _openDims.w = W;
    _openDims.h = H;

    /* Detect construction type from selections */
    var isMasonry = true;  /* default */
    var isFlush   = true;  /* default */
    if (_openType.fp) {
      isMasonry = _openType.fp.toLowerCase().indexOf('masonry') !== -1;
    }
    if (_openType.fb) {
      isFlush = _openType.fb.toLowerCase().indexOf('flush') !== -1 ||
                _openType.fb.toLowerCase().indexOf('hearth') !== -1;
    }

    /*
     * True-proportion scaling:
     * The opening fits into max 220×180 px, W:H ratio exact.
     */
    var maxOW = 220, maxOH = 180;
    var scale = Math.min(maxOW / W, maxOH / H);
    var oW = Math.round(W * scale);
    var oH = Math.round(H * scale);

    /* Surround padding around opening */
    var surPadX = Math.max(28, Math.round(oW * 0.18));

    /*
     * Flush Hearth: opening sits on the hearth floor.
     *   → bigger top padding, small bottom (opening bottom = surround bottom = hearth top)
     * Hole in Wall: opening is vertically centered.
     *   → equal top and bottom padding
     */
    var surPadTop, surPadBot;
    if (isFlush) {
      surPadTop = Math.max(32, Math.round(oH * 0.25));
      surPadBot = 0; /* opening bottom flush with surround bottom / hearth top */
    } else {
      /* Hole in wall: equal padding top and bottom → centered */
      var surPadV = Math.max(28, Math.round(oH * 0.18));
      surPadTop = surPadV;
      surPadBot = surPadV;
    }

    var sW = oW + surPadX * 2;
    var sH = oH + surPadTop + surPadBot;

    /* Mantel/hearth geometry */
    var mantelH = 14;
    var mantelOver = 10;
    var hearthH = 16;
    var hearthEdgeH = 6;
    var hearthOver = 15;
    var showHearth = isFlush;

    /* Dimension lines */
    var dimLeft = 28;
    var dimBot = 28;
    var arrowLen = 6;
    var hLblOffset = 6; /* extra space for height label text */

    /* Positions */
    var svgPadL = dimLeft + hLblOffset + 12;
    var svgPadT = 10;
    var sX = svgPadL;
    var sY = svgPadT + mantelH + 4; /* always room for mantel area */
    var oX = sX + surPadX;
    var oY = sY + surPadTop;

    var hearthY = sY + sH;
    var hearthX = sX - hearthOver;
    var hearthTotalW = sW + hearthOver * 2;

    var mantelX = sX - mantelOver;
    var mantelY = sY - mantelH - 2;
    var mantelW = sW + mantelOver * 2;

    /* Total SVG size */
    var totalW = svgPadL + sW + 20;
    var bottomExtra = showHearth ? hearthH + hearthEdgeH : 4;
    var totalH = mantelY + mantelH + 4 + sH + bottomExtra + dimBot + 18;

    svg.setAttribute('viewBox', '0 0 ' + totalW + ' ' + totalH);

    /* ─ Helper ─ */
    function setAttr(id, attrs) {
      var el = document.getElementById(id);
      if (!el) return;
      for (var k in attrs) el.setAttribute(k, attrs[k]);
    }

    /* ── Surround ── */
    if (isMasonry) {
      /* Brick surround */
      setAttr('efCfgSurroundRect', { x: sX, y: sY, width: sW, height: sH, fill: 'url(#efBrickPat)', stroke: '#B5A898', 'stroke-width': '1', rx: '2' });
      /* Show mantel */
      setAttr('efCfgMantel', { x: mantelX, y: mantelY, width: mantelW, height: mantelH, opacity: '1' });
      setAttr('efCfgMantelFace', { x: mantelX, y: mantelY + mantelH, width: mantelW, height: 4, opacity: '1' });
      setAttr('efCfgMantelShadow', { x: sX, y: sY, width: sW, height: 10, opacity: '1' });
      /* Hide prefab frame */
      setAttr('efCfgPrefabOuter', { opacity: '0', 'stroke-width': '0' });
      setAttr('efCfgPrefabInner', { opacity: '0', 'stroke-width': '0' });
    } else {
      /* Prefab: dark metal housing */
      setAttr('efCfgSurroundRect', { x: sX, y: sY, width: sW, height: sH, fill: '#2C2C2C', stroke: '#4A4A4A', 'stroke-width': '1.5', rx: '3' });
      /* Show prefab double-frame */
      setAttr('efCfgPrefabOuter', { x: sX - 2, y: sY - 2, width: sW + 4, height: sH + 4, rx: 4, opacity: '1', stroke: '#555', 'stroke-width': '1.5' });
      setAttr('efCfgPrefabInner', { x: sX + 4, y: sY + 4, width: sW - 8, height: sH - 8, rx: 2, opacity: '0.5', stroke: '#3A3A3A', 'stroke-width': '0.8' });
      /* Hide masonry mantel */
      setAttr('efCfgMantel', { opacity: '0' });
      setAttr('efCfgMantelFace', { opacity: '0' });
      setAttr('efCfgMantelShadow', { opacity: '0' });
    }

    /* ── Firebox opening ── */
    setAttr('efCfgOpeningRect', { x: oX, y: oY, width: oW, height: oH });

    /* Soot */
    setAttr('efCfgSoot', { x: oX + 1, y: oY + 1, width: oW - 2, height: Math.min(30, oH * 0.18) });

    /* Back wall hint */
    var bwInset = Math.max(12, Math.round(oW * 0.1));
    var bwInsetV = Math.max(14, Math.round(oH * 0.1));
    setAttr('efCfgBackWall', {
      x: oX + bwInset, y: oY + bwInsetV,
      width: oW - bwInset * 2, height: oH - bwInsetV * 2
    });

    /* ── Hearth / floor ── */
    if (showHearth) {
      /* Flush Hearth: hearth slab below surround, opening sits on it */
      setAttr('efCfgHearth', { x: hearthX, y: hearthY, width: hearthTotalW, height: hearthH, opacity: '1' });
      setAttr('efCfgHearthEdge', { x: hearthX, y: hearthY + hearthH - 2, width: hearthTotalW, height: hearthEdgeH, opacity: '1' });
      setAttr('efCfgFloorLine', { x1: hearthX - 10, y1: hearthY + hearthH + hearthEdgeH - 2, x2: hearthX + hearthTotalW + 10, y2: hearthY + hearthH + hearthEdgeH - 2, opacity: '1' });
    } else {
      /* Hole in wall: no hearth, just floor line below surround */
      setAttr('efCfgHearth', { opacity: '0' });
      setAttr('efCfgHearthEdge', { opacity: '0' });
      setAttr('efCfgFloorLine', { x1: sX - 10, y1: sY + sH + 2, x2: sX + sW + 10, y2: sY + sH + 2, opacity: '1' });
    }

    /* ── Width dimension ── */
    var wDimBase = showHearth ? (hearthY + hearthH + hearthEdgeH) : (sY + sH);
    var wDimY = wDimBase + 12;
    setAttr('efCfgDimWLine', { x1: oX, y1: wDimY, x2: oX + oW, y2: wDimY });
    var wAL = oX, wAR = oX + oW;
    setAttr('efCfgDimWArwL', { points: wAL+','+wDimY+' '+(wAL+arrowLen)+','+(wDimY-3)+' '+(wAL+arrowLen)+','+(wDimY+3) });
    setAttr('efCfgDimWArwR', { points: wAR+','+wDimY+' '+(wAR-arrowLen)+','+(wDimY-3)+' '+(wAR-arrowLen)+','+(wDimY+3) });
    setAttr('efCfgDimWCapL', { x1: oX, y1: wDimY - 6, x2: oX, y2: wDimY + 6 });
    setAttr('efCfgDimWCapR', { x1: oX + oW, y1: wDimY - 6, x2: oX + oW, y2: wDimY + 6 });
    var wLbl = document.getElementById('efCfgDimWLabel');
    if (wLbl) {
      wLbl.setAttribute('x', oX + oW / 2);
      wLbl.setAttribute('y', wDimY + 16);
      wLbl.textContent = W + '\u2033';
    }

    /* ── Height dimension ── */
    var hDimX = sX - dimLeft;
    var hLblX = hDimX - 6; /* label offset from line — matches width label gap */
    setAttr('efCfgDimHLine', { x1: hDimX, y1: oY, x2: hDimX, y2: oY + oH });
    setAttr('efCfgDimHArwT', { points: hDimX+','+oY+' '+(hDimX-3)+','+(oY+arrowLen)+' '+(hDimX+3)+','+(oY+arrowLen) });
    setAttr('efCfgDimHArwB', { points: hDimX+','+(oY+oH)+' '+(hDimX-3)+','+(oY+oH-arrowLen)+' '+(hDimX+3)+','+(oY+oH-arrowLen) });
    setAttr('efCfgDimHCapT', { x1: hDimX - 6, y1: oY, x2: hDimX + 6, y2: oY });
    setAttr('efCfgDimHCapB', { x1: hDimX - 6, y1: oY + oH, x2: hDimX + 6, y2: oY + oH });
    var hLbl = document.getElementById('efCfgDimHLabel');
    if (hLbl) {
      var hMid = oY + oH / 2;
      hLbl.setAttribute('x', hLblX);
      hLbl.setAttribute('y', hMid);
      hLbl.setAttribute('transform', 'rotate(-90 ' + hLblX + ' ' + hMid + ')');
      hLbl.textContent = H + '\u2033';
    }
  }

  /* Initial draw with defaults (matches placeholders e.g. 36 / e.g. 28) */
  drawOpening(36, 28);

  /* ────────────────────────────────────
     MEASUREMENTS → SIZE CATEGORY
     ──────────────────────────────────── */
  function handleMeasurements() {
    var wEl = document.getElementById('efCfgWidth');
    var hEl = document.getElementById('efCfgHeight');
    var sEl = document.getElementById('efCfgSideHeight'); /* arch only */
    if (!wEl || !hEl) return;

    /* Debounce SVG diagram updates so it doesn't jump on every keystroke.
       User typing "40" sees the diagram update after they pause, not after "4". */
    var _drawTimer = null;
    function debouncedDraw(w, h) {
      clearTimeout(_drawTimer);
      _drawTimer = setTimeout(function() { drawOpening(w, h); }, 500);
    }

    /* Light the field + show a green check once a realistic measurement is in,
       so the customer gets a live "got it" confirmation. 2026-05-31. */
    function _efSetDimValid(el, ok) {
      var wrap = el && el.closest ? el.closest('.ef-cfg-input-suffix') : null;
      if (wrap) wrap.classList.toggle('is-valid', !!ok);
    }

    function calc() {
      var w = parseMeasurement(wEl.value);
      var h = parseMeasurement(hEl.value);
      var wValid = !isNaN(w) && w > 0;
      var hValid = !isNaN(h) && h > 0;
      var wRealistic = wValid && w >= 10;
      var hRealistic = hValid && h >= 10;

      _efSetDimValid(wEl, wRealistic);
      _efSetDimValid(hEl, hRealistic);
      if (sEl) { var sv = parseMeasurement(sEl.value); _efSetDimValid(sEl, !isNaN(sv) && sv >= 10); }

      /* Update SVG diagram only when value looks like a real measurement (>=10")
         so typing the first digit of "36" doesn't redraw at 3" */
      if (wRealistic || hRealistic) {
        debouncedDraw(wRealistic ? Math.round(w) : 36, hRealistic ? Math.round(h) : 28);
      }

      if (!wValid || !hValid) {
        document.getElementById('efCfgSizeResult').classList.remove('is-visible');
        var sizeSection = document.getElementById('efCfgSizeSection');
        if (sizeSection) sizeSection.style.display = 'none';
        delete selections._width;
        delete selections._height;
        delete selections._side_height;
        delete selections.size;
        delete surcharges.size; delete surcharges.size_height;
        updatePrice();
        return;
      }

      selections._width = wEl.value.trim();
      selections._height = hEl.value.trim();
      /* Arch: capture Side Height (no impact on pricing — just for manufacturer reference) */
      if (isArch && sEl) {
        var sideRaw = sEl.value.trim();
        if (sideRaw) selections._side_height = sideRaw;
        else delete selections._side_height;
      }
      /* Pricing total: Width + Height (rectangle) OR Width + Peak (arch — same field, just relabeled) */
      var total = Math.round((w + h) * 100) / 100;
      var totalDisplay = Math.round(total);

      // Find matching size category
      var cat = null;
      if (sizeGrid) {
        /* EF_STOLL_SIZE_GRID_20260829 - first row whose max width AND max height both fit.
           Height here is the peak height on arch products (same input field). If nothing
           fits, fall back to the last (largest) row so we never under-charge. */
        /* EF_STOLL_1TO1_20260829 — exact Stoll order-form rule (owner decision 2026-08-29):
           the row is chosen by WIDTH only ("Fireplace Opening Size Up To … wide"); any height
           over the row's max height is charged "+$135 per 2″ height increase over dimensions
           on sizing chart" (each started 2″ = one $135 unit, added as a multiplied line item). */
        for (var gi = 0; gi < sizeData.length; gi++) {
          var ge = sizeData[gi];
          if (ge.maxW === null || ge.maxH === null) continue;
          if (w <= ge.maxW) { cat = ge; break; }
        }
        if (!cat && sizeData.length) cat = sizeData[sizeData.length - 1];
        delete surcharges.size_height;
        if (cat && h > cat.maxH) {
          var _over = h - cat.maxH;
          var _steps = Math.ceil(_over / 2 - 1e-9);
          surcharges.size_height = {
            amount: _steps * STOLL_HEIGHT_STEP_PRICE * 100,
            label: '+' + (Math.round(_over * 100) / 100) + '″ over ' + cat.maxH + '″ (' + _steps + ' × $' + STOLL_HEIGHT_STEP_PRICE + ')',
            variantId: STOLL_HEIGHT_STEP_VARIANT,
            qty: _steps
          };
        }
        console.log('[EF-CFG] size-grid W=' + w + ' H=' + h + ' rows=' + sizeData.length + ' matched=' + (cat ? cat.label : 'NONE') + (surcharges.size_height ? ' | height ' + surcharges.size_height.label : ''));
      } else {
        delete surcharges.size_height;
      }
      for (var i = 0; !sizeGrid && i < sizeData.length; i++) {
        if (total >= sizeData[i].minTotal && total <= sizeData[i].maxTotal) {
          cat = sizeData[i];
          break;
        }
      }

      /* ────────────────────────────────────
         EF_STOLL_UI_BRACKETS_20260830 — owner decision: Stoll doors sell in the same
         united-inch brackets as every other EF door (one "Size" line, no per-2-inch
         multiplier, which read like a miscalculation to customers). Bracket prices are
         set above the Stoll list for realistic openings, but a very wide-and-short
         opening (linear fireplaces) can still list higher than its bracket, so we move
         it up to the first bracket that covers the list price. Never below Stoll list,
         still exactly one size line. `stoll_grid` = the order-form rows for this style.
         ──────────────────────────────────── */
      if (cat && groupData && Array.isArray(groupData.stoll_grid) && groupData.stoll_grid.length) {
        var _grid = groupData.stoll_grid, _row = null;
        for (var _gi = 0; _gi < _grid.length; _gi++) {
          if (w <= parseFloat(_grid[_gi].maxW)) { _row = _grid[_gi]; break; }
        }
        if (!_row) _row = _grid[_grid.length - 1];
        var _over = Math.max(0, h - parseFloat(_row.maxH));
        var _listPrice = (parseFloat(_row.price) || 0) + STOLL_HEIGHT_STEP_PRICE * Math.ceil(_over / 2 - 1e-9);
        if (_listPrice > cat.price) {
          var _bumped = null;
          for (var _bi = 0; _bi < sizeData.length; _bi++) {
            if (sizeData[_bi].price >= _listPrice) { _bumped = sizeData[_bi]; break; }
          }
          cat = _bumped || sizeData[sizeData.length - 1];
          console.log('[EF-CFG] stoll-guard: list $' + _listPrice + ' > bracket — moved up to ' + cat.label);
        }
      }

      console.log('[EF-CFG] calc: W=' + w + ' H=' + h + ' total=' + total + ' | sizeData=' + sizeData.length + ' entries | matched=' + (cat ? cat.label : 'NONE'));

      var resEl = document.getElementById('efCfgSizeResult');
      var sizeSection = document.getElementById('efCfgSizeSection');
      if (sizeSection) sizeSection.style.display = '';
      document.getElementById('efCfgSizeTotal').textContent = sizeGrid
        ? ((isArch ? 'W \u00D7 Peak = ' : 'W \u00D7 H = ') + w + '\u2033 \u00D7 ' + h + '\u2033')
        : ((isArch ? 'W + Peak = ' : 'W + H = ') + totalDisplay + '\u2033');

      if (cat) {
        document.getElementById('efCfgSizeBadge').textContent = cat.displayLabel;
        document.getElementById('efCfgSizeSurcharge').textContent = cat.price > 0 ? '+$' + cat.price : 'Base price';
        selections.size = cat.displayLabel;
        surcharges.size = { amount: cat.price * 100, label: cat.displayLabel, variantId: cat.variantId };
      } else {
        document.getElementById('efCfgSizeBadge').textContent = 'Custom';
        document.getElementById('efCfgSizeSurcharge').textContent = '';
        selections.size = 'Custom';
        surcharges.size = { amount: 0, label: 'Custom', variantId: null };
      }

      resEl.classList.add('is-visible');
      updatePrice();
    }

    wEl.addEventListener('input', calc);
    hEl.addEventListener('input', calc);
  }

  /* ────────────────────────────────────
     HOW TO MEASURE ACCORDION
     ──────────────────────────────────── */
  (function() {
    var toggle = document.getElementById('efCfgHtmToggle');
    var body = document.getElementById('efCfgHtmBody');
    if (!toggle || !body) return;
    toggle.addEventListener('click', function() {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !open);
      body.setAttribute('aria-hidden', open);
    });
  })();

  /* ────────────────────────────────────
     VARIANT SELECT (cfg-standard)
     ──────────────────────────────────── */
  function handleVariantSelect() {
    var sel = document.getElementById('efCfgVariantSelect');
    if (!sel) return;
    sel.addEventListener('change', function() {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.value) {
        variantId = opt.value;
        var vPrice = parseInt(opt.dataset.price, 10) || 0;
        basePrice = vPrice;
        selections.variant = opt.textContent.trim();
      } else {
        selections.variant = null;
      }
      updatePrice();
    });

    /* Preselect first available variant so ATC is click-ready on page load.
       Skips the placeholder "" option and any disabled (sold-out) variants. */
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value && !o.disabled) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change'));
        break;
      }
    }
  }

  /* ────────────────────────────────────
     STANDARD SIZE DROPDOWNS (Stoll Columbia, etc.)
     Replaces W/H text inputs with two cascading dropdowns when the matched
     group has standard_size === true. Width tier carries the size surcharge
     (since Columbia prices by finished width, not W+H sum); height range is
     informational only.
     ──────────────────────────────────── */
  /* Brookfield Deluxe Magnetic — replaces standard width/height inputs with the
     6-input measurement panel (per Avis/DS spec). Also hides:
       - W+H size badge section
       - The big rectangular opening diagram SVG (#efCfgOpeningDiagram) — that
         28"×36" fireplace illustration was showing above the inputs and looks
         out of place next to the magnetic-mount real-photo image we now use. */
  function handleBrookfieldDeluxe() {
    if (matchedGroup !== 'Fireplace Doors - Brookfield Deluxe') return;
    var measureBox = document.getElementById('efCfgMeasure');
    var deluxeBox  = document.getElementById('efCfgDeluxeMeasure');
    if (!measureBox || !deluxeBox) return;
    measureBox.style.display = 'none';
    deluxeBox.style.display = '';
    var sizeSection = document.getElementById('efCfgSizeSection');
    if (sizeSection) sizeSection.style.display = 'none';
    var openingDiagram = document.getElementById('efCfgOpeningDiagram');
    if (openingDiagram) openingDiagram.style.display = 'none';
  }

  function handleStandardSize() {
    if (!groupData || !groupData.standard_size) return;
    var measureBox = document.getElementById('efCfgMeasure');
    var stdBox     = document.getElementById('efCfgStdSize');
    var wSel       = document.getElementById('efCfgStdWidth');
    var hSel       = document.getElementById('efCfgStdHeight');
    if (!measureBox || !stdBox || !wSel || !hSel) return;

    measureBox.style.display = 'none';
    stdBox.style.display = '';
    /* Hide the W+H size badge section — it doesn't apply to width-tier pricing */
    var sizeSection = document.getElementById('efCfgSizeSection');
    if (sizeSection) sizeSection.style.display = 'none';

    var widths  = groupData.size || [];
    var heights = groupData.size_height || [];

    widths.forEach(function(w, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = w.label + (w.price > 0 ? '  (+$' + w.price + ')' : '');
      wSel.appendChild(opt);
    });
    heights.forEach(function(h, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = h.label;
      hSel.appendChild(opt);
    });

    function applySelections() {
      var wIdx = wSel.value;
      var hIdx = hSel.value;
      if (wIdx === '' || hIdx === '') {
        delete selections._width;
        delete selections._height;
        delete selections.size;
        delete surcharges.size; delete surcharges.size_height;
        updatePrice();
        return;
      }
      var w = widths[parseInt(wIdx, 10)];
      var h = heights[parseInt(hIdx, 10)];
      selections._width  = w.label;
      selections._height = h.label;
      selections.size    = w.label;
      surcharges.size = {
        amount:    (w.price || 0) * 100,
        label:     w.label,
        variantId: w.variantId || null
      };
      updatePrice();
    }

    wSel.addEventListener('change', function() {
      hSel.disabled = (wSel.value === '');
      if (wSel.value === '') {
        hSel.value = '';
      }
      applySelections();
    });
    hSel.addEventListener('change', applySelections);
  }

  /* ────────────────────────────────────
     SIMPLE RANGE SELECTS (cfg-simple)
     ──────────────────────────────────── */
  function handleSimpleRanges() {
    if (cfgType !== 'cfg-simple') return;
    if (!groupData || !groupData.simple_width) {
      console.warn('[EF-CFG] cfg-simple: no range data found for product "' + prodTitle + '". Matched group:', matchedGroup);
      return;
    }
    var wSel = document.getElementById('efCfgSimpleWidth');
    var hSel = document.getElementById('efCfgSimpleHeight');
    if (!wSel || !hSel) return;

    var widthData = groupData.simple_width || [];
    var heightSets = groupData.simple_height || [];
    var modelSets = groupData.simple_models || [];
    var dimsEl = document.getElementById('efCfgSimpleDims');
    var dimsValEl = document.getElementById('efCfgSimpleDimsValue');

    function showModelDims(wIdx, hIdx) {
      if (!dimsEl || !dimsValEl) return;
      var models = modelSets[wIdx];
      if (models && models[hIdx]) {
        var m = models[hIdx];
        dimsValEl.innerHTML = '<strong>' + m.name + '</strong><br>Overall: ' + m.overall;
        dimsEl.style.display = '';
      } else {
        dimsEl.style.display = 'none';
      }
    }

    widthData.forEach(function(w, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = w.label + (w.price > 0 ? ' (+$' + w.price + ')' : '');
      opt.dataset.price = w.price || 0;
      opt.dataset.variantId = w.variantId || '';
      wSel.appendChild(opt);
    });

    function populateHeight(widthIdx) {
      hSel.innerHTML = '<option value="">Select height range...</option>';
      var heights = heightSets[widthIdx] || [];
      heights.forEach(function(h, i) {
        var opt = document.createElement('option');
        opt.value = i;
        opt.textContent = h.label + (h.price > 0 ? ' (+$' + h.price + ')' : '');
        opt.dataset.price = h.price || 0;
        opt.dataset.variantId = h.variantId || '';
        hSel.appendChild(opt);
      });
      hSel.disabled = false;
      delete selections.simple_height;
      delete surcharges.simple_height;
      if (dimsEl) dimsEl.style.display = 'none';
      updatePrice();
    }

    wSel.addEventListener('change', function() {
      wSel.style.borderColor = '';
      if (wSel.value === '') {
        hSel.innerHTML = '<option value="">Select width first...</option>';
        hSel.disabled = true;
        delete selections.simple_width;
        delete surcharges.simple_width;
        delete selections.simple_height;
        delete surcharges.simple_height;
        updatePrice();
        return;
      }
      var idx = parseInt(wSel.value, 10);
      var w = widthData[idx];
      selections.simple_width = w.label;
      surcharges.simple_width = { amount: (w.price || 0) * 100, label: w.label, variantId: w.variantId || null };
      populateHeight(idx);
    });

    hSel.addEventListener('change', function() {
      hSel.style.borderColor = '';
      if (hSel.value === '') {
        delete selections.simple_height;
        delete surcharges.simple_height;
        updatePrice();
        return;
      }
      var wIdx = parseInt(wSel.value, 10);
      var hIdx = parseInt(hSel.value, 10);
      var h = (heightSets[wIdx] || [])[hIdx];
      if (h) {
        selections.simple_height = h.label;
        surcharges.simple_height = { amount: (h.price || 0) * 100, label: h.label, variantId: h.variantId || null };
        showModelDims(wIdx, hIdx);
      }
      updatePrice();
    });

    /* Preselect first available width + first matching height so ATC is
       click-ready on page load. Buyer changes the dropdowns if their fireplace
       falls outside the default range — but for the most common purchase path
       we remove the friction of forcing two selections before checkout. */
    if (widthData.length > 0) {
      wSel.value = '0';
      wSel.dispatchEvent(new Event('change'));
      var firstHeights = heightSets[0] || [];
      if (firstHeights.length > 0) {
        hSel.value = '0';
        hSel.dispatchEvent(new Event('change'));
      }
    }
  }

  /* ────────────────────────────────────
     PRICE CALCULATION & DISPLAY
     ──────────────────────────────────── */
  function updatePrice() {
    var linesEl = document.getElementById('efCfgPriceLines');
    linesEl.innerHTML = '';

    var total = basePrice;
    var displayBase = money(basePrice);

    // Base price line
    addPriceLine(linesEl, 'Base Price', displayBase, false);

    // Surcharges
    var keys = Object.keys(surcharges);
    keys.forEach(function(k) {
      var s = surcharges[k];
      if (s.amount > 0) {
        total += s.amount;
        var fieldLabel = formatFieldLabel(k);
        addPriceLine(linesEl, '+ ' + fieldLabel + ' (' + s.label + ')', '+' + money(s.amount), true);
      }
    });

    document.getElementById('efCfgTotalPrice').textContent = money(total);

    /* Puls ceny — mikrofeedback przy każdej zmianie konfiguracji (2026-07-15) */
    var _tpop = document.getElementById('efCfgTotalPrice');
    if (_tpop) { _tpop.classList.remove('ef-price-pop'); void _tpop.offsetWidth; _tpop.classList.add('ef-price-pop'); }

    // Update main product price display on page
    var mainPrice = document.getElementById('ef-price-display');
    if (mainPrice) mainPrice.textContent = money(total);

    // Update compare-at price — scale proportionally or hide if total exceeds it
    var compareEl = document.querySelector('.ef-pd-price-compare');
    var saveEl = document.querySelector('.ef-pd-price-save');
    if (compareEl) {
      var origCompare = (parseInt(document.getElementById('efCfg').dataset.comparePrice, 10) || 0);
      var origBase = basePrice;
      if (origCompare > 0 && origBase > 0) {
        // Scale compare-at proportionally: compare_ratio * total
        var ratio = origCompare / origBase;
        var scaledCompare = Math.round(total * ratio / 100) * 100;
        if (scaledCompare > total) {
          compareEl.textContent = money(scaledCompare);
          compareEl.style.display = '';
          /* 2026-05-11 — SAVE badge was static from Liquid (only base savings).
             Now sync with scaledCompare so badge = displayed_compare - total. */
          if (saveEl) {
            saveEl.textContent = 'Save ' + money(scaledCompare - total);
            saveEl.style.display = '';
          }
        } else {
          // Compare would be less than total — hide it
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
    }

    // Update ATC button text
    var atc = document.getElementById('efCfgATC');
    if (atc) atc.textContent = 'Add to Cart \u2014 ' + money(total);

    // Review step price breakdown
    var reviewPB = document.getElementById('efCfgPriceBreakdownReview');
    if (reviewPB) reviewPB.innerHTML = linesEl.innerHTML;

    /* CRO 2026-04-29 \u2014 broadcast live price for ef-pd2-sticky-atc.js */
    try {
      window.dispatchEvent(new CustomEvent('ef-cfg:price-changed', {
        detail: { totalCents: total, allSelectionsMade: _allSelectionsMade() }
      }));
    } catch (_) {}

    /* EF FUNNEL: price ping (P-007) \u2014 throttled to max 1/s, additive only */
    try {
      var _efNowTs = Date.now();
      if (!window._efCfgPriceTs || (_efNowTs - window._efCfgPriceTs) >= 1000) {
        window._efCfgPriceTs = _efNowTs;
        efTrack('ef_cfg_price', { total: Math.round(total) / 100 });
      }
    } catch (e) {}

    /* Quick Ship single-page flow (cfg-standard + cfg-simple) \u2014 no showStep
       advance to re-enable the ATC after a selection, so refresh disabled
       state from here. Custom flows always allow ATC, so this is a no-op
       for them. */
    updateATCState();
  }

  function addPriceLine(container, label, value, isSurcharge) {
    var div = document.createElement('div');
    div.className = 'ef-cfg-price-line' + (isSurcharge ? ' ef-cfg-price-line--surcharge' : '');
    div.innerHTML = '<span>' + escHtml(label) + '</span><span class="ef-cfg-price-line__value">' + escHtml(value) + '</span>';
    container.appendChild(div);
  }

  function formatFieldLabel(key) {
    var map = {
      size: 'Size',
      size_height: 'Height Increase',
      finish: 'Finish',
      fireplace_type: 'Fireplace Type',
      firebox_type: 'Firebox Type',
      fit_type: 'Fit Type',
      frame_width: 'Frame Width',
      door_fit: 'Door Fit Type',
      style_finish: 'Style Finish',
      hardware_finish: 'Hardware Finish',
      door_type: 'Door Type',
      side_panel: 'Tri-Fold Side Panels',
      handle: 'Handle',
      glass: 'Glass',
      mesh: 'Mesh Screen',
      draft_control: 'Draft Control',
      pattern: 'Pattern'
    };
    /* Extras are keyed extra_<slug> (multi-select). They all report as "Extra" so the price
       breakdown reads "+ Extra (Key Lock)" and the cart line item carries
       _option_type: "Extra". EF_STOLL_EXTRAS_20260829 */
    if (key.indexOf('extra_') === 0) return 'Extra';
    return map[key] || key.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }

  /* Human-readable selection value (e.g. hardware "__match__" → "Match Frame"). */
  function selValDisplay(field, v) {
    if (field === 'hardware_finish' && v === '__match__') return 'Match Frame';
    return v;
  }

  /* ────────────────────────────────────
     REVIEW STEP
     ──────────────────────────────────── */
  function buildReview() {
    var grid = document.getElementById('efCfgReviewGrid');
    grid.innerHTML = '';

    // Fireplace Type (Step 1)
    if (selections.fireplace_type) {
      var sFP = surcharges.fireplace_type;
      addReviewItem(grid, 'Fireplace Type', selections.fireplace_type, sFP ? sFP.amount : 0);
    }
    if (selections.firebox_type) {
      var sFB = surcharges.firebox_type;
      addReviewItem(grid, 'Firebox Type', selections.firebox_type, sFB ? sFB.amount : 0);
    }

    // Measurements (Step 2)
    if (selections._width) {
      addReviewItem(grid, 'Width', selections._width + '"');
    }
    if (selections._height) {
      addReviewItem(grid, isArch ? 'Center Peak Height' : 'Height', selections._height + '"');
    }
    if (isArch && selections._side_height) {
      addReviewItem(grid, 'Side Height', selections._side_height + '"');
    }
    if (selections._frame_left) {
      addReviewItem(grid, 'Custom Frame Width', 'L:' + selections._frame_left + ' R:' + selections._frame_right + ' T:' + selections._frame_top + ' B:' + selections._frame_bottom);
    }
    if (selections.size) {
      var sPrice = surcharges.size ? surcharges.size.amount : 0;
      addReviewItem(grid, 'Opening Size', selections.size, sPrice);
    }
    if (selections.simple_width) {
      var sW = surcharges.simple_width;
      addReviewItem(grid, 'Opening Width', selections.simple_width, sW ? sW.amount : 0);
    }
    if (selections.simple_height) {
      var sH = surcharges.simple_height;
      addReviewItem(grid, 'Opening Height', selections.simple_height, sH ? sH.amount : 0);
    }
    if (selections.variant) {
      addReviewItem(grid, 'Selected Variant', selections.variant);
    }

    // Remaining selections (Style, Finish, Glass)
    var order = ['fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','hardware_finish','glass','mesh','draft_control'];
    order.forEach(function(field) {
      if (!selections[field]) return;
      /* Hardware finish: show "Match Frame" for the included default, real color otherwise. */
      var val = (field === 'hardware_finish' && selections[field] === '__match__') ? 'Match Frame' : selections[field];
      var s = surcharges[field];
      addReviewItem(grid, formatFieldLabel(field), val, s ? s.amount : 0);
    });

    /* Extras (EF_STOLL_EXTRAS_20260829) — one summary row listing every ticked add-on
       with their combined surcharge. */
    var _revExtras = efSelectedExtras();
    if (_revExtras.length) {
      var _exTotal = 0;
      _revExtras.forEach(function (e) { _exTotal += e.amount; });
      addReviewItem(grid, 'Extras', _revExtras.map(function (e) { return e.label; }).join(', '), _exTotal);
    }

    // Price breakdown
    updatePrice();
  }

  /* Map review labels to step indices for "Edit" links — varies by cfgType */
  var reviewStepMap;
  if (cfgType === 'cfg-standard') {
    reviewStepMap = { 'Selected Variant': 0, 'Size': 0, 'Opening Size': 0 };
  } else if (cfgType === 'cfg-simple') {
    reviewStepMap = { 'Opening Width': 0, 'Opening Height': 0 };
  } else {
    reviewStepMap = {
      'Fireplace Type': 0, 'Firebox Type': 0,
      'Width': 1, 'Height': 1, 'Opening Size': 1, 'Selected Variant': 1, 'Size': 1,
      'Fit Type': 2, 'Frame Width': 2, 'Door Fit Type': 2, 'Door Type': 2, 'Handle': 2, 'Pattern': 2,
      'Finish': 3, 'Style Finish': 3, 'Hardware Finish': 3,
      'Glass': 4, 'Mesh': 4, 'Mesh Screen': 4, 'Draft Control': 4, 'Extras': 4
    };
  }

  /* Strip verbose descriptions — keep only the short label before separators */
  function shortenValue(val) {
    if (!val) return '';
    /* Remove everything after common separators: " — ", " – ", " - ", " · " */
    val = val.split(/\s[—–\-]\s/)[0];
    /* Trim "Only" suffix */
    val = val.replace(/\s+Only$/i, '');
    return val.trim();
  }

  function addReviewItem(container, label, value, surchargeAmount) {
    var div = document.createElement('div');
    div.className = 'ef-cfg-review-item';
    var shortVal = shortenValue(value);
    /* Visual chip (2026-05-30): show the selected option's image / finish swatch next to
       each row — turns the text summary into a luxury spec sheet. Fully defensive: if no
       image is found the row renders exactly as before. Reads from the rendered (possibly
       hidden) option cards/swatches via their aria-checked state. */
    var THUMB_SEL = {'Fireplace Type':'[data-group="fireplace_type"]','Firebox Type':'[data-group="firebox_type"]','Fit Type':'[data-group="fit_type"]','Door Type':'[data-group="door_type"]','Handle':'[data-group="handle"]','Hardware Finish':'#efCfgHardwareGrid','Glass':'[data-group="glass"]','Mesh':'[data-group="mesh"]','Mesh Screen':'[data-group="mesh"]','Draft Control':'[data-group="draft_control"]'};
    var thumbHtml = '';
    function _efChip(bgImg, bgColor){
      /* style.backgroundImage returns url("...") with DOUBLE quotes — swap to single so it
         doesn't break the double-quoted style="" attribute (this was the empty-chip bug). */
      if (bgImg && bgImg !== 'none') return '<span class="ef-cfg-review-item__thumb" style="background-image:' + bgImg.replace(/"/g, "'") + '"></span>';
      if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') return '<span class="ef-cfg-review-item__thumb ef-cfg-review-item__thumb--color" style="background:' + bgColor + '"></span>';
      return '';
    }
    try {
      if (label === 'Finish' || label === 'Style Finish') {
        /* Primary source: the appearance captured at selection time onto #efCfg[data-finish-chip]
           (robust against grid re-renders / image-less finishes). */
        var _fc = ''; try { var _efRt = document.getElementById('efCfg'); _fc = (label === 'Finish' && _efRt) ? (_efRt.dataset.finishChip || '') : ''; } catch (e) {}
        if (_fc) { thumbHtml = (_fc.indexOf('url(') === 0) ? _efChip(_fc, '') : _efChip('', _fc); }
        /* Fallback: preview swatch mirrors the selected finish image; then grid swatch + computed. */
        var _pv = thumbHtml ? null : document.getElementById(label === 'Style Finish' ? 'efCfgStyleFinishPreviewSwatch' : 'efCfgFinishPreviewSwatch');
        var _gc = document.querySelector((label === 'Style Finish' ? '#efCfgStyleFinishGrid' : '#efCfgSwatchGrid') + ' .ef-cfg-swatch[aria-checked="true"] .ef-cfg-swatch__circle');
        var _bgi = (_pv && _pv.style.backgroundImage) || (_gc && _gc.style.backgroundImage) || '';
        var _bgc = '';
        if (!_bgi || _bgi === 'none') {
          var _src = _gc || _pv;
          if (_src) { var _cs = getComputedStyle(_src); _bgi = _cs.backgroundImage; _bgc = _cs.backgroundColor; }
        }
        if (!thumbHtml) thumbHtml = _efChip(_bgi, _bgc);
      } else {
        var _csel = THUMB_SEL[label];
        if (_csel) {
          var _grp = document.querySelector(_csel);
          var _sel = _grp && _grp.querySelector('.ef-cfg-card[aria-checked="true"], .ef-cfg-swatch[aria-checked="true"]');
          if (_sel) {
            var _im = _sel.querySelector('img');
            if (_im && _im.getAttribute('src')) {
              thumbHtml = '<span class="ef-cfg-review-item__thumb" style="background-image:url(\'' + _im.getAttribute('src').replace(/'/g, '%27') + '\')"></span>';
            } else {
              var _c = _sel.querySelector('.ef-cfg-swatch__circle');
              if (_c) { var _cs2 = getComputedStyle(_c); thumbHtml = _efChip(_c.style.backgroundImage || _cs2.backgroundImage, _c.style.backgroundColor || _cs2.backgroundColor); }
            }
          }
        }
      }
    } catch (e) {}
    var html = thumbHtml + '<span class="ef-cfg-review-item__label">' + escHtml(label) + '</span>';
    html += '<span class="ef-cfg-review-item__value">' + escHtml(shortVal) + '</span>';
    if (surchargeAmount && surchargeAmount > 0) {
      html += '<span class="ef-cfg-review-item__price">+' + money(surchargeAmount) + '</span>';
    }
    var stepIdx = reviewStepMap[label];
    if (stepIdx !== undefined) {
      /* Bronze sentence-case "Edit" text link (typography-spec rec). aria-label
         disambiguates 10 identical links for SR users (a11y rec). */
      var ariaLabel = 'Edit ' + label.toLowerCase();
      html += '<a href="#" class="ef-cfg-review-item__edit" data-edit-step="' + stepIdx + '" aria-label="' + escHtml(ariaLabel) + '">Edit</a>';
    }
    div.innerHTML = html;
    container.appendChild(div);
  }

  /* ────────────────────────────────────
     NAVIGATION
     ──────────────────────────────────── */
  function goToStep(idx) { showStep(idx); }

  /* 2026-05-06 — Expose validate-and-advance helper for sticky ATC.
     Sticky ATC click in locked state should:
       1. Validate current step (highlights missing required fields w/ red outline + msg)
       2. If valid → advance to next step
       3. If invalid → user sees red borders + "Please make a selection" (no advance)
     Returns: 'advanced' | 'highlighted' | 'unlocked' (when on last step + valid). */
  window.efCfgValidateAndAdvance = function() {
    if (!validateStep(curStep)) return 'highlighted';
    /* Find next visible step */
    var next = curStep + 1;
    while (next < stepNames.length && _isSkippedStep(next)) next++;
    if (next >= stepNames.length) return 'unlocked';
    goToStep(next);
    return 'advanced';
  };

  function showStep(idx, opts) {
    curStep = idx;
    /* EF FUNNEL: step view (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_step_view', {
        step_index: idx,
        step_name: stepNames[idx] || ('step-' + idx)
      });
    } catch (e) {}
    // Hide all steps
    root.querySelectorAll('.ef-cfg-step').forEach(function(s) { s.classList.remove('is-visible'); });
    // Hide swatch popup left over from finish selection — without this, the
    // selected-finish popup persists onto next step (Glass / Review etc) on
    // every device, looking like a stuck overlay. Bug reported 2026-04-28.
    var _swatchPopup = document.getElementById('efCfgSwatchPopup');
    if (_swatchPopup) _swatchPopup.classList.remove('is-visible');

    // Lazy-load heavy scripts as needed
    if (idx >= 1 && typeof efLoadScript === 'function') {
      efLoadScript(document.getElementById('efCfg').dataset.imagesUrl, 'efCfgImagesLoaded');
    }
    if (idx === totalSteps - 1 && typeof efLoadScript === 'function') {
      efLoadScript(document.getElementById('efCfg').dataset.surchargesUrl, 'efCfgSurchargesLoaded');
    }

    // Show current.
    // Single-page types (cfg-standard + cfg-simple) collapsed step 0 + review
    // into one view — no efCfgStepReview exists for them, render step 0 always.
    var stepEl;
    var _isSinglePage = (cfgType === 'cfg-standard' || cfgType === 'cfg-simple');
    if (idx === totalSteps - 1 && !_isSinglePage) {
      stepEl = document.getElementById('efCfgStepReview');
      buildReview();
    } else {
      stepEl = document.getElementById('efCfgStep' + idx);
    }
    if (stepEl) stepEl.classList.add('is-visible');

    if (typeof window._efUpdateFrameSvg === 'function') window._efUpdateFrameSvg();

    // Update eyebrow text "STEP X OF Y" (adjust for skipped steps)
    var _displayTotal = totalSteps - _totalSkipped();
    var _displayIdx = idx + 1 - _skippedBefore(idx);
    var eyebrow = stepEl ? stepEl.querySelector('.ef-cfg-step__eyebrow') : null;
    if (eyebrow) eyebrow.textContent = 'Step ' + _displayIdx + ' of ' + _displayTotal;

    updateProgress();

    // Update progressbar aria-valuenow
    var progNav = document.getElementById('efCfgProgress');
    if (progNav) progNav.setAttribute('aria-valuenow', _displayIdx);

    // Announce step change to screen readers
    var announcement = document.getElementById('ef-step-announcement');
    if (announcement) announcement.textContent = 'Step ' + _displayIdx + ' of ' + _displayTotal + ': ' + (stepNames[idx] || '');

    // Nav buttons
    var backBtn = document.getElementById('efCfgBack');
    var nextBtn = document.getElementById('efCfgNext');
    var quoteBtn = document.getElementById('ef-quote-trigger');
    var prevVisIdx = idx - 1;
    while (prevVisIdx >= 0 && _isSkippedStep(prevVisIdx)) prevVisIdx--;
    backBtn.style.display = (prevVisIdx < 0) ? 'none' : '';

    var atcBtn = document.getElementById('efCfgATC');
    var navWrap = document.getElementById('efCfgNav');
    /* Review-step extras: A2 More Payment Options + A3 Express Checkout +
       A1 money-back guarantee. Hidden via [hidden] attr on non-review steps. */
    var reviewExtras = document.getElementById('efCfgReviewExtras');
    if (idx === totalSteps - 1) {
      nextBtn.style.display = 'none';
      if (quoteBtn) quoteBtn.style.display = 'none';
      if (atcBtn) { atcBtn.style.display = ''; atcBtn.textContent = 'Add to Cart \u2014 ' + money(calcTotal()); }
      if (navWrap) navWrap.classList.add('is-review-step');
      if (reviewExtras) reviewExtras.hidden = false;
    } else {
      nextBtn.style.display = '';
      if (quoteBtn) quoteBtn.style.display = '';
      var nextVisIdx = idx + 1;
      while (nextVisIdx < totalSteps && _isSkippedStep(nextVisIdx)) nextVisIdx++;
      var nextStepName = stepNames[nextVisIdx] || '';
      /* Desktop: full "Next: Measurements" label. Mobile: just step name + arrow
         (was truncating on 375px viewport). 2026-05-03 — dual span swap. */
      nextBtn.innerHTML = '<span class="ef-desktop-only">Next: ' + nextStepName + '</span><span class="ef-mobile-only">' + nextStepName + '</span> <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
      if (atcBtn) atcBtn.style.display = 'none';
      if (navWrap) navWrap.classList.remove('is-review-step');
      if (reviewExtras) reviewExtras.hidden = true;
    }

    /* Helper line rotation \u2014 copy specialist consensus 2026-05-03 (technical
       + CRO copywriters both rejected poetic Cormorant italic in favor of
       sentence-case Inter as "system hint" register the technical buyer trusts).
       Each line addresses a specific anxiety/signal for that step's decision. */
    var helperEl = document.getElementById('efCfgNavHelper');
    if (helperEl) {
      var helperBeats = [
        '3 min \u00b7 6 steps \u00b7 save anytime',                              /* attribution + reversibility */
        'Measure to nearest 1/8\u2033 \u2014 fractions or decimals OK. Expert review before building.',  /* anxiety reduction */
        'Overlap covers gaps. Inside sits flush against the frame.',              /* decision aid */
        'Free finish samples ship before we cut metal.',                          /* color-confidence proof */
        'Tempered safety glass \u00b7 Built in 14\u201321 days.',                  /* spec + lead-time */
        'A real person reviews every order before production.'                    /* commitment / risk reversal */
      ];
      helperEl.textContent = helperBeats[Math.min(idx, helperBeats.length - 1)] || helperBeats[0];
    }

    /* ROUND 5 (2026-04-29) \u2014 Update simple stepbar (Step X of Y \u2014 Name + Next + segmented bar).
       Reuses _displayIdx / _displayTotal / stepNames already computed above (~line 2730).
       Bar uses segmented bronze treatment matching .ef-cfg-strip \u2014 premium, tactile,
       buyer counts progress without reading text. */
    var sbPos  = document.getElementById('efPd2StepPos');
    var sbName = document.getElementById('efPd2StepName');
    var sbNext = document.getElementById('efPd2StepNext');
    var sbBar  = document.getElementById('efPd2Stepbar');
    if (sbPos)  sbPos.textContent  = 'Step ' + _displayIdx + ' of ' + _displayTotal;
    if (sbName) sbName.textContent = stepNames[idx] || '';
    if (sbNext) {
      if (idx === totalSteps - 1) {
        sbNext.innerHTML = '<span class="ef-pd2-stepbar__ready">\u2713 Ready to checkout</span>';
      } else {
        var _nbVisIdx = idx + 1;
        while (_nbVisIdx < totalSteps && _isSkippedStep(_nbVisIdx)) _nbVisIdx++;
        sbNext.textContent = 'Next: ' + (stepNames[_nbVisIdx] || '');
      }
    }
    /* Sync segmented bar \u2014 same logic as luxury strip:
       segments before _displayIdx-1 = .is-done, segment at _displayIdx-1 = .is-active. */
    var sbSegs = document.querySelectorAll('#efPd2StepBarTrack .ef-pd2-stepbar__seg');
    sbSegs.forEach(function(seg, sIdx) {
      seg.classList.remove('is-done', 'is-active');
      if (sIdx < _displayIdx - 1) seg.classList.add('is-done');
      else if (sIdx === _displayIdx - 1) seg.classList.add('is-active');
    });
    if (sbBar) sbBar.classList.toggle('is-final', idx === totalSteps - 1);

    // Enable/disable ATC
    updateATCState();

    /* Old sticky bar toggling (#efStickyATC + #ef-sticky-atc) removed 2026-04-29.
       Both legacy bars only showed on the last step; replaced by the new always-visible
       dark 3-state sticky bar (#efPd2Sticky). The new bar reads state via the
       'ef-cfg:state-changed' / 'ef-cfg:price-changed' events dispatched below. */

    // Scroll to top of configurator (skip on initial page load — keep user at gallery)
    if (!opts || !opts.skipScroll) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* CRO 2026-04-29 — broadcast state for ef-pd2-sticky-atc.js (read-only listener).
       NOTE: do NOT call validateStep() here — it has side effects (scrolls, sets
       red outlines, injects "Please make a selection" error UI). Sticky bar uses
       realAtc.disabled instead. */
    try {
      window.dispatchEvent(new CustomEvent('ef-cfg:state-changed', {
        detail: {
          curStep: idx,
          totalSteps: totalSteps,
          totalSkipped: _totalSkipped(),
          isLast: (idx === totalSteps - 1),
          totalCents: calcTotal(),
          cfgType: cfgType,
          /* 2026-05-06 — sticky ATC unlocks on this flag, not on review-step position. */
          allSelectionsMade: _allSelectionsMade()
        }
      }));
    } catch (_) {}
  }

  function updateATCState() {
    var atc = document.getElementById('efCfgATC');
    if (!atc) return;
    if (cfgType === 'cfg-standard') {
      atc.disabled = !selections.variant;
    } else if (cfgType === 'cfg-simple') {
      atc.disabled = !selections.simple_width || !selections.simple_height;
    } else {
      // For custom types, always allow (user chose what they wanted)
      atc.disabled = false;
    }
  }

  function nextVisibleStep(from, dir) {
    var s = from + dir;
    while (s >= 0 && s < totalSteps) {
      if (_isSkippedStep(s)) { s += dir; continue; }
      return s;
    }
    return from;
  }

  document.getElementById('efCfgNext').addEventListener('click', function() {
    if (curStep < totalSteps - 1) {
      if (validateStep(curStep)) {
        showStep(nextVisibleStep(curStep, 1));
      }
    }
  });

  /* ────────────────────────────────────
     PASSIVE COMPLETENESS CHECK (2026-05-06)
     Returns true when every required selection has been made — regardless of
     which step the user is currently viewing. Used by the sticky ATC bar so it
     unlocks based on selections rather than navigation position. NO side effects
     (no scrolls, no red outlines, no DOM mutations).
     ──────────────────────────────────── */
  function _allSelectionsMade() {
    if (cfgType === 'cfg-standard') return !!selections.variant;
    if (cfgType === 'cfg-simple')   return !!(selections.simple_width && selections.simple_height);
    /* cfg-custom* / cfg-arch flow */
    /* Measurements: standard-size dropdowns OR W/H inputs OR Brookfield Deluxe 6 inputs */
    if (groupData && groupData.standard_size) {
      var stdW = document.getElementById('efCfgStdWidth');
      var stdH = document.getElementById('efCfgStdHeight');
      if (!stdW || !stdW.value || !stdH || !stdH.value) return false;
    } else if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
      var ids = ['efCfgDeluxeOverallW','efCfgDeluxeOverallH','efCfgDeluxeOpeningW',
                 'efCfgDeluxeOpeningH','efCfgDeluxeTopOffset','efCfgDeluxeBottomOffset'];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (!el || !String(el.value || '').trim()) return false;
      }
    } else {
      if (!selections._width || !selections._height) return false;
    }
    if (!(selections.door_type || selections.fit_type)) return false;
    if (!selections.finish) return false;
    if (!(selections.glass || selections.mesh)) return false;
    if (cfgType === 'cfg-custom-full' || cfgType === 'cfg-custom-premium') {
      if (!selections.draft_control) return false;
    }
    if (cfgType === 'cfg-custom-premium') {
      if (!selections.frame_width) return false;
    }
    return true;
  }

  /* ────────────────────────────────────
     VALIDATION
     ──────────────────────────────────── */
  function validateStep(stepIdx) {
    /* Step 0: Fireplace Type — need fireplace_type + firebox_type (or variant for cfg-standard) */
    if (stepIdx === 0) {
      if (cfgType === 'cfg-standard') {
        var sel = document.getElementById('efCfgVariantSelect');
        if (sel && !sel.value) {
          sel.style.borderColor = '#C0533A';
          sel.focus();
          return false;
        }
        return true;
      }
      if (cfgType === 'cfg-simple') {
        var wSel = document.getElementById('efCfgSimpleWidth');
        var hSel = document.getElementById('efCfgSimpleHeight');
        if (wSel && !wSel.value) {
          wSel.style.borderColor = '#C0533A';
          wSel.focus();
          return false;
        }
        if (hSel && !hSel.value) {
          hSel.style.borderColor = '#C0533A';
          hSel.focus();
          return false;
        }
        return true;
      }
      /* For custom types: validate card groups in step 0 (falls through to generic card validation below) */
    }

    /* Measurements validation — Step 1 for custom types */
    var isMeasureStep = (stepIdx === 1 && cfgType !== 'cfg-standard' && cfgType !== 'cfg-simple');
    if (isMeasureStep) {
      /* Standard-size mode (Columbia + future width-tier products): validate
         the two dropdowns, not the hidden W/H text inputs. */
      if (groupData && groupData.standard_size) {
        var stdWSel = document.getElementById('efCfgStdWidth');
        var stdHSel = document.getElementById('efCfgStdHeight');
        if (stdWSel && !stdWSel.value) {
          stdWSel.style.borderColor = '#C0533A';
          stdWSel.focus();
          return false;
        }
        if (stdHSel && !stdHSel.value) {
          stdHSel.style.borderColor = '#C0533A';
          stdHSel.focus();
          return false;
        }
        return true;
      }
      /* Brookfield Deluxe — validate the 6 measurement inputs instead of the
         hidden default width/height. */
      if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
        var deluxeIds = ['efCfgDeluxeOverallW', 'efCfgDeluxeOverallH', 'efCfgDeluxeOpeningW',
                         'efCfgDeluxeOpeningH', 'efCfgDeluxeTopOffset', 'efCfgDeluxeBottomOffset'];
        for (var di = 0; di < deluxeIds.length; di++) {
          var dEl = document.getElementById(deluxeIds[di]);
          if (dEl && !String(dEl.value || '').trim()) {
            dEl.style.borderColor = '#C0533A';
            dEl.focus();
            return false;
          }
        }
        return true;
      }
      var wEl = document.getElementById('efCfgWidth');
      var hEl = document.getElementById('efCfgHeight');
      if (wEl && hEl && (!wEl.value.trim() || !hEl.value.trim())) {
        if (!wEl.value.trim()) { wEl.style.borderColor = '#C0533A'; wEl.focus(); }
        else { hEl.style.borderColor = '#C0533A'; hEl.focus(); }
        return false;
      }
      return true;
    }

    /* 2026-05-06 — Step 3 Finish: swatch grid is NOT wrapped in .ef-cfg-group,
       so the generic loop below skips it. Explicit selections.finish check here
       prevents user from advancing without picking a finish swatch. */
    if (stepIdx === 3 && cfgType !== 'cfg-standard' && cfgType !== 'cfg-simple') {
      if (!selections.finish) {
        var swatchGridEl = document.getElementById('efCfgSwatchGrid');
        if (swatchGridEl) {
          swatchGridEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          swatchGridEl.style.outline = '2px solid #C0533A';
          swatchGridEl.style.outlineOffset = '4px';
          swatchGridEl.style.borderRadius = '8px';
          setTimeout(function() {
            swatchGridEl.style.outline = '';
            swatchGridEl.style.outlineOffset = '';
          }, 3000);
          /* Show "Please make a selection" near the title */
          var subtitle = document.querySelector('#efCfgStep3 .ef-cfg-step__subtitle');
          var errId = 'efCfgErr_finish';
          if (subtitle && !document.getElementById(errId)) {
            var err = document.createElement('div');
            err.id = errId;
            err.style.cssText = 'color:#C0533A;font-size:12px;margin-top:6px;font-weight:500;';
            err.textContent = 'Please make a selection';
            subtitle.after(err);
            setTimeout(function() { var e = document.getElementById(errId); if (e) e.remove(); }, 4000);
          }
        }
        return false;
      }
    }

    /* Steps 1-4: check required card/swatch selections */
    var stepEl = document.getElementById('efCfgStep' + stepIdx);
    if (!stepEl) return true;

    var groups = stepEl.querySelectorAll('.ef-cfg-group');
    for (var i = 0; i < groups.length; i++) {
      var grp = groups[i];
      /* Skip hidden groups */
      if (grp.style.display === 'none') continue;
      /* Skip disabled groups (e.g. mesh dimmed when glass = Replace with Mesh) — no selection required */
      if (grp.classList.contains('ef-cfg-group--disabled')) continue;
      /* Extras (EF_STOLL_EXTRAS_20260829) are an optional multi-select — never required,
         so they must never block Next / Add to Cart. */
      if (grp.dataset.group === 'extras') continue;
      var groupName = grp.dataset.group || '';

      /* Check if group has any rendered options */
      var grid = grp.querySelector('.ef-cfg-group__grid');
      var hasCards = grid && grid.children.length > 0;
      var hasSwatches = grp.querySelector('.ef-cfg-swatch-grid');

      if (hasCards) {
        var selected = grid.querySelector('[aria-checked="true"]');
        if (!selected) {
          /* Scroll to this group and highlight */
          grp.scrollIntoView({ behavior: 'smooth', block: 'center' });
          grid.style.outline = '2px solid #C0533A';
          grid.style.outlineOffset = '4px';
          grid.style.borderRadius = '8px';
          setTimeout(function() { grid.style.outline = ''; grid.style.outlineOffset = ''; }, 3000);

          /* Show error message */
          var label = grp.querySelector('.ef-cfg-group__label');
          var errId = 'efCfgErr_' + groupName;
          var existing = document.getElementById(errId);
          if (!existing) {
            var err = document.createElement('div');
            err.id = errId;
            err.style.cssText = 'color:#C0533A;font-size:12px;margin-top:6px;font-weight:500;';
            err.textContent = 'Please make a selection';
            if (label) label.after(err);
          }
          setTimeout(function() { var e = document.getElementById(errId); if (e) e.remove(); }, 4000);
          return false;
        }
      }

      /* Finish step: check if swatch selected */
      if (groupName === 'finish' || hasSwatches) {
        if (!selections.finish) {
          grp.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var swatchGrid = grp.querySelector('.ef-cfg-swatch-grid');
          if (swatchGrid) {
            swatchGrid.style.outline = '2px solid #C0533A';
            swatchGrid.style.outlineOffset = '4px';
            setTimeout(function() { swatchGrid.style.outline = ''; }, 3000);
          }
          return false;
        }
      }
    }
    return true;
  }

  /* Clear error styling on input */
  var wInput = document.getElementById('efCfgWidth');
  var hInput = document.getElementById('efCfgHeight');
  if (wInput) wInput.addEventListener('input', function() { wInput.style.borderColor = ''; });
  if (hInput) hInput.addEventListener('input', function() { hInput.style.borderColor = ''; });

  document.getElementById('efCfgBack').addEventListener('click', function() {
    if (curStep > 0) showStep(nextVisibleStep(curStep, -1));
  });

  /* ────────────────────────────────────
     FILE UPLOAD
     ──────────────────────────────────── */
  (function() {
    var zone = document.getElementById('efCfgUpload');
    var input = document.getElementById('efCfgFileInput');
    if (!zone || !input) return;

    zone.addEventListener('click', function() { input.click(); });
    zone.addEventListener('dragover', function(e) { e.preventDefault(); zone.style.borderColor = 'var(--ef-bronze)'; });
    zone.addEventListener('dragleave', function() { zone.style.borderColor = ''; });
    zone.addEventListener('drop', function(e) {
      e.preventDefault();
      zone.style.borderColor = '';
      if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]);
    });
    input.addEventListener('change', function() {
      if (input.files.length) handleFile(input.files[0]);
    });

    function handleFile(file) {
      uploadedFile = file;
      zone.classList.add('has-file');
      document.getElementById('efCfgUploadName').textContent = file.name;
      uploadPhoto(file);

      var reader = new FileReader();
      reader.onload = function(ev) {
        var preview = document.getElementById('efCfgPhotoPreview');
        if (preview) { preview.src = ev.target.result; preview.style.display = 'block'; }
      };
      reader.readAsDataURL(file);
    }
  })();

  /* ────────────────────────────────────
     SIDEBAR TOGGLE (mobile)
     ──────────────────────────────────── */
  (function() {
    var sidebar = document.getElementById('efCfgSidebar');
    var toggle = document.getElementById('efCfgSidebarToggle');
    if (!toggle) return;
    toggle.addEventListener('click', function() {
      sidebar.classList.toggle('is-collapsed');
    });
  })();

  /* ────────────────────────────────────
     ADD TO CART
     ──────────────────────────────────── */
  document.getElementById('efCfgATC').addEventListener('click', function() {
    var atc = this;
    if (atc.disabled) return;
    if (_photoUploading) {
      atc.innerHTML = '<span class="ef-cfg-spinner"></span> Processing photo...';
      var _waitPhoto = setInterval(function() {
        if (!_photoUploading) { clearInterval(_waitPhoto); atc.click(); }
      }, 200);
      return;
    }
    /* 2026-05-11 — Required-measurement gate BEFORE ATC.
       Order received without Width/Height (config_id: mp1wetqv) — those props
       are only added if `selections._width/_height` are set. Without explicit
       blocking, the configurator allowed ATC submit with empty measurements.
       Custom Made products MUST have W+H. Standard/Simple have their own
       size selectors and are exempted.

       Brookfield Deluxe has its own 6-measurement gate later (line ~3420). */
    var skipWHGate = (cfgType === 'cfg-standard') ||
                     (cfgType === 'cfg-simple') ||
                     (matchedGroup === 'Fireplace Doors - Brookfield Deluxe');
    if (!skipWHGate) {
      var needsWidth = !selections._width && !selections.simple_width && !selections.size;
      var needsHeight = !selections._height && !selections.simple_height && !selections.size;
      if (needsWidth || needsHeight) {
        var missingM = [];
        if (needsWidth) missingM.push('Width');
        if (needsHeight) missingM.push(isArch ? 'Center Peak Height' : 'Height');
        atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + money(calcTotal());
        alert('Please enter your fireplace opening measurements before adding to cart:\n\n• ' + missingM.join('\n• '));
        /* Jump back to Measurements step so user sees the fields */
        try { goToStep(1); } catch(e) {}
        return;
      }
    }

    atc.disabled = true;
    atc.innerHTML = '<span class="ef-cfg-spinner"></span> Adding...';

    var items = [];
    var props = {};

    // Build line item properties
    if (selections._width) props['Width'] = selections._width + '"';
    if (selections._height) props[isArch ? 'Center Peak Height' : 'Height'] = selections._height + '"';
    if (isArch && selections._side_height) props['Side Height'] = selections._side_height + '"';
    if (selections.size) props['Opening Size'] = selections.size;
    if (selections.simple_width) props['Opening Width'] = selections.simple_width;
    if (selections.simple_height) props['Opening Height'] = selections.simple_height;
    if (selections._frame_left) props['Frame Left'] = selections._frame_left;
    if (selections._frame_right) props['Frame Right'] = selections._frame_right;
    if (selections._frame_top) props['Frame Top'] = selections._frame_top;
    if (selections._frame_bottom) props['Frame Bottom'] = selections._frame_bottom;

    var fieldOrder = ['fireplace_type','firebox_type','fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','hardware_finish','glass','mesh','draft_control'];
    fieldOrder.forEach(function(field) {
      if (selections[field]) {
        props[formatFieldLabel(field)] = selValDisplay(field, selections[field]);
      }
    });

    /* Extras (EF_STOLL_EXTRAS_20260829) — one readable property for the packing slip;
       each extra still rides in as its own surcharge line item below. */
    var _extras = efSelectedExtras();
    if (_extras.length) {
      props['Extras'] = _extras.map(function (e) { return e.label; }).join(', ');
    }

    // Photo URL (Cloudinary)
    if (photoURL) {
      props['_Photo URL'] = photoURL;
    }

    // Order notes
    var notes = document.getElementById('efCfgNotes');
    if (notes && notes.value.trim()) {
      props['_Notes'] = notes.value.trim();
    }

    /* Brookfield Deluxe Magnetic — capture the 6 measurement inputs as line
       item properties. These are required fields; if any is empty, block ATC. */
    if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
      var deluxeFields = [
        ['efCfgDeluxeOverallW',     'Overall Width'],
        ['efCfgDeluxeOverallH',     'Overall Height'],
        ['efCfgDeluxeOpeningW',     'Opening Width'],
        ['efCfgDeluxeOpeningH',     'Opening Height'],
        ['efCfgDeluxeTopOffset',    'Top of opening to top of fireplace'],
        ['efCfgDeluxeBottomOffset', 'Bottom of opening to bottom of fireplace']
      ];
      var missing = [];
      deluxeFields.forEach(function (f) {
        var el = document.getElementById(f[0]);
        var v = el ? String(el.value || '').trim() : '';
        if (!v) { missing.push(f[1]); return; }
        props['_' + f[1]] = v + '"';
      });
      if (missing.length) {
        atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + money(calcTotal());
        alert('Please fill in all 6 measurements before adding to cart:\n\n• ' + missing.join('\n• '));
        return;
      }
    }

    // Configured total price (for cart display)
    props['_Configured Price'] = money(calcTotal());

    // Unique config ID (to match surcharges to specific config, not just product title)
    var configId = Date.now().toString(36);
    props['_config_id'] = configId;

    /* EF FUNNEL: add to cart (P-007) — additive emission only */
    try {
      var _efSumParts = [];
      ['size', 'fit_type', 'door_type', 'finish', 'glass', 'mesh'].forEach(function (k) {
        if (selections[k]) _efSumParts.push(k + ':' + String(selections[k]).slice(0, 40));
      });
      efTrack('ef_cfg_atc', {
        total: Math.round(calcTotal()) / 100,
        config_summary: _efSumParts.join(' | ').slice(0, 200)
      });
    } catch (e) {}

    // Main product item
    var mainVid = variantId;
    // For cfg-standard, use the selected variant
    if (cfgType === 'cfg-standard') {
      var sel = document.getElementById('efCfgVariantSelect');
      if (sel && sel.value) mainVid = sel.value;
    }

    items.push({
      id: parseInt(mainVid, 10),
      quantity: 1,
      properties: props
    });

    /* Expose latest props + items + total for Express Checkout (worker path).
       Same object identity so when ATC re-runs after each click the values
       update for any subsequent Express Checkout. 2026-05-03. */
    window._efOrderSnapshot = {
      mainVariantId: parseInt(mainVid, 10),
      properties: Object.assign({}, props),
      totalCents: calcTotal(),
      productTitle: prodTitle
    };

    // Surcharge variant items
    Object.keys(surcharges).forEach(function(k) {
      var s = surcharges[k];
      if (s.variantId && s.amount > 0) {
        items.push({
          id: parseInt(s.variantId, 10),
          quantity: s.qty || 1,
          properties: {
            '_parent_product': prodTitle,
            '_option_type': formatFieldLabel(k),
            '_config_id': configId
          }
        });
      }
    });

    /* DEBUG: log full ATC payload so we can verify variant IDs match expected surcharges. */
    console.group('[EF-CFG] Add to Cart payload');
    console.log('Selections:', JSON.parse(JSON.stringify(selections)));
    console.log('Surcharges:', JSON.parse(JSON.stringify(surcharges)));
    console.log('Items being added:');
    items.forEach(function(it, i) {
      console.log('  [' + i + ']', 'variantId=' + it.id, 'qty=' + it.quantity, 'props=', it.properties);
    });
    console.groupEnd();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err) { console.error('[EF-CFG] Cart reject:', err); throw new Error(err.description || 'Cart error ' + res.status); });
      return res.json();
    })
    .then(function() {
      atc.innerHTML = 'Added to Cart \u2713';
      atc.style.background = 'var(--ef-green)';

      setTimeout(function() {
        var openCart = function() { if (window.EFCartDrawer) window.EFCartDrawer.open(); else window.location.href = '/cart'; };
        // "Complete Your Hearth" cross-sell \u2014 DOORS only, behind the draft flag (?hearth=1).
        // The door is already banked above, so this can never cost the sale. (2026-06-30)
        if (window.EFHearth && window.EFHearth.enabled() && cfgType !== 'cfg-screen') {
          window.EFHearth.show(openCart);
        } else {
          openCart();
        }
      }, 800);
    })
    .catch(function(err) {
      console.error('ATC error:', err);
      atc.disabled = false;
      atc.textContent = 'Error \u2014 Try Again';
      atc.style.background = '';
      setTimeout(function() {
        atc.textContent = 'Add to Cart \u2014 ' + money(calcTotal());
      }, 2000);
    });
  });

  function calcTotal() {
    /* Only sum surcharges that will actually be added as cart variants
       (matches the filter at /cart/add.js: s.variantId && s.amount > 0).
       Without this, "Configured Price" shown in cart drifts above the
       real Shopify subtotal whenever a priced option lacks a variantId. */
    var total = basePrice;
    Object.keys(surcharges).forEach(function(k) {
      var s = surcharges[k];
      if (s && s.variantId && s.amount > 0) total += s.amount;
    });
    return total;
  }

  var photoURL = '';
  var _photoUploading = false;

  function uploadPhoto(file) {
    if (!file || !file.type.match('image.*')) return;
    if (file.size > 10 * 1024 * 1024) { alert('File is too large. Maximum 10MB.'); return; }

    var nameEl = document.getElementById('efCfgUploadName');
    var uploadEl = document.getElementById('efCfgUpload');
    if (nameEl) { nameEl.textContent = 'Uploading ' + file.name + '...'; nameEl.style.display = 'block'; }
    if (uploadEl) uploadEl.classList.add('has-file');
    _photoUploading = true;

    /* Upload directly to Cloudinary (unsigned, no worker needed).
       Supports files up to 10MB, full resolution preserved. */
    var formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'ef_fireplace');
    formData.append('folder', 'fireplace-photos');

    fetch('https://api.cloudinary.com/v1_1/dcz6x0ccy/image/upload', {
      method: 'POST',
      body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.secure_url) {
        photoURL = data.secure_url;
        _photoUploading = false;
        if (nameEl) nameEl.textContent = file.name + ' — uploaded';
        var preview = document.getElementById('efCfgPhotoPreview');
        if (preview) { preview.src = photoURL; preview.style.display = 'block'; }
        var photoGuarantee = document.getElementById('efCfgPhotoGuarantee');
        if (photoGuarantee) photoGuarantee.hidden = false;
      } else {
        throw new Error(data.error ? data.error.message : 'Upload failed');
      }
    })
    .catch(function(err) {
      console.error('[EF-CFG] Photo upload error:', err);
      _photoUploading = false;
      if (nameEl) nameEl.textContent = file.name + ' — upload failed';
    });
  }

  /* ────────────────────────────────────
     HTML ESCAPE UTILITY
     ──────────────────────────────────── */
  function escHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ────────────────────────────────────
     EMAIL THIS CONFIGURATION
     ──────────────────────────────────── */
  var emailBtn = document.getElementById('efCfgEmailConfig');
  if (emailBtn) {
    emailBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var lines = [prodTitle, ''];
      if (selections._width) lines.push('Width: ' + selections._width + '"');
      if (selections._height) lines.push((isArch ? 'Center Peak Height: ' : 'Height: ') + selections._height + '"');
      if (isArch && selections._side_height) lines.push('Side Height: ' + selections._side_height + '"');
      if (selections._frame_left) lines.push('Custom Frame: L:' + selections._frame_left + ' R:' + selections._frame_right + ' T:' + selections._frame_top + ' B:' + selections._frame_bottom);
      if (selections.size) lines.push('Opening Size: ' + selections.size);
      var fieldOrder = ['fireplace_type','firebox_type','fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','hardware_finish','glass','mesh','draft_control'];
      fieldOrder.forEach(function(field) {
        if (selections[field]) lines.push(formatFieldLabel(field) + ': ' + selValDisplay(field, selections[field]));
      });
      lines.push('');
      lines.push('Total: ' + money(calcTotal()));
      lines.push('');
      lines.push('View product: ' + window.location.href);
      var subject = encodeURIComponent('My ' + prodTitle + ' Configuration');
      var body = encodeURIComponent(lines.join('\n'));
      window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
    });
  }

  /* ────────────────────────────────────
     REVIEW "EDIT" LINK DELEGATION
     ──────────────────────────────────── */
  var reviewGrid = document.getElementById('efCfgReviewGrid');
  if (reviewGrid) {
    reviewGrid.addEventListener('click', function(e) {
      var link = e.target.closest('.ef-cfg-review-item__edit');
      if (!link) return;
      e.preventDefault();
      var stepIdx = parseInt(link.getAttribute('data-edit-step'), 10);
      if (!isNaN(stepIdx)) goToStep(stepIdx);
    });
  }

  /* ────────────────────────────────────
     INIT
     ──────────────────────────────────── */
  /* Listen for cart changes (e.g. item removed from drawer) — reset ATC button */
  document.addEventListener('cart:change', function() {
    var atc = document.getElementById('efCfgATC');
    if (atc && atc.disabled) {
      atc.disabled = false;
      atc.style.background = '';
      atc.textContent = 'Add to Cart \u2014 ' + money(calcTotal());
    }
  });
  document.addEventListener('cart:refresh', function() {
    var atc = document.getElementById('efCfgATC');
    if (atc && atc.disabled) {
      atc.disabled = false;
      atc.style.background = '';
      atc.textContent = 'Add to Cart \u2014 ' + money(calcTotal());
    }
  });

  function init() {
    buildProgress();
    try { populateSteps(); } catch(e) { console.error('[EF-CFG] populateSteps error:', e); }
    handleMeasurements();
    handleStandardSize();
    handleBrookfieldDeluxe();
    handleVariantSelect();
    handleSimpleRanges();
    updatePrice();
    showStep(_skipStep0 ? 1 : 0, { skipScroll: true });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Video modal (cfg-simple "Watch Installation Video") removed 2026-05-01 —
     the Installation Guide tab below the gallery is the single source for
     install instructions. */

  /* ────────────────────────────────────
     FREE TEMPLATE KIT REQUEST (arch products)
     ──────────────────────────────────── */
  (function() {
    var openBtn = document.getElementById('efCfgTemplateOpen');
    var modal = document.getElementById('efCfgTemplateModal');
    if (!openBtn || !modal) return;

    var closeBtn = document.getElementById('efCfgTemplateClose');
    var form = document.getElementById('efCfgTemplateForm');
    var submitBtn = document.getElementById('efTplSubmit');
    var errorEl = document.getElementById('efTplError');

    function openModal() {
      modal.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      var first = modal.querySelector('input,textarea,button');
      if (first) setTimeout(function(){ first.focus(); }, 50);
    }
    function closeModal() {
      modal.removeAttribute('data-open');
      modal.removeAttribute('data-success');
      modal.removeAttribute('data-error');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') closeModal();
    });

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        modal.removeAttribute('data-error');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span class="ef-cfg-spinner"></span> Sending...';
        }

        var data = new FormData(form);
        var payload = {
          name: data.get('name') || '',
          phone: data.get('phone') || '',
          email: data.get('email') || '',
          address: data.get('address') || '',
          notes: data.get('notes') || '',
          product: prodTitle,
          product_url: window.location.href,
          width: selections._width || '',
          peak_height: selections._height || '',
          side_height: selections._side_height || ''
        };

        var subject = 'Free Template Kit Request: ' + payload.product;
        var bodyLines = [
          'FREE TEMPLATE KIT REQUEST',
          '',
          'Product: ' + payload.product,
          'URL: ' + payload.product_url,
          '',
          'CUSTOMER',
          'Name: ' + payload.name,
          'Phone: ' + payload.phone,
          'Email: ' + payload.email,
          'Shipping Address: ' + payload.address,
          '',
          'MEASUREMENTS (preliminary, template will give exact)',
          'Width: ' + (payload.width || 'TBD') + '"',
          'Center Peak Height: ' + (payload.peak_height || 'TBD') + '"',
          'Side Height: ' + (payload.side_height || 'TBD') + '"',
          '',
          'NOTES',
          payload.notes || '(none)',
          '',
          '— Sent from ExceptionalFire arch configurator'
        ];
        var mailto = 'mailto:info@exceptionalfire.com?subject=' +
          encodeURIComponent(subject) + '&body=' + encodeURIComponent(bodyLines.join('\n'));

        /* Open user's default mail client (works on every device, no backend needed) */
        window.location.href = mailto;

        /* Show success after a short delay so the mailto handler kicks in first */
        setTimeout(function() {
          modal.setAttribute('data-success', 'true');
          form.reset();
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Request';
          }
        }, 400);
      });
    }
  })();

})();


/* ─── Block 2 (was line ~3812) ─── */

/* ── Sticky ATC bar click ── */
(function() {
  var stickyBtn = document.getElementById('efStickyBtn');
  var mainATC = document.getElementById('efCfgATC');
  if (stickyBtn && mainATC) {
    stickyBtn.addEventListener('click', function() { mainATC.click(); });
  }
})();

document.querySelectorAll('.ef-info-trigger').forEach(function(btn){
  btn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll('.ef-tooltip').forEach(function(t){ t.style.display = 'none'; });
    var tip = btn.querySelector('.ef-tooltip');
    if(!tip){
      tip = document.createElement('span');
      tip.className = 'ef-tooltip';
      tip.textContent = btn.getAttribute('data-ef-tooltip');
      btn.appendChild(tip);
    }
    tip.style.display = tip.style.display === 'block' ? 'none' : 'block';
  });
});
document.addEventListener('click', function(){ document.querySelectorAll('.ef-tooltip').forEach(function(t){ t.style.display = 'none'; }); });


/* ─── Block 3 (was line ~3840) ─── */

/* ── AI Configurator Assist ── */
(function() {
  var aiBtn = document.getElementById('efCfgAiBtn');
  var aiPanel = document.getElementById('efCfgAiPanel');
  var aiUpload = document.getElementById('efCfgAiUpload');
  var aiFile = document.getElementById('efCfgAiFile');
  var aiAnalyzing = document.getElementById('efCfgAiAnalyzing');
  var aiResult = document.getElementById('efCfgAiResult');
  var aiCard = document.getElementById('efCfgAiCard');
  var aiManualLink = document.getElementById('efCfgAiManualLink');
  if (!aiPanel) return;

  /* 2026-05-14 — unified card redesign removed the standalone aiUpload label
     element. The legacy AI handler still calls aiUpload.style.display = 'none'
     /'flex' to toggle between upload + analyzing states. Provide a no-op
     sentinel so those calls don't throw, AND wire data-state on the card root
     so the idle layout returns when the legacy code "shows the upload" again. */
  if (!aiUpload) {
    aiUpload = {
      _state: { display: '' },
      get style() {
        var s = this._state, card = aiCard;
        return {
          set display(v) {
            s.display = v;
            // 'none' = handler is moving to analyzing/result; CSS handles via data-state
            // 'flex' / '' = handler is restoring the idle upload — reset card state
            if (card && (v === 'flex' || v === 'block' || v === '')) card.dataset.state = 'idle';
          },
          get display() { return s.display; }
        };
      }
    };
  }

  var WORKER_URL = 'https://configurator-assistant.danielzajacus.workers.dev';

  /* Unified card: card IS the upload trigger via native <label for=efCfgAiFile>.
     No more toggle — panel is always present; the data-state attribute on the
     card root switches between idle / loading / result. 2026-05-14.

     THREE display modes (mutually exclusive), detected at runtime:
       A. Card always visible (v6 sandbox): aiBtn is hidden empty placeholder.
       B. Button reveals card (LIVE main): aiBtn visible, aiCard initially
          display:none. Click button → show card + manual link, hide button.
       C. Legacy fallback (older LIVE without aiCard): button toggles old panel. */

  var btnRevealMode = aiBtn && aiCard && !aiBtn.hasAttribute('hidden') &&
                      (aiCard.style.display === 'none');

  if (btnRevealMode) {
    /* Mode B — LIVE click-to-reveal */
    aiBtn.addEventListener('click', function (e) {
      e.preventDefault();
      aiCard.style.display = '';
      if (aiManualLink) aiManualLink.style.display = '';
      aiBtn.style.display = 'none';
    });
  } else if (!aiCard && aiBtn) {
    /* Mode C — legacy fallback */
    aiBtn.addEventListener('click', function () {
      var open = aiPanel.style.display !== 'none';
      aiPanel.style.display = open ? 'none' : 'block';
      if (!open) aiBtn.style.display = 'none';
    });
  }
  /* Mode A — no extra wiring; card is already visible. */

  /* "Or pick manually" — un-fades the type selector below so user can manually
     choose Factory-Built / Masonry without uploading. Also hides the manual
     link itself once clicked (one-shot reveal). */
  if (aiManualLink) {
    aiManualLink.addEventListener('click', function (e) {
      e.preventDefault();
      var groups = document.querySelectorAll('.ef-cfg-group--deprio');
      groups.forEach(function (g) { g.classList.add('is-active'); });
      aiManualLink.style.display = 'none';
      var typeGroup = document.querySelector('.ef-cfg-group[data-group="fireplace_type"]');
      if (typeGroup && typeof typeGroup.scrollIntoView === 'function') {
        typeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* Card-as-button: trigger file picker on click + space/enter (since we use
     <div role="button"> instead of <label> — label cannot legally contain
     <div> children, browsers auto-close the label and the idle layout escapes).
     Don't fire while in loading/result state to avoid re-opening picker.
     Skip clicks originating inside thumbnails (they have their own lightbox). */
  if (aiCard && aiFile) {
    aiCard.addEventListener('click', function (e) {
      if (aiCard.dataset.state !== 'idle') return;
      if (e.target.closest('.ef-cfg-ai-card__thumb')) return;
      aiFile.click();
    });
    aiCard.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (aiCard.dataset.state !== 'idle') return;
        if (e.target.closest('.ef-cfg-ai-card__thumb')) return;
        e.preventDefault();
        aiFile.click();
      }
    });
  }

  /* Example thumbnail lightbox — open full-size on click, close on overlay
     click / X button / Escape. Stops propagation so card click doesn't fire. */
  var aiLightbox = document.getElementById('efCfgAiLightbox');
  var aiLightboxImg = document.getElementById('efCfgAiLightboxImg');
  var aiLightboxClose = document.getElementById('efCfgAiLightboxClose');
  if (aiLightbox && aiLightboxImg) {
    document.querySelectorAll('.ef-cfg-ai-card__thumb').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var src = btn.getAttribute('data-full');
        if (!src) return;
        aiLightboxImg.src = src;
        aiLightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeLightbox() {
      aiLightbox.setAttribute('aria-hidden', 'true');
      aiLightboxImg.src = '';
      document.body.style.overflow = '';
    }
    aiLightbox.addEventListener('click', function (e) {
      if (e.target === aiLightbox || e.target === aiLightboxImg) closeLightbox();
    });
    if (aiLightboxClose) aiLightboxClose.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aiLightbox.getAttribute('aria-hidden') === 'false') closeLightbox();
    });
  }

  /* Drag-and-drop on the card. dragover MUST preventDefault for drop to fire. */
  if (aiCard && aiFile) {
    var dragLeaveTimer = null;
    function onDragOver(e) {
      e.preventDefault(); e.stopPropagation();
      if (dragLeaveTimer) { clearTimeout(dragLeaveTimer); dragLeaveTimer = null; }
      aiCard.classList.add('is-dragover');
    }
    function onDragLeave(e) {
      // dragleave fires for child elements too — debounce by 60ms so a
      // dragover on the next child doesn't make the highlight flicker
      dragLeaveTimer = setTimeout(function () { aiCard.classList.remove('is-dragover'); }, 60);
    }
    function onDrop(e) {
      e.preventDefault(); e.stopPropagation();
      aiCard.classList.remove('is-dragover');
      var files = e.dataTransfer && e.dataTransfer.files;
      if (!files || !files.length) return;
      // Set on the file input + dispatch change so existing handler picks it up
      try {
        var dt = new DataTransfer();
        dt.items.add(files[0]);
        aiFile.files = dt.files;
        aiFile.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {
        console.warn('[EF-CFG] drop fallback', err);
      }
    }
    aiCard.addEventListener('dragover', onDragOver);
    aiCard.addEventListener('dragenter', onDragOver);
    aiCard.addEventListener('dragleave', onDragLeave);
    aiCard.addEventListener('drop', onDrop);
  }

  /* When file is selected (via tap or drop), flip card to loading state.
     The downstream handler sets aiAnalyzing display='block' / aiResult on success;
     here we just keep data-state in sync so CSS can hide the idle layout. */
  if (aiFile && aiCard) {
    aiFile.addEventListener('change', function () {
      if (aiFile.files && aiFile.files.length) aiCard.dataset.state = 'loading';
    });
  }
  /* MutationObserver on aiResult: when it becomes visible (display:block),
     bump card state to 'result' AND un-fade the type cards (AI gave us values
     to populate them, so manual selection is now also relevant). */
  if (aiResult && aiCard) {
    var ro = new MutationObserver(function () {
      if (aiResult.style.display && aiResult.style.display !== 'none') {
        aiCard.dataset.state = 'result';
        document.querySelectorAll('.ef-cfg-group--deprio').forEach(function (g) {
          g.classList.add('is-active');
        });
        if (aiManualLink) aiManualLink.style.display = 'none';
      }
    });
    ro.observe(aiResult, { attributes: true, attributeFilter: ['style'] });
  }

  /* Step 2 measurement help is now native <details>/<summary> — no JS needed.
     Removed the old jump-to-step-1 + AI-panel handler 2026-05-03. */

  /* Upload click handled by native <label for="efCfgAiFile"> — no JS proxy.
     Removed `aiFile.click()` 2026-05-04 because iOS Safari throttles
     programmatic file-input clicks (~7s delay before picker opens).
     Native label fires picker immediately on user tap. */

  /* HEIC support — lazy-load converter only when iPhone HEIC photo is uploaded */
  var heic2anyLoaded = null;
  function loadHeic2Any() {
    if (heic2anyLoaded) return heic2anyLoaded;
    heic2anyLoaded = new Promise(function (resolve, reject) {
      if (window.heic2any) return resolve(window.heic2any);
      var s = document.createElement('script');
      s.src = window.EF_HEIC2ANY_URL || 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      var loadedFlag = false;
      var timeoutId = setTimeout(function () {
        if (loadedFlag) return;
        reject(new Error('HEIC converter failed to load (network timeout). Please switch to WiFi and try again, or re-export your photo as JPEG from your iPhone.'));
      }, 15000);
      s.onload = function () { loadedFlag = true; clearTimeout(timeoutId); resolve(window.heic2any); };
      s.onerror = function () { clearTimeout(timeoutId); reject(new Error('Failed to load HEIC converter (CDN blocked or offline). Please re-export your photo as JPEG from your iPhone Photos app.')); };
      document.head.appendChild(s);
    });
    return heic2anyLoaded;
  }
  function isHeic(file) {
    var name = (file.name || '').toLowerCase();
    var type = (file.type || '').toLowerCase();
    return type === 'image/heic' || type === 'image/heif' ||
           /\.(heic|heif)$/i.test(name);
  }
  function probeNativeHeic(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      var settled = false;
      function done(ok) { if (settled) return; settled = true; URL.revokeObjectURL(url); resolve(ok); }
      img.onload = function () { done(img.naturalWidth > 0); };
      img.onerror = function () { done(false); };
      setTimeout(function () { done(false); }, 4000);
      img.src = url;
    });
  }
  /* Safari/iOS decode HEIC natively in <img> — no wasm needed there; downstream canvas re-encode outputs JPEG. */
  function convertHeicToJpeg(file) {
    return probeNativeHeic(file).then(function (nativeOk) {
      if (nativeOk) return file;
      return wasmConvertHeic(file);
    });
  }
  var efHeifLoaded = null;
  function loadEfHeif() {
    if (efHeifLoaded) return efHeifLoaded;
    efHeifLoaded = new Promise(function (resolve, reject) {
      if (window.EFConvertHeic) return resolve();
      if (!window.EF_HEIF_URL) return reject(new Error('no EF_HEIF_URL'));
      var s = document.createElement('script');
      s.src = window.EF_HEIF_URL;
      var t = setTimeout(function () { reject(new Error('ef-heic load timeout')); }, 20000);
      s.onload = function () { clearTimeout(t); window.EFConvertHeic ? resolve() : reject(new Error('ef-heic loaded but no API')); };
      s.onerror = function () { clearTimeout(t); reject(new Error('ef-heic failed to load')); };
      document.head.appendChild(s);
    });
    return efHeifLoaded;
  }
  /* Decoder ladder: modern libheif first (handles iPhone 15/16 HDR HEIC), legacy heic2any as fallback. */
  function wasmConvertHeic(file) {
    return loadEfHeif().then(function () { return window.EFConvertHeic(file); })
      .catch(function (err) { if (window.console) console.warn('[ef-heic] libheif path failed, trying heic2any:', err && err.message); return legacyConvertHeic(file); });
  }
  function legacyConvertHeic(file) {
    return loadHeic2Any().then(function (heic2any) {
      return heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 });
    }).then(function (blob) {
      if (Array.isArray(blob)) blob = blob[0];
      return new File([blob], (file.name || 'photo').replace(/\.(heic|heif)$/i, '.jpg'), { type: 'image/jpeg' });
    });
  }

  /* File selected → analyze */
  /* Resize image to max 1600px before sending. Promise-based so img-decode
     errors (some malformed PNGs, oversized phone shots) propagate to .catch
     instead of silently never invoking the callback. JPEG re-encode at q=0.85
     keeps everything under Anthropic's 5MB image limit. */
  function resizeImage(file, maxDim) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (w > maxDim || h > maxDim) {
          var ratio = Math.min(maxDim / w, maxDim / h);
          w = Math.round(w * ratio);
          h = Math.round(h * ratio);
        }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL('image/jpeg', 0.85));
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('Image decode failed'));
      };
      img.src = url;
    });
  }

  aiFile.addEventListener('change', function(e) {
    var file = e.target.files[0];
    if (!file) return;

    /* Clear stale preview from any previous photo so old image doesn't flash. */
    var prevImg = document.getElementById('efCfgAiPreview');
    if (prevImg) prevImg.removeAttribute('src');

    /* Show analyzing state immediately */
    aiUpload.style.display = 'none';
    aiAnalyzing.style.display = 'block';

    /* iPhone HEIC handling — convert client-side first. Errors propagate to the
       outer chain's .catch so we don't double-alert. */
    var processFile;
    if (isHeic(file)) {
      var s0 = document.getElementById('efCfgAiStatus');
      if (s0) s0.textContent = 'Converting iPhone photo (HEIC → JPEG)…';
      processFile = convertHeicToJpeg(file).catch(function (err) {
        throw new Error('heic_conversion_failed: ' + (err && err.message || err));
      });
    } else {
      processFile = Promise.resolve(file);
    }

    processFile.then(function (finalFile) {
      var statusEl = document.getElementById('efCfgAiStatus');
      if (statusEl) statusEl.textContent = 'Preparing image…';

      /* Mirror the photo into the Step 6 (Review) upload widget so the customer
         doesn't have to re-upload. Uses DataTransfer + dispatch change so the
         existing efCfgUpload handler's handleFile() runs naturally — that sets
         uploadedFile, filename, preview, and triggers Shopify upload. 2026-05-14. */
      try {
        var reviewInput = document.getElementById('efCfgFileInput');
        if (reviewInput && finalFile) {
          var dt = new DataTransfer();
          dt.items.add(finalFile);
          reviewInput.files = dt.files;
          reviewInput.dispatchEvent(new Event('change', { bubbles: true }));
          var zone = document.getElementById('efCfgUpload');
          if (zone) zone.classList.add('has-file');
        }
      } catch (mirrorErr) {
        console.warn('[EF-CFG] mirror to review step failed:', mirrorErr);
      }

      return resizeImage(finalFile, 1600);
    }).then(function (dataUrl) {
      console.log('[EF-AI] Image resized, payload size:', Math.round(dataUrl.length / 1024) + 'KB');
      document.getElementById('efCfgAiPreview').src = dataUrl;

      /* Rotate status messages — paced for typical 30-50s analysis */
      var msgs = [
        'Uploading and processing your photo…',
        'Identifying fireplace type — masonry or prefab',
        'Detecting opening shape and hearth',
        'Checking lintel bar, louvers, and surround',
        'Estimating dimensions from visual references',
        'Matching against door catalog',
        'Preparing recommendations…'
      ];
      var msgIdx = 0;
      var statusEl = document.getElementById('efCfgAiStatus');
      var timer = setInterval(function() {
        msgIdx++;
        if (msgIdx < msgs.length && statusEl) {
          statusEl.style.opacity = '0';
          setTimeout(function() {
            statusEl.textContent = msgs[msgIdx];
            statusEl.style.opacity = '1';
          }, 200);
        }
      }, 5500);

      /* Elapsed timer — real-time so customer knows it's still working */
      var elapsedStart = Date.now();
      var elapsedEl = document.getElementById('efCfgAiElapsed');
      var elapsedTimer = setInterval(function() {
        if (!elapsedEl) return;
        var s = Math.floor((Date.now() - elapsedStart) / 1000);
        var m = Math.floor(s / 60);
        elapsedEl.textContent = m + ':' + String(s % 60).padStart(2, '0');
      }, 1000);

      /* Get product handle from page */
      var root = document.getElementById('efCfg');
      var handle = root ? root.dataset.productHandle : '';

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image: dataUrl,
          product_handle: handle,
          cfg_group: window.efCfgMatchedGroup || null
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        clearInterval(timer);
        clearInterval(elapsedTimer);
        console.log('[EF-AI] Worker response:', JSON.stringify(data));
        aiAnalyzing.style.display = 'none';
        aiResult.style.display = 'block';

        /* Check for error from worker — also catch silent failures where the
           worker returned 200 but the analysis is missing the core type field
           (Anthropic API quota, parse errors, etc. would manifest this way). */
        if (data.error || !data.fireplace_type) {
          console.error('[EF-AI] Worker error:', data.error || 'empty_result', data.detail || '');
          aiResult.style.display = 'none';
          aiUpload.style.display = 'flex';
          aiBtn.style.display = 'flex';
          aiPanel.style.display = 'none';
          var msg = data.overloaded
            ? 'Our AI service is briefly overloaded. Please try again in 30 seconds, or pick manually below.'
            : 'Could not analyze this photo. Please try a different photo or pick manually below.';
          alert(msg);
          return;
        }

        /* Build specs display */
        var specs = document.getElementById('efCfgAiSpecs');
        var html = '';
        var fpType = (data.fireplace_type || '').toLowerCase().indexOf('masonry') !== -1 ? 'Masonry' : 'Factory-Built';
        var fbType = (data.firebox_type || '').toLowerCase().indexOf('flush') !== -1 ? 'Flush Hearth' : 'Hole in Wall';
        html += aiSpec('Type', fpType);
        html += aiSpec('Firebox', fbType);
        if (data.estimated_width && data.estimated_height) {
          html += aiSpec('Est. Size', data.estimated_width + '" x ' + data.estimated_height + '"');
        }
        if (data.lintel_bar && data.lintel_bar.visible) {
          html += aiSpec('Lintel Bar', data.lintel_bar.position === 'flush' ? 'Flush' : data.lintel_bar.position === 'recessed' ? 'Recessed' : 'Detected');
        }
        html += aiSpec('Confidence', (data.confidence || 85) + '%');
        specs.innerHTML = html;

        /* Lintel bar explainer — uses ef-cfg-ai-trust--info structure so it
           visually matches the hand-verified (green) and AI-estimates (warn)
           boxes above. Left vertical border + icon + title + text. */
        var lintelNote = document.getElementById('efCfgAiLintelNote');
        if (lintelNote) {
          if (data.lintel_bar && data.lintel_bar.visible) {
            var posExplanation = data.lintel_bar.position === 'flush'
              ? '<strong>Flush</strong> means the bar sits even with the brick face — measure height to the bottom of the bar, the door frame will cover it.'
              : data.lintel_bar.position === 'recessed'
              ? '<strong>Recessed</strong> means the bar is set back inside the opening — measure height to the top of the brick/stone, NOT to the bar deep inside.'
              : 'Measure carefully at the top of the opening — see Step 2 for tips.';
            lintelNote.innerHTML =
              '<div class="ef-cfg-ai-trust ef-cfg-ai-trust--info">' +
                '<svg class="ef-cfg-ai-trust__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
                '<div class="ef-cfg-ai-trust__body">' +
                  '<p class="ef-cfg-ai-trust__title">What is a lintel bar?</p>' +
                  '<p class="ef-cfg-ai-trust__text">A horizontal metal bar (usually steel angle iron) at the top of masonry fireplace openings — it supports the brickwork above. Often painted to match the brick.<br><br>' + posExplanation + '</p>' +
                '</div>' +
              '</div>';
            lintelNote.style.display = '';
          } else {
            lintelNote.style.display = 'none';
          }
        }

        /* Step-1 finish tip removed — finish recommendation now shown in
           the Finish step itself in the same green-bordered Fit-Advice style
           (see renderAiTips below). Keeps Step 1 panel focused on type/size. */

        /* ── AUTO-FILL CONFIGURATOR ── */

        /* 1. Auto-select fireplace_type card */
        autoSelectCard('fireplace_type', fpType.toLowerCase());

        /* 2. Auto-select firebox_type card */
        var fbSearch = fbType.toLowerCase().indexOf('flush') !== -1 ? 'flush' : 'hole';
        autoSelectCard('firebox_type', fbSearch);

        /* 3. Store estimated dimensions + tips for Step 2 */
        if (data.estimated_width && data.estimated_height) {
          window._efAiDims = {
            w: data.estimated_width,
            h: data.estimated_height,
            tips: data.measuring_tips || [],
            lintel: data.lintel_bar || null,
            method: data.size_estimation_method || ''
          };
        }

        /* 4. Store finish/glass/fit/mesh/draft recommendations + reasoning for later steps */
        window._efAiRecs = {
          finish: data.recommended_finish || '',
          finish_reason: data.finish_reason || '',
          finish_premium: data.recommended_finish_premium || '',
          finish_premium_reason: data.finish_premium_reason || '',
          glass: data.recommended_glass || '',
          glass_reason: data.glass_reason || '',
          mesh_reason: data.mesh_reason || '',
          draft_reason: data.draft_reason || '',
          fireplace_type: fpType.toLowerCase(),
          fit: data.recommended_fit || '',
          frame: data.recommended_frame_size || '',
          fit_options: data.fit_options || null,
          product_variant: data.product_variant || null,
          available_variants: data.available_variants || []
        };
        renderAiTips();
      })
      .catch(function(err) {
        clearInterval(timer);
        clearInterval(elapsedTimer);
        console.error('[EF-AI] Fetch error:', err);
        aiAnalyzing.style.display = 'none';
        aiUpload.style.display = 'flex';
        aiBtn.style.display = 'flex';
        aiPanel.style.display = 'none';
      });
    }) /* end of .then(dataUrl) — fetch is fire-and-forget inside */
    .catch(function (err) {
      console.error('[EF-AI] Photo prep failed:', err);
      aiAnalyzing.style.display = 'none';
      aiUpload.style.display = 'flex';
      var msg = (err && /heic/i.test(String(err.message || '')))
        ? 'Could not convert this iPhone photo. Try saving as JPEG (Photos → Edit → Done) and re-upload.'
        : 'Could not read this image. Please try a different photo (JPG or PNG).';
      alert(msg);
    });
  });

  function aiSpec(label, value) {
    return '<div class="ef-cfg-ai-panel__spec">' +
      '<div class="ef-cfg-ai-panel__spec-label">' + label + '</div>' +
      '<div class="ef-cfg-ai-panel__spec-val">' + value + '</div></div>';
  }

  /* Renders contextual AI tips inside steps (Finish, Glass, Mesh, Draft Control)
     once analysis completes. Each tip is gated on whether its container exists
     in the rendered configurator (some tags hide certain steps). */
  function efAiTipCard(opts) {
    var icon = opts.icon || 'sparkle';
    var iconSvg = icon === 'sparkle'
      ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px;"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>'
      : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
    var rows = (opts.rows || []).map(function (r) {
      return '<p style="margin:0 0 6px;font-family:Inter,sans-serif;font-size:12.5px;line-height:1.5;color:#3A3732;">' +
        (r.label ? '<strong style="color:#1E1E1B;font-weight:600;">' + r.label + ':</strong> ' : '') +
        r.text + '</p>';
    }).join('');
    if (rows) rows = rows.replace(/margin:0 0 6px;/, 'margin:0 0 6px;').replace(/<\/p>$/, '</p>');
    return '<div class="ef-cfg-ai-tip" style="display:flex;gap:10px;align-items:flex-start;padding:12px 14px;background:#FEF8EE;border:1px solid #F2E5C8;border-left:3px solid #8A6A43;border-radius:6px;margin:14px 0;">' +
      iconSvg +
      '<div style="flex:1;">' +
        '<p style="margin:0 0 6px;font-family:Inter,sans-serif;font-size:10px;font-weight:700;color:#8A6A43;letter-spacing:0.12em;text-transform:uppercase;">' + (opts.eyebrow || 'AI Recommendation') + '</p>' +
        rows +
      '</div>' +
    '</div>';
  }

  /* Renders an inline "AI recommends X — text" advice card matching the Fit Type
     advice style (.ef-cfg-ai-advice). Used for finish, glass, and mesh tips. */
  function efAiAdviceHtml(recommendation, text) {
    /* Modern "AI Expert Pick" callout (2026-05-31) — premium, structured: sparkle eyebrow +
       bold recommendation headline + reasoning. Styled by .ef-cfg-ai-advice (bronze, not 2010 green). */
    return '<span class="ef-cfg-ai-advice__eyebrow">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.85 5.55L19.5 10l-5.65 1.45L12 17l-1.85-5.55L4.5 10l5.65-1.45z"/><path d="M19 15l.7 2.1L22 18l-2.3.9L19 21l-.7-2.1L16 18l2.3-.9z"/></svg>' +
        'AI Expert Pick</span>' +
      '<span class="ef-cfg-ai-advice__rec">' + recommendation + '</span>' +
      '<span class="ef-cfg-ai-advice__text">' + text + '</span>';
  }

  function renderAiTips() {
    var r = window._efAiRecs || {};

    /* Finish — primary recommendation, premium upgrade appended as one sentence */
    var finishHost = document.getElementById('efCfgSwatchGrid');
    if (finishHost && (r.finish || r.finish_premium)) {
      var existingFinish = document.getElementById('efCfgAiFinishTip');
      if (existingFinish) existingFinish.remove();
      var primary = r.finish || r.finish_premium;
      var text = (r.finish ? r.finish_reason : r.finish_premium_reason) || 'Complements your fireplace.';
      if (r.finish && r.finish_premium && r.finish !== r.finish_premium) {
        text += ' For a premium upgrade, consider <em>' + r.finish_premium + '</em> (Artisan Premier, +$75–150).';
      }
      var fwrap = document.createElement('div');
      fwrap.id = 'efCfgAiFinishTip';
      fwrap.className = 'ef-cfg-ai-advice';
      fwrap.innerHTML = efAiAdviceHtml(primary, text);
      finishHost.parentNode.insertBefore(fwrap, finishHost.nextSibling);
    }

    /* Glass — Clear/Tinted based on interior */
    var glassGroups = document.querySelectorAll('[data-group="glass_color"], [data-group="glass"], [data-group="glass_type"]');
    glassGroups.forEach(function (g) {
      var existing = g.querySelector('.ef-cfg-ai-glass-tip');
      if (existing) existing.remove();
      if (!r.glass) return;
      var wrap = document.createElement('div');
      wrap.className = 'ef-cfg-ai-glass-tip ef-cfg-ai-advice';
      wrap.innerHTML = efAiAdviceHtml(r.glass + ' Glass', r.glass_reason || 'Best match for your firebox interior.');
      g.appendChild(wrap);
    });

    /* Mesh — always recommend Twin Gate Mesh */
    var meshGroups = document.querySelectorAll('[data-group="mesh"], [data-group="mesh_screen"], [data-group="mesh_type"]');
    meshGroups.forEach(function (g) {
      var existing = g.querySelector('.ef-cfg-ai-mesh-tip');
      if (existing) existing.remove();
      var wrap = document.createElement('div');
      wrap.className = 'ef-cfg-ai-mesh-tip ef-cfg-ai-advice';
      wrap.innerHTML = efAiAdviceHtml('Twin Gate Mesh', r.mesh_reason || 'Twin gate mesh opens like saloon doors so you can tend the fire without removing the entire screen — full hearth access, symmetrical look, smoother everyday operation.');
      g.appendChild(wrap);
    });

    /* Draft control — masonry doors only */
    if (r.fireplace_type && r.fireplace_type.indexOf('masonry') !== -1) {
      var draftGroups = document.querySelectorAll('[data-group="draft_control"], [data-group="draft"]');
      draftGroups.forEach(function (g) {
        var existing = g.querySelector('.ef-cfg-ai-draft-tip');
        if (existing) existing.remove();
        var wrap = document.createElement('div');
        wrap.className = 'ef-cfg-ai-draft-tip ef-cfg-ai-advice';
        wrap.innerHTML = efAiAdviceHtml('Yes — add draft control', r.draft_reason || 'For masonry fireplaces draft control regulates burn rate and oxygen flow — slower burns, longer fires, less wasted wood.');
        g.appendChild(wrap);
      });
    }
  }

  /* Re-render tips when user navigates to a step (in case step content was rebuilt) */
  document.addEventListener('click', function (e) {
    var navBtn = e.target.closest('[data-step-nav], .ef-cfg-nav__next, .ef-cfg-nav__prev');
    if (navBtn && window._efAiRecs) {
      setTimeout(renderAiTips, 100);
    }
  });

  function autoSelectCard(field, searchTerm) {
    var cards = document.querySelectorAll('[data-field="' + field + '"]');
    cards.forEach(function(card) {
      var val = (card.dataset.value || '').toLowerCase();
      if (val.indexOf(searchTerm) !== -1) {
        card.click();
      }
    });
  }

  /* Pre-fill dimensions + show estimated badge when entering Step 2 (measurements) */
  var observer = new MutationObserver(function() {
    var step1 = document.getElementById('efCfgStep1');
    if (step1 && step1.classList.contains('is-visible') && window._efAiDims) {
      var dims = window._efAiDims;
      /* Width/Height inputs intentionally left empty — customer must measure
         the opening with a tape measure and enter exact dimensions. AI estimate
         is surfaced as a badge + tips below, never written into the fields.
         Reason: per customer feedback, prefilled estimates were being submitted
         without verification, causing fit issues during production. */

      /* Show estimated badge with tips */
      var estEl = document.getElementById('efCfgAiEstimated');
      if (estEl) {
        estEl.style.display = 'block';

        /* Populate measuring tips with STATIC general rules per fireplace type.
           2026-05-13 — switched from per-photo AI tips (inconsistent) to canned
           rules. AI is only used to detect masonry vs prefab; rules are
           hardcoded so they cannot drift. */
        var tipsUl = document.getElementById('efCfgAiTips');
        if (tipsUl) {
          var fpType = (window._efAiRecs && window._efAiRecs.fireplace_type || '').toLowerCase();
          var isMasonry = fpType.indexOf('masonry') !== -1;
          var rules = isMasonry
            ? [
                'Measure WIDTH at three points (top, middle, bottom) — use the SMALLEST width.',
                'Measure HEIGHT at three points (left, center, right) — use the SMALLEST height.',
                'Measure brick-to-brick or stone-to-stone at the FRONT opening — not deep inside the firebox.',
                'If a lintel bar is FLUSH with the front face: measure HEIGHT to the BOTTOM of the lintel — the door frame will seat against it.',
                'If a lintel bar is RECESSED (more than ~1" behind the front face): IGNORE it — measure to the top of the brick/stone opening.',
                'Measure to the nearest 1/8".'
              ]
            : [
                'Measure the FRONT METAL OPENING — where the new door frame will install. Not deep inside the firebox.',
                'Measure WIDTH (left edge of metal to right edge) at top, middle, and bottom — use the SMALLEST width.',
                'Measure HEIGHT (front bottom to front top of metal opening) at left, center, and right — use the SMALLEST height.',
                'DO NOT measure: the back wall, behind logs / grate / mesh curtain / vents / louvers, or anywhere deep inside the firebox.',
                'There is NO structural lintel bar on a prefab. Any horizontal metal element you see deep inside is a smoke shelf or panel brace — NOT a measurement landmark.',
                'If old factory doors / metal trim are still installed: REMOVE them first, then measure the clean front opening.',
                'If the surround (tile / marble / stone) is rough or uneven, the frame may not seat flush — install the frame first, then bring veneer up to its edge.',
                'Measure to the nearest 1/8".'
              ];
          tipsUl.innerHTML = rules.map(function(t) { return '<li>' + t + '</li>'; }).join('');
        }

        /* Show lintel bar info */
        var lintelEl = document.getElementById('efCfgAiLintel');
        /* 2026-05-13 — dynamic per-photo lintel detection box disabled.
           AI was confusing internal smoke shelves on prefab as lintels.
           General rules for both flush and recessed lintels are now in the
           static measuring rules above; no per-photo lintel callout needed. */
        if (lintelEl) lintelEl.style.display = 'none';

        /* Fit type info now embeds DIRECTLY into the existing Overlap/Inside Fit
           radio cards in Step 3 (see applyAiFitInfoToCards). Step 1 only shows
           a tiny banner pointing the customer to where the details live. */
        var fitEl = document.getElementById('efCfgAiFitAdvice');
        if (fitEl) {
          if (window._efAiRecs && (window._efAiRecs.fit_options || window._efAiRecs.fit)) {
            fitEl.querySelector('span').innerHTML =
              '<strong>Fit Type analyzed</strong> — see Overlap/Inside Fit cards in Step 3 for product-specific tolerance and measuring tips.';
            fitEl.style.display = 'flex';
          }
          /* Try injecting now in case Step 3 cards already rendered; otherwise
             the MutationObserver below will catch them when they appear. */
          applyAiFitInfoToCards();
        }
      }

      window._efAiDims = null; /* only auto-fill once */
    }
  });
  var step1El = document.getElementById('efCfgStep1');
  if (step1El) observer.observe(step1El, { attributes: true, attributeFilter: ['class'] });

  /* When Step 2 (Door Style) becomes visible, inject AI fit info into the
     existing Overlap/Inside Fit radio cards. The observer also catches the
     case where AI completes before the customer reaches Step 2. */
  var fitObserver = new MutationObserver(function() {
    var step2 = document.getElementById('efCfgStep2');
    if (!step2 || !step2.classList.contains('is-visible')) return;
    if (!window._efAiRecs) return;
    /* Hide the legacy advice banner inside fit_type group — info is now in cards */
    var adviceEl = document.getElementById('efCfgFitAdvice');
    if (adviceEl) adviceEl.style.display = 'none';
    applyAiFitInfoToCards();
  });
  var step2El = document.getElementById('efCfgStep2');
  if (step2El) fitObserver.observe(step2El, { attributes: true, attributeFilter: ['class'] });

  function _aiEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Inject AI-derived per-product fit info DIRECTLY into the existing Overlap/
     Inside Fit radio cards in Step 3 (Door Style). For each card:
       - Append a tolerance pill + AI reason inside the card body
       - Add a "★ AI Recommended" badge on the card the AI suggests
       - Disable + grey out the card if that fit isn't viable for the customer's
         fireplace type (e.g. Brookfield Prefab has no Inside Fit)
     Idempotent — calling it twice replaces previous injection cleanly. */
  function applyAiFitInfoToCards() {
    var recs = window._efAiRecs;
    if (!recs) return;
    var opts = recs.fit_options || null;
    var rec = (recs.fit || '').toLowerCase();
    var cards = document.querySelectorAll('[data-group="fit_type"] .ef-cfg-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var label = (card.dataset.value || '').toLowerCase();
      var mode = label.indexOf('inside') !== -1 ? 'inside' : 'overlap';
      var body = card.querySelector('.ef-cfg-card__body');
      if (!body) return;

      // Clean previous injection
      var prev = body.querySelector('.ef-cfg-card__ai-info');
      if (prev) prev.remove();
      card.classList.remove('ef-cfg-card--ai-recommended', 'ef-cfg-card--ai-unavailable');
      card.removeAttribute('data-ai-disabled');

      var o = opts ? opts[mode] : null;
      var isRecommended = rec.indexOf(mode) !== -1;

      // Build injection
      var html = '<div class="ef-cfg-card__ai-info">';

      if (o && o.viable === false) {
        // Fit is supported by AI logic but not viable for THIS fireplace
        // (e.g. Inside Fit on uneven opening, or product-specific block)
        html += '<div class="ef-cfg-card__ai-unavail">'
          + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;display:inline;vertical-align:middle;margin-right:4px;"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'
          + 'Not recommended for your fireplace'
          + '</div>';
        html += '<p class="ef-cfg-card__ai-reason">' + _aiEsc(o.reason || '') + '</p>';
        /* 2026-05-14 — show "Not recommended" warning but keep card clickable so
           customer can override AI's recommendation (e.g. they know their opening
           better than the photo angle suggests). No greyout, no click block. */
      } else if (o) {
        // Viable fit — show tolerance + reason
        if (isRecommended) {
          html += '<div class="ef-cfg-card__ai-badge">'
            + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;display:inline-block;vertical-align:middle;"><path d="M12 3l1.85 5.55L19.5 10l-5.65 1.45L12 17l-1.85-5.55L4.5 10l5.65-1.45z"/><path d="M19 15l.7 2.1L22 18l-2.3.9L19 21l-.7-2.1L16 18l2.3-.9z"/></svg>'
            + 'AI Recommended'
            + '</div>';
          card.classList.add('ef-cfg-card--ai-recommended');
        }
        html += '<div class="ef-cfg-card__ai-tol">Tolerance <strong>' + _aiEsc(o.tolerance || '±1/8"') + '</strong>';
        if (o.overlap_depth) html += ' · Overlap <strong>' + _aiEsc(o.overlap_depth) + '</strong>';
        html += '</div>';
        if (o.reason) html += '<p class="ef-cfg-card__ai-reason">' + _aiEsc(o.reason) + '</p>';
      } else if (rec && isRecommended) {
        // No fit_options data (legacy products), fall back to a simple badge
        html += '<div class="ef-cfg-card__ai-badge">'
          + '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" style="flex-shrink:0;display:inline;vertical-align:middle;margin-right:3px;"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8 5.8 21.3l2.4-7.4L2 9.4h7.6z"/></svg>'
          + 'AI Recommended'
          + '</div>';
        card.classList.add('ef-cfg-card--ai-recommended');
      } else {
        // Nothing to inject for this card
        return;
      }

      html += '</div>';
      body.insertAdjacentHTML('beforeend', html);
    });

    // Block clicks on AI-disabled cards
    cards.forEach(function (card) {
      if (card.dataset.aiDisabled === 'true') {
        card.addEventListener('click', _blockAiDisabledClick, { capture: true });
      } else {
        card.removeEventListener('click', _blockAiDisabledClick, { capture: true });
      }
    });
  }
  function _blockAiDisabledClick(e) {
    if (this.dataset.aiDisabled === 'true') {
      e.stopPropagation();
      e.preventDefault();
    }
  }
  // Expose for callers in other IIFEs
  window.efApplyAiFitInfoToCards = applyAiFitInfoToCards;
})();

/* ────────────────────────────────────
   CARD ZOOM MODAL — mobile tap-to-zoom on option cards.
   Uses event delegation: single listener handles all current
   AND future cards (rendered dynamically when steps change).
   ──────────────────────────────────── */
(function efCfgZoomModalInit() {
  function init() {
    var modal = document.getElementById('efCfgZoom');
    if (!modal) return;
    var img      = document.getElementById('efCfgZoomImg');
    var titleEl  = document.getElementById('efCfgZoomTitle');
    var descEl   = document.getElementById('efCfgZoomDesc');
    var priceEl  = document.getElementById('efCfgZoomPrice');
    var chooseBtn = document.getElementById('efCfgZoomChoose');
    var sourceCard = null;
    var lastFocus = null;

    function open(card) {
      if (!card) return;
      sourceCard = card;
      lastFocus = document.activeElement;
      var imgSrc = card.dataset.imgFull || (card.querySelector('.ef-cfg-card__img img') || {}).src || '';
      var title = (card.querySelector('.ef-cfg-card__title') || {}).textContent || '';
      var desc  = card.dataset.fullDesc || (card.querySelector('.ef-cfg-card__desc') || {}).textContent || '';
      var price = (card.querySelector('.ef-cfg-card__price') || {}).textContent || '';
      img.src = imgSrc;
      img.alt = title;
      titleEl.textContent = title;
      descEl.textContent = desc;
      priceEl.textContent = price;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { chooseBtn && chooseBtn.focus(); }, 60);
    }
    function close() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      sourceCard = null;
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch(e) {}
    }

    /* Open via delegation — works for cards rendered later */
    document.addEventListener('click', function(e) {
      var z = e.target.closest && e.target.closest('[data-cfg-zoom]');
      if (!z) return;
      var card = z.closest('.ef-cfg-card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      open(card);
    });
    /* Keyboard support — span[role=button] doesn't natively trigger click on
       Enter/Space, so we forward the keydown to the same delegate. (a11y rec) */
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var z = e.target.closest && e.target.closest('[data-cfg-zoom]');
      if (!z) return;
      var card = z.closest('.ef-cfg-card');
      if (!card) return;
      e.preventDefault();
      open(card);
    });

    /* Close handlers */
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-zoom-close]')) close();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });

    /* Choose this — select if not already selected.
       If already selected, no-op (don't toggle off — user pressed "Choose this", they want IT). */
    chooseBtn && chooseBtn.addEventListener('click', function() {
      if (sourceCard && sourceCard.getAttribute('aria-checked') !== 'true') {
        try { sourceCard.click(); } catch(e) {}
      }
      close();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ════════════════════════════════════════════════════════════
     REVIEW-STEP CHECKOUT EXTRAS — native dynamic wallet button
     2026-05-03 (rewrite — option A: native dynamic Shopify button)
     ──────────────────────────────────────────────────────────────
     The Liquid {{ form | payment_button }} filter renders a wallet
     button that auto-detects the buyer's preferred wallet (Shop Pay
     purple, PayPal yellow, Apple Pay black, Google Pay). We intercept
     the click in capture phase BEFORE Shopify's wallet popup opens,
     silently ATC base + surcharges to honor the configured price,
     then redirect to /checkout where the same accelerated wallet
     appears at the top of the page. No worker / draft order needed —
     cart contents drive the checkout total exactly.

     More payment options — same handler, no wallet branding, for
     buyers who want card / other payment methods.
     ════════════════════════════════════════════════════════════ */

  function efBuildAtcItems() {
    /* Mirrors the ATC handler payload (assets/ef-configurator-v2.js ~line 3150)
       so the resulting order shows every customer-entered config. Returns
       null if state isn't ready or required fields are missing. */
    var state = window._efCfgState;
    if (!state) return { error: 'Configuration not ready. Try Add to Cart.' };

    var sel = state.selections;
    var surch = state.surcharges || {};
    var props = {};

    if (sel._width) props['Width'] = sel._width + '"';
    if (sel._height) props[state.isArch ? 'Center Peak Height' : 'Height'] = sel._height + '"';
    if (state.isArch && sel._side_height) props['Side Height'] = sel._side_height + '"';
    if (sel.size) props['Opening Size'] = sel.size;
    if (sel.simple_width) props['Opening Width'] = sel.simple_width;
    if (sel.simple_height) props['Opening Height'] = sel.simple_height;
    if (sel._frame_left) props['Frame Left'] = sel._frame_left;
    if (sel._frame_right) props['Frame Right'] = sel._frame_right;
    if (sel._frame_top) props['Frame Top'] = sel._frame_top;
    if (sel._frame_bottom) props['Frame Bottom'] = sel._frame_bottom;

    var fieldOrder = ['fireplace_type','firebox_type','fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','hardware_finish','glass','mesh','draft_control'];
    fieldOrder.forEach(function (field) {
      if (sel[field]) props[state.formatFieldLabel(field)] = (field === 'hardware_finish' && sel[field] === '__match__') ? 'Match Frame' : sel[field];
    });

    if (state.photoURL) props['_Photo URL'] = state.photoURL;
    var notesEl = document.getElementById('efCfgNotes');
    if (notesEl && notesEl.value.trim()) props['_Notes'] = notesEl.value.trim();

    if (state.matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
      var deluxe = [
        ['efCfgDeluxeOverallW','_Overall Width'],
        ['efCfgDeluxeOverallH','_Overall Height'],
        ['efCfgDeluxeOpeningW','_Opening Width'],
        ['efCfgDeluxeOpeningH','_Opening Height'],
        ['efCfgDeluxeTopOffset','_Top of opening to top of fireplace'],
        ['efCfgDeluxeBottomOffset','_Bottom of opening to bottom of fireplace']
      ];
      var missing = [];
      deluxe.forEach(function (f) {
        var el = document.getElementById(f[0]);
        var v = el ? String(el.value || '').trim() : '';
        if (!v) missing.push(f[1].replace(/^_/, ''));
        else props[f[1]] = v + '"';
      });
      if (missing.length) {
        return { error: 'Please fill in all 6 measurements before checkout:\n\n• ' + missing.join('\n• ') };
      }
    }

    var totalCents = state.calcTotal();
    if (!totalCents || totalCents < 1000) {
      return { error: 'Could not calculate price. Please try Add to Cart instead.' };
    }

    var configId = 'cfg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    props['_Configured Price'] = (totalCents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    props['_config_id'] = configId;

    var mainVariantId = state.variantId;
    if (state.cfgType === 'cfg-standard') {
      var v = document.getElementById('efCfgVariantSelect');
      if (v && v.value) mainVariantId = v.value;
    }

    var items = [{
      id: parseInt(mainVariantId, 10),
      quantity: 1,
      properties: props
    }];

    Object.keys(surch).forEach(function (key) {
      var s = surch[key];
      if (s && s.variantId && s.amount > 0) {
        items.push({
          id: parseInt(s.variantId, 10),
          quantity: s.qty || 1,
          properties: {
            '_parent_product': state.prodTitle,
            '_option_type': state.formatFieldLabel(key),
            '_config_id': configId
          }
        });
      }
    });

    return { items: items };
  }

  function efBuyWithWalletHandler(triggerEl, e) {
    /* Intercepts BOTH the native Shopify dynamic-checkout-button click and
       the More Payment Options click. Validates configuration, builds the
       same multi-line ATC payload as the regular Add-to-Cart handler,
       silently POSTs /cart/add.js, then HARD-redirects to /checkout. */
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    var built = efBuildAtcItems();
    if (built.error) {
      alert(built.error);
      return;
    }

    /* EF FUNNEL: express-checkout ATC (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_atc', {
        total: Math.round(calcTotal()) / 100,
        config_summary: 'express_checkout'
      });
    } catch (e) {}

    var origLabel = triggerEl ? triggerEl.textContent : '';
    if (triggerEl && !triggerEl.dataset.cfgWalletBusy) {
      triggerEl.dataset.cfgWalletBusy = '1';
      triggerEl.style.pointerEvents = 'none';
      triggerEl.style.opacity = '0.7';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: built.items })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Cart error ' + res.status); });
      return res.json();
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      console.error('[EF-CFG buy-with-wallet] Cart error:', err);
      if (triggerEl) {
        triggerEl.style.pointerEvents = '';
        triggerEl.style.opacity = '';
        delete triggerEl.dataset.cfgWalletBusy;
      }
      alert('Could not start checkout: ' + err.message + '\n\nPlease use Add to Cart instead.');
    });
  }

  /* Capture-phase listener on the dynamic button container. The native
     Shopify wallet button renders inside #efCfgShopPayWrap. We capture
     ANY click on that subtree, prevent the wallet popup from opening,
     and route through /checkout instead. Capture phase runs BEFORE
     Shopify's own listeners. */
  var shopPayWrap = document.getElementById('efCfgShopPayWrap');
  if (shopPayWrap) {
    shopPayWrap.addEventListener('click', function (e) {
      var inner = e.target.closest('button, [role="button"], a');
      efBuyWithWalletHandler(inner || shopPayWrap, e);
    }, true);
  }

  var moreBtn = document.getElementById('efCfgMorePay');
  if (moreBtn) {
    moreBtn.addEventListener('click', function (e) {
      efBuyWithWalletHandler(moreBtn, e);
    });
    /* Dynamic Shop Pay height-sync removed 2026-05-03 — Shop Pay button hidden
       entirely (display:none). More-Pay now uses static 56px height matching
       ATC + BACK via CSS. */
  }

  /* ═══════════════════════════════════════════════════════════════════
     LOCALSTORAGE AUTO-SAVE + RESUME (2026-05-03)
     Saves selections + curStep on every change. On return visit shows a
     "Continue where you left off?" banner. Clear on successful add-to-cart.
     Per-product key (handle-scoped). 30-day expiry.
     ═══════════════════════════════════════════════════════════════════ */
  (function efCfgPersist() {
    /* 2026-05-11 — Define root locally. This IIFE lives in efCfgZoomModalInit
       (line 4405 IIFE), NOT in the main configurator IIFE (line 20). The outer
       `root` from line 64 is out of scope here. Was throwing
       Uncaught ReferenceError: root is not defined, which on screens PDP (no
       #efCfg element) was halting page JS init. */
    var root = document.getElementById('efCfg');
    if (!root) return;
    var handle = root.dataset.productHandle || '';
    if (!handle) return;
    var KEY = 'ef-cfg-state-' + handle;
    var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

    function save() {
      try {
        if (!Object.keys(selections).length && curStep === 0) return;
        var data = {
          selections: JSON.parse(JSON.stringify(selections)),
          curStep: curStep,
          ts: Date.now()
        };
        localStorage.setItem(KEY, JSON.stringify(data));
      } catch (e) {}
    }

    function loadSaved() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || (Date.now() - (data.ts || 0)) > MAX_AGE_MS) {
          localStorage.removeItem(KEY);
          return null;
        }
        return data;
      } catch (e) { return null; }
    }

    function clearSaved() {
      try { localStorage.removeItem(KEY); } catch (e) {}
    }

    /* Debounced save on any state-changed event + click on option buttons */
    var saveTimer;
    function debouncedSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(save, 300);
    }
    window.addEventListener('ef-cfg:state-changed', debouncedSave);
    document.addEventListener('click', function (e) {
      var target = e.target.closest('[data-field][data-value]');
      if (target && root.contains(target)) debouncedSave();
    });

    /* Clear on successful ATC — listen to cart drawer open or page nav to /cart */
    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('#efCfgATC');
      if (atcBtn) setTimeout(clearSaved, 1500); /* clear after ATC fetch settles */
    });

    /* Replay saved state — clicks each saved selection's button to re-trigger
       handlers (sets selections + surcharges + UI), then jumps to last step. */
    function restoreFrom(data) {
      if (!data || !data.selections) return;
      Object.keys(data.selections).forEach(function (field) {
        var value = data.selections[field];
        var btn = document.querySelector('[data-field="' + field + '"][data-value="' + CSS.escape(value) + '"]');
        if (btn) try { btn.click(); } catch (e) {}
      });
      if (typeof data.curStep === 'number' && data.curStep > 0) {
        setTimeout(function () { try { goToStep(data.curStep); } catch (e) {} }, 250);
      }
    }

    /* Banner UI — bronze checkmark + 2 buttons, matches store palette */
    function showResumeBanner(data) {
      var hasSelections = data.selections && Object.keys(data.selections).length > 0;
      if (!hasSelections) return;
      var banner = document.createElement('div');
      banner.className = 'ef-cfg-resume-banner';
      banner.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<polyline points="3 12 8 17 21 4"/>' +
        '</svg>' +
        '<div class="ef-cfg-resume-banner__text">' +
          '<strong>Continue where you left off?</strong>' +
          '<span>We saved your last configuration.</span>' +
        '</div>' +
        '<button type="button" class="ef-cfg-resume-banner__yes">Restore</button>' +
        '<button type="button" class="ef-cfg-resume-banner__no" aria-label="Dismiss">&times;</button>';
      var insertBefore = root.querySelector('.ef-cfg-section-header') || root.firstChild;
      if (insertBefore && insertBefore.parentNode) {
        insertBefore.parentNode.insertBefore(banner, insertBefore);
      } else {
        root.insertBefore(banner, root.firstChild);
      }
      banner.querySelector('.ef-cfg-resume-banner__yes').addEventListener('click', function () {
        restoreFrom(data);
        banner.remove();
      });
      banner.querySelector('.ef-cfg-resume-banner__no').addEventListener('click', function () {
        clearSaved();
        banner.remove();
      });
    }

    var saved = loadSaved();
    if (saved) {
      /* Show banner after a tick so initial DOM is settled */
      setTimeout(function () { showResumeBanner(saved); }, 600);
    }
  })();
})();


